var t_ = Object.defineProperty;
var n_ = (o, i, e) => i in o ? t_(o, i, { enumerable: !0, configurable: !0, writable: !0, value: e }) : o[i] = e;
var w = (o, i, e) => (n_(o, typeof i != "symbol" ? i + "" : i, e), e);
function ma(o, i) {
  return function() {
    return o.apply(i, arguments);
  };
}
const { toString: ga } = Object.prototype, { getPrototypeOf: yc } = Object, wc = ((o) => (i) => {
  const e = ga.call(i);
  return o[e] || (o[e] = e.slice(8, -1).toLowerCase());
})(/* @__PURE__ */ Object.create(null)), un = (o) => (o = o.toLowerCase(), (i) => wc(i) === o), Ws = (o) => (i) => typeof i === o, { isArray: br } = Array, Jr = Ws("undefined");
function r_(o) {
  return o !== null && !Jr(o) && o.constructor !== null && !Jr(o.constructor) && Cn(o.constructor.isBuffer) && o.constructor.isBuffer(o);
}
const da = un("ArrayBuffer");
function i_(o) {
  let i;
  return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? i = ArrayBuffer.isView(o) : i = o && o.buffer && da(o.buffer), i;
}
const s_ = Ws("string"), Cn = Ws("function"), ya = Ws("number"), _c = (o) => o !== null && typeof o == "object", o_ = (o) => o === !0 || o === !1, Qi = (o) => {
  if (wc(o) !== "object")
    return !1;
  const i = yc(o);
  return (i === null || i === Object.prototype || Object.getPrototypeOf(i) === null) && !(Symbol.toStringTag in o) && !(Symbol.iterator in o);
}, c_ = un("Date"), u_ = un("File"), l_ = un("Blob"), a_ = un("FileList"), f_ = (o) => _c(o) && Cn(o.pipe), h_ = (o) => {
  const i = "[object FormData]";
  return o && (typeof FormData == "function" && o instanceof FormData || ga.call(o) === i || Cn(o.toString) && o.toString() === i);
}, p_ = un("URLSearchParams"), m_ = (o) => o.trim ? o.trim() : o.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
function oi(o, i, { allOwnKeys: e = !1 } = {}) {
  if (o === null || typeof o > "u")
    return;
  let r, c;
  if (typeof o != "object" && (o = [o]), br(o))
    for (r = 0, c = o.length; r < c; r++)
      i.call(null, o[r], r, o);
  else {
    const l = e ? Object.getOwnPropertyNames(o) : Object.keys(o), h = l.length;
    let g;
    for (r = 0; r < h; r++)
      g = l[r], i.call(null, o[g], g, o);
  }
}
function wa(o, i) {
  i = i.toLowerCase();
  const e = Object.keys(o);
  let r = e.length, c;
  for (; r-- > 0; )
    if (c = e[r], i === c.toLowerCase())
      return c;
  return null;
}
const _a = (() => typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : global)(), Aa = (o) => !Jr(o) && o !== _a;
function ac() {
  const { caseless: o } = Aa(this) && this || {}, i = {}, e = (r, c) => {
    const l = o && wa(i, c) || c;
    Qi(i[l]) && Qi(r) ? i[l] = ac(i[l], r) : Qi(r) ? i[l] = ac({}, r) : br(r) ? i[l] = r.slice() : i[l] = r;
  };
  for (let r = 0, c = arguments.length; r < c; r++)
    arguments[r] && oi(arguments[r], e);
  return i;
}
const g_ = (o, i, e, { allOwnKeys: r } = {}) => (oi(i, (c, l) => {
  e && Cn(c) ? o[l] = ma(c, e) : o[l] = c;
}, { allOwnKeys: r }), o), d_ = (o) => (o.charCodeAt(0) === 65279 && (o = o.slice(1)), o), y_ = (o, i, e, r) => {
  o.prototype = Object.create(i.prototype, r), o.prototype.constructor = o, Object.defineProperty(o, "super", {
    value: i.prototype
  }), e && Object.assign(o.prototype, e);
}, w_ = (o, i, e, r) => {
  let c, l, h;
  const g = {};
  if (i = i || {}, o == null)
    return i;
  do {
    for (c = Object.getOwnPropertyNames(o), l = c.length; l-- > 0; )
      h = c[l], (!r || r(h, o, i)) && !g[h] && (i[h] = o[h], g[h] = !0);
    o = e !== !1 && yc(o);
  } while (o && (!e || e(o, i)) && o !== Object.prototype);
  return i;
}, __ = (o, i, e) => {
  o = String(o), (e === void 0 || e > o.length) && (e = o.length), e -= i.length;
  const r = o.indexOf(i, e);
  return r !== -1 && r === e;
}, A_ = (o) => {
  if (!o)
    return null;
  if (br(o))
    return o;
  let i = o.length;
  if (!ya(i))
    return null;
  const e = new Array(i);
  for (; i-- > 0; )
    e[i] = o[i];
  return e;
}, v_ = ((o) => (i) => o && i instanceof o)(typeof Uint8Array < "u" && yc(Uint8Array)), b_ = (o, i) => {
  const r = (o && o[Symbol.iterator]).call(o);
  let c;
  for (; (c = r.next()) && !c.done; ) {
    const l = c.value;
    i.call(o, l[0], l[1]);
  }
}, D_ = (o, i) => {
  let e;
  const r = [];
  for (; (e = o.exec(i)) !== null; )
    r.push(e);
  return r;
}, C_ = un("HTMLFormElement"), T_ = (o) => o.toLowerCase().replace(
  /[-_\s]([a-z\d])(\w*)/g,
  function(e, r, c) {
    return r.toUpperCase() + c;
  }
), ra = (({ hasOwnProperty: o }) => (i, e) => o.call(i, e))(Object.prototype), E_ = un("RegExp"), va = (o, i) => {
  const e = Object.getOwnPropertyDescriptors(o), r = {};
  oi(e, (c, l) => {
    i(c, l, o) !== !1 && (r[l] = c);
  }), Object.defineProperties(o, r);
}, x_ = (o) => {
  va(o, (i, e) => {
    if (Cn(o) && ["arguments", "caller", "callee"].indexOf(e) !== -1)
      return !1;
    const r = o[e];
    if (Cn(r)) {
      if (i.enumerable = !1, "writable" in i) {
        i.writable = !1;
        return;
      }
      i.set || (i.set = () => {
        throw Error("Can not rewrite read-only method '" + e + "'");
      });
    }
  });
}, I_ = (o, i) => {
  const e = {}, r = (c) => {
    c.forEach((l) => {
      e[l] = !0;
    });
  };
  return br(o) ? r(o) : r(String(o).split(i)), e;
}, R_ = () => {
}, P_ = (o, i) => (o = +o, Number.isFinite(o) ? o : i), oc = "abcdefghijklmnopqrstuvwxyz", ia = "0123456789", ba = {
  DIGIT: ia,
  ALPHA: oc,
  ALPHA_DIGIT: oc + oc.toUpperCase() + ia
}, N_ = (o = 16, i = ba.ALPHA_DIGIT) => {
  let e = "";
  const { length: r } = i;
  for (; o--; )
    e += i[Math.random() * r | 0];
  return e;
};
function S_(o) {
  return !!(o && Cn(o.append) && o[Symbol.toStringTag] === "FormData" && o[Symbol.iterator]);
}
const O_ = (o) => {
  const i = new Array(10), e = (r, c) => {
    if (_c(r)) {
      if (i.indexOf(r) >= 0)
        return;
      if (!("toJSON" in r)) {
        i[c] = r;
        const l = br(r) ? [] : {};
        return oi(r, (h, g) => {
          const v = e(h, c + 1);
          !Jr(v) && (l[g] = v);
        }), i[c] = void 0, l;
      }
    }
    return r;
  };
  return e(o, 0);
}, T = {
  isArray: br,
  isArrayBuffer: da,
  isBuffer: r_,
  isFormData: h_,
  isArrayBufferView: i_,
  isString: s_,
  isNumber: ya,
  isBoolean: o_,
  isObject: _c,
  isPlainObject: Qi,
  isUndefined: Jr,
  isDate: c_,
  isFile: u_,
  isBlob: l_,
  isRegExp: E_,
  isFunction: Cn,
  isStream: f_,
  isURLSearchParams: p_,
  isTypedArray: v_,
  isFileList: a_,
  forEach: oi,
  merge: ac,
  extend: g_,
  trim: m_,
  stripBOM: d_,
  inherits: y_,
  toFlatObject: w_,
  kindOf: wc,
  kindOfTest: un,
  endsWith: __,
  toArray: A_,
  forEachEntry: b_,
  matchAll: D_,
  isHTMLForm: C_,
  hasOwnProperty: ra,
  hasOwnProp: ra,
  // an alias to avoid ESLint no-prototype-builtins detection
  reduceDescriptors: va,
  freezeMethods: x_,
  toObjectSet: I_,
  toCamelCase: T_,
  noop: R_,
  toFiniteNumber: P_,
  findKey: wa,
  global: _a,
  isContextDefined: Aa,
  ALPHABET: ba,
  generateString: N_,
  isSpecCompliantForm: S_,
  toJSONObject: O_
};
function se(o, i, e, r, c) {
  Error.call(this), Error.captureStackTrace ? Error.captureStackTrace(this, this.constructor) : this.stack = new Error().stack, this.message = o, this.name = "AxiosError", i && (this.code = i), e && (this.config = e), r && (this.request = r), c && (this.response = c);
}
T.inherits(se, Error, {
  toJSON: function() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: T.toJSONObject(this.config),
      code: this.code,
      status: this.response && this.response.status ? this.response.status : null
    };
  }
});
const Da = se.prototype, Ca = {};
[
  "ERR_BAD_OPTION_VALUE",
  "ERR_BAD_OPTION",
  "ECONNABORTED",
  "ETIMEDOUT",
  "ERR_NETWORK",
  "ERR_FR_TOO_MANY_REDIRECTS",
  "ERR_DEPRECATED",
  "ERR_BAD_RESPONSE",
  "ERR_BAD_REQUEST",
  "ERR_CANCELED",
  "ERR_NOT_SUPPORT",
  "ERR_INVALID_URL"
  // eslint-disable-next-line func-names
].forEach((o) => {
  Ca[o] = { value: o };
});
Object.defineProperties(se, Ca);
Object.defineProperty(Da, "isAxiosError", { value: !0 });
se.from = (o, i, e, r, c, l) => {
  const h = Object.create(Da);
  return T.toFlatObject(o, h, function(v) {
    return v !== Error.prototype;
  }, (g) => g !== "isAxiosError"), se.call(h, o.message, i, e, r, c), h.cause = o, h.name = o.name, l && Object.assign(h, l), h;
};
const k_ = null;
function fc(o) {
  return T.isPlainObject(o) || T.isArray(o);
}
function Ta(o) {
  return T.endsWith(o, "[]") ? o.slice(0, -2) : o;
}
function sa(o, i, e) {
  return o ? o.concat(i).map(function(c, l) {
    return c = Ta(c), !e && l ? "[" + c + "]" : c;
  }).join(e ? "." : "") : i;
}
function B_(o) {
  return T.isArray(o) && !o.some(fc);
}
const L_ = T.toFlatObject(T, {}, null, function(i) {
  return /^is[A-Z]/.test(i);
});
function Hs(o, i, e) {
  if (!T.isObject(o))
    throw new TypeError("target must be an object");
  i = i || new FormData(), e = T.toFlatObject(e, {
    metaTokens: !0,
    dots: !1,
    indexes: !1
  }, !1, function(O, $) {
    return !T.isUndefined($[O]);
  });
  const r = e.metaTokens, c = e.visitor || D, l = e.dots, h = e.indexes, v = (e.Blob || typeof Blob < "u" && Blob) && T.isSpecCompliantForm(i);
  if (!T.isFunction(c))
    throw new TypeError("visitor must be a function");
  function A(R) {
    if (R === null)
      return "";
    if (T.isDate(R))
      return R.toISOString();
    if (!v && T.isBlob(R))
      throw new se("Blob is not supported. Use a Buffer instead.");
    return T.isArrayBuffer(R) || T.isTypedArray(R) ? v && typeof Blob == "function" ? new Blob([R]) : Buffer.from(R) : R;
  }
  function D(R, O, $) {
    let G = R;
    if (R && !$ && typeof R == "object") {
      if (T.endsWith(O, "{}"))
        O = r ? O : O.slice(0, -2), R = JSON.stringify(R);
      else if (T.isArray(R) && B_(R) || (T.isFileList(R) || T.endsWith(O, "[]")) && (G = T.toArray(R)))
        return O = Ta(O), G.forEach(function(Q, he) {
          !(T.isUndefined(Q) || Q === null) && i.append(
            // eslint-disable-next-line no-nested-ternary
            h === !0 ? sa([O], he, l) : h === null ? O : O + "[]",
            A(Q)
          );
        }), !1;
    }
    return fc(R) ? !0 : (i.append(sa($, O, l), A(R)), !1);
  }
  const I = [], S = Object.assign(L_, {
    defaultVisitor: D,
    convertValue: A,
    isVisitable: fc
  });
  function N(R, O) {
    if (!T.isUndefined(R)) {
      if (I.indexOf(R) !== -1)
        throw Error("Circular reference detected in " + O.join("."));
      I.push(R), T.forEach(R, function(G, ne) {
        (!(T.isUndefined(G) || G === null) && c.call(
          i,
          G,
          T.isString(ne) ? ne.trim() : ne,
          O,
          S
        )) === !0 && N(G, O ? O.concat(ne) : [ne]);
      }), I.pop();
    }
  }
  if (!T.isObject(o))
    throw new TypeError("data must be an object");
  return N(o), i;
}
function oa(o) {
  const i = {
    "!": "%21",
    "'": "%27",
    "(": "%28",
    ")": "%29",
    "~": "%7E",
    "%20": "+",
    "%00": "\0"
  };
  return encodeURIComponent(o).replace(/[!'()~]|%20|%00/g, function(r) {
    return i[r];
  });
}
function Ac(o, i) {
  this._pairs = [], o && Hs(o, this, i);
}
const Ea = Ac.prototype;
Ea.append = function(i, e) {
  this._pairs.push([i, e]);
};
Ea.toString = function(i) {
  const e = i ? function(r) {
    return i.call(this, r, oa);
  } : oa;
  return this._pairs.map(function(c) {
    return e(c[0]) + "=" + e(c[1]);
  }, "").join("&");
};
function M_(o) {
  return encodeURIComponent(o).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
function xa(o, i, e) {
  if (!i)
    return o;
  const r = e && e.encode || M_, c = e && e.serialize;
  let l;
  if (c ? l = c(i, e) : l = T.isURLSearchParams(i) ? i.toString() : new Ac(i, e).toString(r), l) {
    const h = o.indexOf("#");
    h !== -1 && (o = o.slice(0, h)), o += (o.indexOf("?") === -1 ? "?" : "&") + l;
  }
  return o;
}
class U_ {
  constructor() {
    this.handlers = [];
  }
  /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */
  use(i, e, r) {
    return this.handlers.push({
      fulfilled: i,
      rejected: e,
      synchronous: r ? r.synchronous : !1,
      runWhen: r ? r.runWhen : null
    }), this.handlers.length - 1;
  }
  /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */
  eject(i) {
    this.handlers[i] && (this.handlers[i] = null);
  }
  /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */
  clear() {
    this.handlers && (this.handlers = []);
  }
  /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */
  forEach(i) {
    T.forEach(this.handlers, function(r) {
      r !== null && i(r);
    });
  }
}
const ca = U_, Ia = {
  silentJSONParsing: !0,
  forcedJSONParsing: !0,
  clarifyTimeoutError: !1
}, F_ = typeof URLSearchParams < "u" ? URLSearchParams : Ac, $_ = typeof FormData < "u" ? FormData : null, q_ = typeof Blob < "u" ? Blob : null, W_ = (() => {
  let o;
  return typeof navigator < "u" && ((o = navigator.product) === "ReactNative" || o === "NativeScript" || o === "NS") ? !1 : typeof window < "u" && typeof document < "u";
})(), H_ = (() => typeof WorkerGlobalScope < "u" && // eslint-disable-next-line no-undef
self instanceof WorkerGlobalScope && typeof self.importScripts == "function")(), kt = {
  isBrowser: !0,
  classes: {
    URLSearchParams: F_,
    FormData: $_,
    Blob: q_
  },
  isStandardBrowserEnv: W_,
  isStandardBrowserWebWorkerEnv: H_,
  protocols: ["http", "https", "file", "blob", "url", "data"]
};
function K_(o, i) {
  return Hs(o, new kt.classes.URLSearchParams(), Object.assign({
    visitor: function(e, r, c, l) {
      return kt.isNode && T.isBuffer(e) ? (this.append(r, e.toString("base64")), !1) : l.defaultVisitor.apply(this, arguments);
    }
  }, i));
}
function V_(o) {
  return T.matchAll(/\w+|\[(\w*)]/g, o).map((i) => i[0] === "[]" ? "" : i[1] || i[0]);
}
function G_(o) {
  const i = {}, e = Object.keys(o);
  let r;
  const c = e.length;
  let l;
  for (r = 0; r < c; r++)
    l = e[r], i[l] = o[l];
  return i;
}
function Ra(o) {
  function i(e, r, c, l) {
    let h = e[l++];
    const g = Number.isFinite(+h), v = l >= e.length;
    return h = !h && T.isArray(c) ? c.length : h, v ? (T.hasOwnProp(c, h) ? c[h] = [c[h], r] : c[h] = r, !g) : ((!c[h] || !T.isObject(c[h])) && (c[h] = []), i(e, r, c[h], l) && T.isArray(c[h]) && (c[h] = G_(c[h])), !g);
  }
  if (T.isFormData(o) && T.isFunction(o.entries)) {
    const e = {};
    return T.forEachEntry(o, (r, c) => {
      i(V_(r), c, e, 0);
    }), e;
  }
  return null;
}
const j_ = {
  "Content-Type": void 0
};
function z_(o, i, e) {
  if (T.isString(o))
    try {
      return (i || JSON.parse)(o), T.trim(o);
    } catch (r) {
      if (r.name !== "SyntaxError")
        throw r;
    }
  return (e || JSON.stringify)(o);
}
const Ks = {
  transitional: Ia,
  adapter: ["xhr", "http"],
  transformRequest: [function(i, e) {
    const r = e.getContentType() || "", c = r.indexOf("application/json") > -1, l = T.isObject(i);
    if (l && T.isHTMLForm(i) && (i = new FormData(i)), T.isFormData(i))
      return c && c ? JSON.stringify(Ra(i)) : i;
    if (T.isArrayBuffer(i) || T.isBuffer(i) || T.isStream(i) || T.isFile(i) || T.isBlob(i))
      return i;
    if (T.isArrayBufferView(i))
      return i.buffer;
    if (T.isURLSearchParams(i))
      return e.setContentType("application/x-www-form-urlencoded;charset=utf-8", !1), i.toString();
    let g;
    if (l) {
      if (r.indexOf("application/x-www-form-urlencoded") > -1)
        return K_(i, this.formSerializer).toString();
      if ((g = T.isFileList(i)) || r.indexOf("multipart/form-data") > -1) {
        const v = this.env && this.env.FormData;
        return Hs(
          g ? { "files[]": i } : i,
          v && new v(),
          this.formSerializer
        );
      }
    }
    return l || c ? (e.setContentType("application/json", !1), z_(i)) : i;
  }],
  transformResponse: [function(i) {
    const e = this.transitional || Ks.transitional, r = e && e.forcedJSONParsing, c = this.responseType === "json";
    if (i && T.isString(i) && (r && !this.responseType || c)) {
      const h = !(e && e.silentJSONParsing) && c;
      try {
        return JSON.parse(i);
      } catch (g) {
        if (h)
          throw g.name === "SyntaxError" ? se.from(g, se.ERR_BAD_RESPONSE, this, null, this.response) : g;
      }
    }
    return i;
  }],
  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  env: {
    FormData: kt.classes.FormData,
    Blob: kt.classes.Blob
  },
  validateStatus: function(i) {
    return i >= 200 && i < 300;
  },
  headers: {
    common: {
      Accept: "application/json, text/plain, */*"
    }
  }
};
T.forEach(["delete", "get", "head"], function(i) {
  Ks.headers[i] = {};
});
T.forEach(["post", "put", "patch"], function(i) {
  Ks.headers[i] = T.merge(j_);
});
const vc = Ks, Y_ = T.toObjectSet([
  "age",
  "authorization",
  "content-length",
  "content-type",
  "etag",
  "expires",
  "from",
  "host",
  "if-modified-since",
  "if-unmodified-since",
  "last-modified",
  "location",
  "max-forwards",
  "proxy-authorization",
  "referer",
  "retry-after",
  "user-agent"
]), J_ = (o) => {
  const i = {};
  let e, r, c;
  return o && o.split(`
`).forEach(function(h) {
    c = h.indexOf(":"), e = h.substring(0, c).trim().toLowerCase(), r = h.substring(c + 1).trim(), !(!e || i[e] && Y_[e]) && (e === "set-cookie" ? i[e] ? i[e].push(r) : i[e] = [r] : i[e] = i[e] ? i[e] + ", " + r : r);
  }), i;
}, ua = Symbol("internals");
function Kr(o) {
  return o && String(o).trim().toLowerCase();
}
function es(o) {
  return o === !1 || o == null ? o : T.isArray(o) ? o.map(es) : String(o);
}
function Z_(o) {
  const i = /* @__PURE__ */ Object.create(null), e = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
  let r;
  for (; r = e.exec(o); )
    i[r[1]] = r[2];
  return i;
}
function X_(o) {
  return /^[-_a-zA-Z]+$/.test(o.trim());
}
function cc(o, i, e, r, c) {
  if (T.isFunction(r))
    return r.call(this, i, e);
  if (c && (i = e), !!T.isString(i)) {
    if (T.isString(r))
      return i.indexOf(r) !== -1;
    if (T.isRegExp(r))
      return r.test(i);
  }
}
function Q_(o) {
  return o.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (i, e, r) => e.toUpperCase() + r);
}
function eA(o, i) {
  const e = T.toCamelCase(" " + i);
  ["get", "set", "has"].forEach((r) => {
    Object.defineProperty(o, r + e, {
      value: function(c, l, h) {
        return this[r].call(this, i, c, l, h);
      },
      configurable: !0
    });
  });
}
class Vs {
  constructor(i) {
    i && this.set(i);
  }
  set(i, e, r) {
    const c = this;
    function l(g, v, A) {
      const D = Kr(v);
      if (!D)
        throw new Error("header name must be a non-empty string");
      const I = T.findKey(c, D);
      (!I || c[I] === void 0 || A === !0 || A === void 0 && c[I] !== !1) && (c[I || v] = es(g));
    }
    const h = (g, v) => T.forEach(g, (A, D) => l(A, D, v));
    return T.isPlainObject(i) || i instanceof this.constructor ? h(i, e) : T.isString(i) && (i = i.trim()) && !X_(i) ? h(J_(i), e) : i != null && l(e, i, r), this;
  }
  get(i, e) {
    if (i = Kr(i), i) {
      const r = T.findKey(this, i);
      if (r) {
        const c = this[r];
        if (!e)
          return c;
        if (e === !0)
          return Z_(c);
        if (T.isFunction(e))
          return e.call(this, c, r);
        if (T.isRegExp(e))
          return e.exec(c);
        throw new TypeError("parser must be boolean|regexp|function");
      }
    }
  }
  has(i, e) {
    if (i = Kr(i), i) {
      const r = T.findKey(this, i);
      return !!(r && this[r] !== void 0 && (!e || cc(this, this[r], r, e)));
    }
    return !1;
  }
  delete(i, e) {
    const r = this;
    let c = !1;
    function l(h) {
      if (h = Kr(h), h) {
        const g = T.findKey(r, h);
        g && (!e || cc(r, r[g], g, e)) && (delete r[g], c = !0);
      }
    }
    return T.isArray(i) ? i.forEach(l) : l(i), c;
  }
  clear(i) {
    const e = Object.keys(this);
    let r = e.length, c = !1;
    for (; r--; ) {
      const l = e[r];
      (!i || cc(this, this[l], l, i, !0)) && (delete this[l], c = !0);
    }
    return c;
  }
  normalize(i) {
    const e = this, r = {};
    return T.forEach(this, (c, l) => {
      const h = T.findKey(r, l);
      if (h) {
        e[h] = es(c), delete e[l];
        return;
      }
      const g = i ? Q_(l) : String(l).trim();
      g !== l && delete e[l], e[g] = es(c), r[g] = !0;
    }), this;
  }
  concat(...i) {
    return this.constructor.concat(this, ...i);
  }
  toJSON(i) {
    const e = /* @__PURE__ */ Object.create(null);
    return T.forEach(this, (r, c) => {
      r != null && r !== !1 && (e[c] = i && T.isArray(r) ? r.join(", ") : r);
    }), e;
  }
  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }
  toString() {
    return Object.entries(this.toJSON()).map(([i, e]) => i + ": " + e).join(`
`);
  }
  get [Symbol.toStringTag]() {
    return "AxiosHeaders";
  }
  static from(i) {
    return i instanceof this ? i : new this(i);
  }
  static concat(i, ...e) {
    const r = new this(i);
    return e.forEach((c) => r.set(c)), r;
  }
  static accessor(i) {
    const r = (this[ua] = this[ua] = {
      accessors: {}
    }).accessors, c = this.prototype;
    function l(h) {
      const g = Kr(h);
      r[g] || (eA(c, h), r[g] = !0);
    }
    return T.isArray(i) ? i.forEach(l) : l(i), this;
  }
}
Vs.accessor(["Content-Type", "Content-Length", "Accept", "Accept-Encoding", "User-Agent", "Authorization"]);
T.freezeMethods(Vs.prototype);
T.freezeMethods(Vs);
const on = Vs;
function uc(o, i) {
  const e = this || vc, r = i || e, c = on.from(r.headers);
  let l = r.data;
  return T.forEach(o, function(g) {
    l = g.call(e, l, c.normalize(), i ? i.status : void 0);
  }), c.normalize(), l;
}
function Pa(o) {
  return !!(o && o.__CANCEL__);
}
function ci(o, i, e) {
  se.call(this, o ?? "canceled", se.ERR_CANCELED, i, e), this.name = "CanceledError";
}
T.inherits(ci, se, {
  __CANCEL__: !0
});
function tA(o, i, e) {
  const r = e.config.validateStatus;
  !e.status || !r || r(e.status) ? o(e) : i(new se(
    "Request failed with status code " + e.status,
    [se.ERR_BAD_REQUEST, se.ERR_BAD_RESPONSE][Math.floor(e.status / 100) - 4],
    e.config,
    e.request,
    e
  ));
}
const nA = kt.isStandardBrowserEnv ? (
  // Standard browser envs support document.cookie
  function() {
    return {
      write: function(e, r, c, l, h, g) {
        const v = [];
        v.push(e + "=" + encodeURIComponent(r)), T.isNumber(c) && v.push("expires=" + new Date(c).toGMTString()), T.isString(l) && v.push("path=" + l), T.isString(h) && v.push("domain=" + h), g === !0 && v.push("secure"), document.cookie = v.join("; ");
      },
      read: function(e) {
        const r = document.cookie.match(new RegExp("(^|;\\s*)(" + e + ")=([^;]*)"));
        return r ? decodeURIComponent(r[3]) : null;
      },
      remove: function(e) {
        this.write(e, "", Date.now() - 864e5);
      }
    };
  }()
) : (
  // Non standard browser env (web workers, react-native) lack needed support.
  function() {
    return {
      write: function() {
      },
      read: function() {
        return null;
      },
      remove: function() {
      }
    };
  }()
);
function rA(o) {
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(o);
}
function iA(o, i) {
  return i ? o.replace(/\/+$/, "") + "/" + i.replace(/^\/+/, "") : o;
}
function Na(o, i) {
  return o && !rA(i) ? iA(o, i) : i;
}
const sA = kt.isStandardBrowserEnv ? (
  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
  function() {
    const i = /(msie|trident)/i.test(navigator.userAgent), e = document.createElement("a");
    let r;
    function c(l) {
      let h = l;
      return i && (e.setAttribute("href", h), h = e.href), e.setAttribute("href", h), {
        href: e.href,
        protocol: e.protocol ? e.protocol.replace(/:$/, "") : "",
        host: e.host,
        search: e.search ? e.search.replace(/^\?/, "") : "",
        hash: e.hash ? e.hash.replace(/^#/, "") : "",
        hostname: e.hostname,
        port: e.port,
        pathname: e.pathname.charAt(0) === "/" ? e.pathname : "/" + e.pathname
      };
    }
    return r = c(window.location.href), function(h) {
      const g = T.isString(h) ? c(h) : h;
      return g.protocol === r.protocol && g.host === r.host;
    };
  }()
) : (
  // Non standard browser envs (web workers, react-native) lack needed support.
  function() {
    return function() {
      return !0;
    };
  }()
);
function oA(o) {
  const i = /^([-+\w]{1,25})(:?\/\/|:)/.exec(o);
  return i && i[1] || "";
}
function cA(o, i) {
  o = o || 10;
  const e = new Array(o), r = new Array(o);
  let c = 0, l = 0, h;
  return i = i !== void 0 ? i : 1e3, function(v) {
    const A = Date.now(), D = r[l];
    h || (h = A), e[c] = v, r[c] = A;
    let I = l, S = 0;
    for (; I !== c; )
      S += e[I++], I = I % o;
    if (c = (c + 1) % o, c === l && (l = (l + 1) % o), A - h < i)
      return;
    const N = D && A - D;
    return N ? Math.round(S * 1e3 / N) : void 0;
  };
}
function la(o, i) {
  let e = 0;
  const r = cA(50, 250);
  return (c) => {
    const l = c.loaded, h = c.lengthComputable ? c.total : void 0, g = l - e, v = r(g), A = l <= h;
    e = l;
    const D = {
      loaded: l,
      total: h,
      progress: h ? l / h : void 0,
      bytes: g,
      rate: v || void 0,
      estimated: v && h && A ? (h - l) / v : void 0,
      event: c
    };
    D[i ? "download" : "upload"] = !0, o(D);
  };
}
const uA = typeof XMLHttpRequest < "u", lA = uA && function(o) {
  return new Promise(function(e, r) {
    let c = o.data;
    const l = on.from(o.headers).normalize(), h = o.responseType;
    let g;
    function v() {
      o.cancelToken && o.cancelToken.unsubscribe(g), o.signal && o.signal.removeEventListener("abort", g);
    }
    T.isFormData(c) && (kt.isStandardBrowserEnv || kt.isStandardBrowserWebWorkerEnv) && l.setContentType(!1);
    let A = new XMLHttpRequest();
    if (o.auth) {
      const N = o.auth.username || "", R = o.auth.password ? unescape(encodeURIComponent(o.auth.password)) : "";
      l.set("Authorization", "Basic " + btoa(N + ":" + R));
    }
    const D = Na(o.baseURL, o.url);
    A.open(o.method.toUpperCase(), xa(D, o.params, o.paramsSerializer), !0), A.timeout = o.timeout;
    function I() {
      if (!A)
        return;
      const N = on.from(
        "getAllResponseHeaders" in A && A.getAllResponseHeaders()
      ), O = {
        data: !h || h === "text" || h === "json" ? A.responseText : A.response,
        status: A.status,
        statusText: A.statusText,
        headers: N,
        config: o,
        request: A
      };
      tA(function(G) {
        e(G), v();
      }, function(G) {
        r(G), v();
      }, O), A = null;
    }
    if ("onloadend" in A ? A.onloadend = I : A.onreadystatechange = function() {
      !A || A.readyState !== 4 || A.status === 0 && !(A.responseURL && A.responseURL.indexOf("file:") === 0) || setTimeout(I);
    }, A.onabort = function() {
      A && (r(new se("Request aborted", se.ECONNABORTED, o, A)), A = null);
    }, A.onerror = function() {
      r(new se("Network Error", se.ERR_NETWORK, o, A)), A = null;
    }, A.ontimeout = function() {
      let R = o.timeout ? "timeout of " + o.timeout + "ms exceeded" : "timeout exceeded";
      const O = o.transitional || Ia;
      o.timeoutErrorMessage && (R = o.timeoutErrorMessage), r(new se(
        R,
        O.clarifyTimeoutError ? se.ETIMEDOUT : se.ECONNABORTED,
        o,
        A
      )), A = null;
    }, kt.isStandardBrowserEnv) {
      const N = (o.withCredentials || sA(D)) && o.xsrfCookieName && nA.read(o.xsrfCookieName);
      N && l.set(o.xsrfHeaderName, N);
    }
    c === void 0 && l.setContentType(null), "setRequestHeader" in A && T.forEach(l.toJSON(), function(R, O) {
      A.setRequestHeader(O, R);
    }), T.isUndefined(o.withCredentials) || (A.withCredentials = !!o.withCredentials), h && h !== "json" && (A.responseType = o.responseType), typeof o.onDownloadProgress == "function" && A.addEventListener("progress", la(o.onDownloadProgress, !0)), typeof o.onUploadProgress == "function" && A.upload && A.upload.addEventListener("progress", la(o.onUploadProgress)), (o.cancelToken || o.signal) && (g = (N) => {
      A && (r(!N || N.type ? new ci(null, o, A) : N), A.abort(), A = null);
    }, o.cancelToken && o.cancelToken.subscribe(g), o.signal && (o.signal.aborted ? g() : o.signal.addEventListener("abort", g)));
    const S = oA(D);
    if (S && kt.protocols.indexOf(S) === -1) {
      r(new se("Unsupported protocol " + S + ":", se.ERR_BAD_REQUEST, o));
      return;
    }
    A.send(c || null);
  });
}, ts = {
  http: k_,
  xhr: lA
};
T.forEach(ts, (o, i) => {
  if (o) {
    try {
      Object.defineProperty(o, "name", { value: i });
    } catch {
    }
    Object.defineProperty(o, "adapterName", { value: i });
  }
});
const aA = {
  getAdapter: (o) => {
    o = T.isArray(o) ? o : [o];
    const { length: i } = o;
    let e, r;
    for (let c = 0; c < i && (e = o[c], !(r = T.isString(e) ? ts[e.toLowerCase()] : e)); c++)
      ;
    if (!r)
      throw r === !1 ? new se(
        `Adapter ${e} is not supported by the environment`,
        "ERR_NOT_SUPPORT"
      ) : new Error(
        T.hasOwnProp(ts, e) ? `Adapter '${e}' is not available in the build` : `Unknown adapter '${e}'`
      );
    if (!T.isFunction(r))
      throw new TypeError("adapter is not a function");
    return r;
  },
  adapters: ts
};
function lc(o) {
  if (o.cancelToken && o.cancelToken.throwIfRequested(), o.signal && o.signal.aborted)
    throw new ci(null, o);
}
function aa(o) {
  return lc(o), o.headers = on.from(o.headers), o.data = uc.call(
    o,
    o.transformRequest
  ), ["post", "put", "patch"].indexOf(o.method) !== -1 && o.headers.setContentType("application/x-www-form-urlencoded", !1), aA.getAdapter(o.adapter || vc.adapter)(o).then(function(r) {
    return lc(o), r.data = uc.call(
      o,
      o.transformResponse,
      r
    ), r.headers = on.from(r.headers), r;
  }, function(r) {
    return Pa(r) || (lc(o), r && r.response && (r.response.data = uc.call(
      o,
      o.transformResponse,
      r.response
    ), r.response.headers = on.from(r.response.headers))), Promise.reject(r);
  });
}
const fa = (o) => o instanceof on ? o.toJSON() : o;
function wr(o, i) {
  i = i || {};
  const e = {};
  function r(A, D, I) {
    return T.isPlainObject(A) && T.isPlainObject(D) ? T.merge.call({ caseless: I }, A, D) : T.isPlainObject(D) ? T.merge({}, D) : T.isArray(D) ? D.slice() : D;
  }
  function c(A, D, I) {
    if (T.isUndefined(D)) {
      if (!T.isUndefined(A))
        return r(void 0, A, I);
    } else
      return r(A, D, I);
  }
  function l(A, D) {
    if (!T.isUndefined(D))
      return r(void 0, D);
  }
  function h(A, D) {
    if (T.isUndefined(D)) {
      if (!T.isUndefined(A))
        return r(void 0, A);
    } else
      return r(void 0, D);
  }
  function g(A, D, I) {
    if (I in i)
      return r(A, D);
    if (I in o)
      return r(void 0, A);
  }
  const v = {
    url: l,
    method: l,
    data: l,
    baseURL: h,
    transformRequest: h,
    transformResponse: h,
    paramsSerializer: h,
    timeout: h,
    timeoutMessage: h,
    withCredentials: h,
    adapter: h,
    responseType: h,
    xsrfCookieName: h,
    xsrfHeaderName: h,
    onUploadProgress: h,
    onDownloadProgress: h,
    decompress: h,
    maxContentLength: h,
    maxBodyLength: h,
    beforeRedirect: h,
    transport: h,
    httpAgent: h,
    httpsAgent: h,
    cancelToken: h,
    socketPath: h,
    responseEncoding: h,
    validateStatus: g,
    headers: (A, D) => c(fa(A), fa(D), !0)
  };
  return T.forEach(Object.keys(o).concat(Object.keys(i)), function(D) {
    const I = v[D] || c, S = I(o[D], i[D], D);
    T.isUndefined(S) && I !== g || (e[D] = S);
  }), e;
}
const Sa = "1.3.4", bc = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach((o, i) => {
  bc[o] = function(r) {
    return typeof r === o || "a" + (i < 1 ? "n " : " ") + o;
  };
});
const ha = {};
bc.transitional = function(i, e, r) {
  function c(l, h) {
    return "[Axios v" + Sa + "] Transitional option '" + l + "'" + h + (r ? ". " + r : "");
  }
  return (l, h, g) => {
    if (i === !1)
      throw new se(
        c(h, " has been removed" + (e ? " in " + e : "")),
        se.ERR_DEPRECATED
      );
    return e && !ha[h] && (ha[h] = !0, console.warn(
      c(
        h,
        " has been deprecated since v" + e + " and will be removed in the near future"
      )
    )), i ? i(l, h, g) : !0;
  };
};
function fA(o, i, e) {
  if (typeof o != "object")
    throw new se("options must be an object", se.ERR_BAD_OPTION_VALUE);
  const r = Object.keys(o);
  let c = r.length;
  for (; c-- > 0; ) {
    const l = r[c], h = i[l];
    if (h) {
      const g = o[l], v = g === void 0 || h(g, l, o);
      if (v !== !0)
        throw new se("option " + l + " must be " + v, se.ERR_BAD_OPTION_VALUE);
      continue;
    }
    if (e !== !0)
      throw new se("Unknown option " + l, se.ERR_BAD_OPTION);
  }
}
const hc = {
  assertOptions: fA,
  validators: bc
}, bn = hc.validators;
class rs {
  constructor(i) {
    this.defaults = i, this.interceptors = {
      request: new ca(),
      response: new ca()
    };
  }
  /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */
  request(i, e) {
    typeof i == "string" ? (e = e || {}, e.url = i) : e = i || {}, e = wr(this.defaults, e);
    const { transitional: r, paramsSerializer: c, headers: l } = e;
    r !== void 0 && hc.assertOptions(r, {
      silentJSONParsing: bn.transitional(bn.boolean),
      forcedJSONParsing: bn.transitional(bn.boolean),
      clarifyTimeoutError: bn.transitional(bn.boolean)
    }, !1), c !== void 0 && hc.assertOptions(c, {
      encode: bn.function,
      serialize: bn.function
    }, !0), e.method = (e.method || this.defaults.method || "get").toLowerCase();
    let h;
    h = l && T.merge(
      l.common,
      l[e.method]
    ), h && T.forEach(
      ["delete", "get", "head", "post", "put", "patch", "common"],
      (R) => {
        delete l[R];
      }
    ), e.headers = on.concat(h, l);
    const g = [];
    let v = !0;
    this.interceptors.request.forEach(function(O) {
      typeof O.runWhen == "function" && O.runWhen(e) === !1 || (v = v && O.synchronous, g.unshift(O.fulfilled, O.rejected));
    });
    const A = [];
    this.interceptors.response.forEach(function(O) {
      A.push(O.fulfilled, O.rejected);
    });
    let D, I = 0, S;
    if (!v) {
      const R = [aa.bind(this), void 0];
      for (R.unshift.apply(R, g), R.push.apply(R, A), S = R.length, D = Promise.resolve(e); I < S; )
        D = D.then(R[I++], R[I++]);
      return D;
    }
    S = g.length;
    let N = e;
    for (I = 0; I < S; ) {
      const R = g[I++], O = g[I++];
      try {
        N = R(N);
      } catch ($) {
        O.call(this, $);
        break;
      }
    }
    try {
      D = aa.call(this, N);
    } catch (R) {
      return Promise.reject(R);
    }
    for (I = 0, S = A.length; I < S; )
      D = D.then(A[I++], A[I++]);
    return D;
  }
  getUri(i) {
    i = wr(this.defaults, i);
    const e = Na(i.baseURL, i.url);
    return xa(e, i.params, i.paramsSerializer);
  }
}
T.forEach(["delete", "get", "head", "options"], function(i) {
  rs.prototype[i] = function(e, r) {
    return this.request(wr(r || {}, {
      method: i,
      url: e,
      data: (r || {}).data
    }));
  };
});
T.forEach(["post", "put", "patch"], function(i) {
  function e(r) {
    return function(l, h, g) {
      return this.request(wr(g || {}, {
        method: i,
        headers: r ? {
          "Content-Type": "multipart/form-data"
        } : {},
        url: l,
        data: h
      }));
    };
  }
  rs.prototype[i] = e(), rs.prototype[i + "Form"] = e(!0);
});
const ns = rs;
class Dc {
  constructor(i) {
    if (typeof i != "function")
      throw new TypeError("executor must be a function.");
    let e;
    this.promise = new Promise(function(l) {
      e = l;
    });
    const r = this;
    this.promise.then((c) => {
      if (!r._listeners)
        return;
      let l = r._listeners.length;
      for (; l-- > 0; )
        r._listeners[l](c);
      r._listeners = null;
    }), this.promise.then = (c) => {
      let l;
      const h = new Promise((g) => {
        r.subscribe(g), l = g;
      }).then(c);
      return h.cancel = function() {
        r.unsubscribe(l);
      }, h;
    }, i(function(l, h, g) {
      r.reason || (r.reason = new ci(l, h, g), e(r.reason));
    });
  }
  /**
   * Throws a `CanceledError` if cancellation has been requested.
   */
  throwIfRequested() {
    if (this.reason)
      throw this.reason;
  }
  /**
   * Subscribe to the cancel signal
   */
  subscribe(i) {
    if (this.reason) {
      i(this.reason);
      return;
    }
    this._listeners ? this._listeners.push(i) : this._listeners = [i];
  }
  /**
   * Unsubscribe from the cancel signal
   */
  unsubscribe(i) {
    if (!this._listeners)
      return;
    const e = this._listeners.indexOf(i);
    e !== -1 && this._listeners.splice(e, 1);
  }
  /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */
  static source() {
    let i;
    return {
      token: new Dc(function(c) {
        i = c;
      }),
      cancel: i
    };
  }
}
const hA = Dc;
function pA(o) {
  return function(e) {
    return o.apply(null, e);
  };
}
function mA(o) {
  return T.isObject(o) && o.isAxiosError === !0;
}
const pc = {
  Continue: 100,
  SwitchingProtocols: 101,
  Processing: 102,
  EarlyHints: 103,
  Ok: 200,
  Created: 201,
  Accepted: 202,
  NonAuthoritativeInformation: 203,
  NoContent: 204,
  ResetContent: 205,
  PartialContent: 206,
  MultiStatus: 207,
  AlreadyReported: 208,
  ImUsed: 226,
  MultipleChoices: 300,
  MovedPermanently: 301,
  Found: 302,
  SeeOther: 303,
  NotModified: 304,
  UseProxy: 305,
  Unused: 306,
  TemporaryRedirect: 307,
  PermanentRedirect: 308,
  BadRequest: 400,
  Unauthorized: 401,
  PaymentRequired: 402,
  Forbidden: 403,
  NotFound: 404,
  MethodNotAllowed: 405,
  NotAcceptable: 406,
  ProxyAuthenticationRequired: 407,
  RequestTimeout: 408,
  Conflict: 409,
  Gone: 410,
  LengthRequired: 411,
  PreconditionFailed: 412,
  PayloadTooLarge: 413,
  UriTooLong: 414,
  UnsupportedMediaType: 415,
  RangeNotSatisfiable: 416,
  ExpectationFailed: 417,
  ImATeapot: 418,
  MisdirectedRequest: 421,
  UnprocessableEntity: 422,
  Locked: 423,
  FailedDependency: 424,
  TooEarly: 425,
  UpgradeRequired: 426,
  PreconditionRequired: 428,
  TooManyRequests: 429,
  RequestHeaderFieldsTooLarge: 431,
  UnavailableForLegalReasons: 451,
  InternalServerError: 500,
  NotImplemented: 501,
  BadGateway: 502,
  ServiceUnavailable: 503,
  GatewayTimeout: 504,
  HttpVersionNotSupported: 505,
  VariantAlsoNegotiates: 506,
  InsufficientStorage: 507,
  LoopDetected: 508,
  NotExtended: 510,
  NetworkAuthenticationRequired: 511
};
Object.entries(pc).forEach(([o, i]) => {
  pc[i] = o;
});
const gA = pc;
function Oa(o) {
  const i = new ns(o), e = ma(ns.prototype.request, i);
  return T.extend(e, ns.prototype, i, { allOwnKeys: !0 }), T.extend(e, i, null, { allOwnKeys: !0 }), e.create = function(c) {
    return Oa(wr(o, c));
  }, e;
}
const Te = Oa(vc);
Te.Axios = ns;
Te.CanceledError = ci;
Te.CancelToken = hA;
Te.isCancel = Pa;
Te.VERSION = Sa;
Te.toFormData = Hs;
Te.AxiosError = se;
Te.Cancel = Te.CanceledError;
Te.all = function(i) {
  return Promise.all(i);
};
Te.spread = pA;
Te.isAxiosError = mA;
Te.mergeConfig = wr;
Te.AxiosHeaders = on;
Te.formToJSON = (o) => Ra(T.isHTMLForm(o) ? new FormData(o) : o);
Te.HttpStatusCode = gA;
Te.default = Te;
const dA = Te;
new TextEncoder();
const ka = new TextDecoder(), yA = (o) => {
  const i = atob(o), e = new Uint8Array(i.length);
  for (let r = 0; r < i.length; r++)
    e[r] = i.charCodeAt(r);
  return e;
}, wA = (o) => {
  let i = o;
  i instanceof Uint8Array && (i = ka.decode(i)), i = i.replace(/-/g, "+").replace(/_/g, "/").replace(/\s/g, "");
  try {
    return yA(i);
  } catch {
    throw new TypeError("The input to be decoded is not correctly encoded.");
  }
};
class _A extends Error {
  static get code() {
    return "ERR_JOSE_GENERIC";
  }
  constructor(i) {
    var e;
    super(i), this.code = "ERR_JOSE_GENERIC", this.name = this.constructor.name, (e = Error.captureStackTrace) === null || e === void 0 || e.call(Error, this, this.constructor);
  }
}
class Gn extends _A {
  constructor() {
    super(...arguments), this.code = "ERR_JWT_INVALID";
  }
  static get code() {
    return "ERR_JWT_INVALID";
  }
}
function AA(o) {
  return typeof o == "object" && o !== null;
}
function vA(o) {
  if (!AA(o) || Object.prototype.toString.call(o) !== "[object Object]")
    return !1;
  if (Object.getPrototypeOf(o) === null)
    return !0;
  let i = o;
  for (; Object.getPrototypeOf(i) !== null; )
    i = Object.getPrototypeOf(i);
  return Object.getPrototypeOf(o) === i;
}
const bA = wA;
function DA(o) {
  if (typeof o != "string")
    throw new Gn("JWTs must use Compact JWS serialization, JWT must be a string");
  const { 1: i, length: e } = o.split(".");
  if (e === 5)
    throw new Gn("Only JWTs using Compact JWS serialization can be decoded");
  if (e !== 3)
    throw new Gn("Invalid JWT");
  if (!i)
    throw new Gn("JWTs must contain a payload");
  let r;
  try {
    r = bA(i);
  } catch {
    throw new Gn("Failed to base64url decode the payload");
  }
  let c;
  try {
    c = JSON.parse(ka.decode(r));
  } catch {
    throw new Gn("Failed to parse the decoded payload as JSON");
  }
  if (!vA(c))
    throw new Gn("Invalid JWT Claims Set");
  return c;
}
const Be = localStorage || sessionStorage;
class Cc {
  constructor() {
    w(this, "client");
    w(this, "basePath");
    w(this, "retryAttempts", 0);
    this.client = dA.create({
      headers: {
        "Content-Type": "application/ld+json"
      }
    }), this.client.interceptors.request.use((i) => this.onRequest(i)), this.client.interceptors.response.use(void 0, (i) => this.onError(i));
  }
  configure(i) {
    this.basePath = i.basePath || "", this.client.defaults.baseURL = i.baseURL, i.accessToken && (this.accessToken = i.accessToken), i.refreshToken && (this.refreshToken = i.refreshToken);
  }
  onRequest(i) {
    return this.accessToken && i.headers && (i.headers.Authorization = `Bearer ${this.accessToken}`), i;
  }
  async onError(i) {
    if (i.response === void 0)
      throw console.error(i), Error("Er kon geen verbinding gemaakt worden met de server. Probeer het later nogmaals of neem contact met ons op: marketing@winck.nl");
    if (i.response.status === 401) {
      if (this.retryAttempts >= 10)
        return;
      if (this.retryAttempts++, this.refreshToken) {
        await this.doRefreshToken();
        const e = i.config;
        return e ? (e.headers.Authorization = `Bearer ${this.accessToken}`, Promise.resolve(this.client(e))) : Promise.reject(i);
      }
    }
    return Promise.reject(i);
  }
  async doRefreshToken() {
    try {
      const i = await this.client.post("/refresh_token", {
        refresh_token: this.refreshToken
      });
      i.status === 200 && (this.accessToken = i.data.token, this.refreshToken = i.data.refresh_token);
    } catch (i) {
      throw i;
    }
  }
  async login(i, e) {
    const r = await this.client.post("/authentication_token", {
      email: i,
      password: e
    });
    Be && (Be.setItem("access_token", r.data.token), Be.setItem("refresh_token", r.data.refresh_token));
  }
  async logout() {
    Be && (Be.removeItem("access_token"), Be.removeItem("refresh_token"));
  }
  get companyId() {
    var i;
    return ((i = this.decodedAccessToken) == null ? void 0 : i.companyId) ?? null;
  }
  get isAuthenticated() {
    return !!this.accessToken;
  }
  get accessToken() {
    return (Be == null ? void 0 : Be.getItem("access_token")) || "";
  }
  set accessToken(i) {
    Be && Be.setItem("access_token", i);
  }
  get refreshToken() {
    return (Be == null ? void 0 : Be.getItem("refresh_token")) || "";
  }
  set refreshToken(i) {
    Be && Be.setItem("refresh_token", i);
  }
  get decodedAccessToken() {
    return this.accessToken ? DA(this.accessToken) : null;
  }
  get axiosClient() {
    return this.client;
  }
  async wait(i = 2) {
    return new Promise((e) => setTimeout(e, i * 1e3));
  }
}
class V extends Cc {
  constructor() {
    super(...arguments);
    w(this, "collectionName");
    w(this, "parseData");
    w(this, "cache", /* @__PURE__ */ new Map());
  }
  async get(e, r = !1) {
    if (!r && this.cache.has(e))
      return this.cache.get(e);
    const c = await this.client.get(`${this.basePath}/${this.collectionName}/${e}`), l = this.parseData(c.data);
    return this.cache.set(e, l), this.cache.get(e);
  }
  async getAll(e = {}) {
    return (await this.client.get(`${this.basePath}/${this.collectionName}`, {
      params: e
    })).data["hydra:member"].map((l) => this.parseData(l));
  }
  async getPaged(e) {
    const r = await this.client.get(`${this.basePath}/${this.collectionName}`, {
      params: e
    }), c = r.data["hydra:totalItems"], l = Math.ceil(c / (e.itemsPerPage || 10));
    return {
      collection: r.data["hydra:member"].map((g) => this.parseData(g)),
      totalItems: c,
      totalPages: l
    };
  }
  async create(e) {
    return await this.client.post(`${this.basePath}/${this.collectionName}`, e), await this.wait(), await this.get(e.id, !0);
  }
  async update(e, r) {
    return await this.client.put(`${this.basePath}/${this.collectionName}/${e}`, r), await this.wait(), await this.get(e, !0);
  }
  async delete(e) {
    await this.client.delete(`${this.basePath}/${this.collectionName}/${e}`), await this.wait();
  }
}
var Vr = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {}, is = { exports: {} };
/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
is.exports;
(function(o, i) {
  (function() {
    var e, r = "4.17.21", c = 200, l = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", h = "Expected a function", g = "Invalid `variable` option passed into `_.template`", v = "__lodash_hash_undefined__", A = 500, D = "__lodash_placeholder__", I = 1, S = 2, N = 4, R = 1, O = 2, $ = 1, G = 2, ne = 4, Q = 8, he = 16, le = 32, ge = 64, ae = 128, ye = 256, be = 512, Le = 30, Me = "...", et = 800, tt = 16, Ge = 1, Mt = 2, Ut = 3, Ue = 1 / 0, Se = 9007199254740991, Ft = 17976931348623157e292, at = 0 / 0, Ee = 4294967295, $t = Ee - 1, qt = Ee >>> 1, Wt = [
      ["ary", ae],
      ["bind", $],
      ["bindKey", G],
      ["curry", Q],
      ["curryRight", he],
      ["flip", be],
      ["partial", le],
      ["partialRight", ge],
      ["rearg", ye]
    ], je = "[object Arguments]", ft = "[object Array]", Ht = "[object AsyncFunction]", nt = "[object Boolean]", rt = "[object Date]", Kt = "[object DOMException]", ht = "[object Error]", It = "[object Function]", an = "[object GeneratorFunction]", Ie = "[object Map]", vt = "[object Number]", xn = "[object Null]", Fe = "[object Object]", fn = "[object Promise]", Dr = "[object Proxy]", Vt = "[object RegExp]", $e = "[object Set]", Gt = "[object String]", hn = "[object Symbol]", Cr = "[object Undefined]", jt = "[object WeakMap]", Tr = "[object WeakSet]", zt = "[object ArrayBuffer]", Rt = "[object DataView]", In = "[object Float32Array]", Rn = "[object Float64Array]", Pn = "[object Int8Array]", Nn = "[object Int16Array]", Sn = "[object Int32Array]", On = "[object Uint8Array]", kn = "[object Uint8ClampedArray]", Bn = "[object Uint16Array]", Ln = "[object Uint32Array]", Er = /\b__p \+= '';/g, xr = /\b(__p \+=) '' \+/g, Ir = /(__e\(.*?\)|\b__t\)) \+\n'';/g, er = /&(?:amp|lt|gt|quot|#39);/g, li = /[&<>"']/g, Gs = RegExp(er.source), Ef = RegExp(li.source), xf = /<%-([\s\S]+?)%>/g, If = /<%([\s\S]+?)%>/g, Pc = /<%=([\s\S]+?)%>/g, Rf = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, Pf = /^\w*$/, Nf = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, js = /[\\^$.*+?()[\]{}|]/g, Sf = RegExp(js.source), zs = /^\s+/, Of = /\s/, kf = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, Bf = /\{\n\/\* \[wrapped with (.+)\] \*/, Lf = /,? & /, Mf = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g, Uf = /[()=,{}\[\]\/\s]/, Ff = /\\(\\)?/g, $f = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g, Nc = /\w*$/, qf = /^[-+]0x[0-9a-f]+$/i, Wf = /^0b[01]+$/i, Hf = /^\[object .+?Constructor\]$/, Kf = /^0o[0-7]+$/i, Vf = /^(?:0|[1-9]\d*)$/, Gf = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g, ai = /($^)/, jf = /['\n\r\u2028\u2029\\]/g, fi = "\\ud800-\\udfff", zf = "\\u0300-\\u036f", Yf = "\\ufe20-\\ufe2f", Jf = "\\u20d0-\\u20ff", Sc = zf + Yf + Jf, Oc = "\\u2700-\\u27bf", kc = "a-z\\xdf-\\xf6\\xf8-\\xff", Zf = "\\xac\\xb1\\xd7\\xf7", Xf = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", Qf = "\\u2000-\\u206f", eh = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", Bc = "A-Z\\xc0-\\xd6\\xd8-\\xde", Lc = "\\ufe0e\\ufe0f", Mc = Zf + Xf + Qf + eh, Ys = "['’]", th = "[" + fi + "]", Uc = "[" + Mc + "]", hi = "[" + Sc + "]", Fc = "\\d+", nh = "[" + Oc + "]", $c = "[" + kc + "]", qc = "[^" + fi + Mc + Fc + Oc + kc + Bc + "]", Js = "\\ud83c[\\udffb-\\udfff]", rh = "(?:" + hi + "|" + Js + ")", Wc = "[^" + fi + "]", Zs = "(?:\\ud83c[\\udde6-\\uddff]){2}", Xs = "[\\ud800-\\udbff][\\udc00-\\udfff]", tr = "[" + Bc + "]", Hc = "\\u200d", Kc = "(?:" + $c + "|" + qc + ")", ih = "(?:" + tr + "|" + qc + ")", Vc = "(?:" + Ys + "(?:d|ll|m|re|s|t|ve))?", Gc = "(?:" + Ys + "(?:D|LL|M|RE|S|T|VE))?", jc = rh + "?", zc = "[" + Lc + "]?", sh = "(?:" + Hc + "(?:" + [Wc, Zs, Xs].join("|") + ")" + zc + jc + ")*", oh = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", ch = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", Yc = zc + jc + sh, uh = "(?:" + [nh, Zs, Xs].join("|") + ")" + Yc, lh = "(?:" + [Wc + hi + "?", hi, Zs, Xs, th].join("|") + ")", ah = RegExp(Ys, "g"), fh = RegExp(hi, "g"), Qs = RegExp(Js + "(?=" + Js + ")|" + lh + Yc, "g"), hh = RegExp([
      tr + "?" + $c + "+" + Vc + "(?=" + [Uc, tr, "$"].join("|") + ")",
      ih + "+" + Gc + "(?=" + [Uc, tr + Kc, "$"].join("|") + ")",
      tr + "?" + Kc + "+" + Vc,
      tr + "+" + Gc,
      ch,
      oh,
      Fc,
      uh
    ].join("|"), "g"), ph = RegExp("[" + Hc + fi + Sc + Lc + "]"), mh = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/, gh = [
      "Array",
      "Buffer",
      "DataView",
      "Date",
      "Error",
      "Float32Array",
      "Float64Array",
      "Function",
      "Int8Array",
      "Int16Array",
      "Int32Array",
      "Map",
      "Math",
      "Object",
      "Promise",
      "RegExp",
      "Set",
      "String",
      "Symbol",
      "TypeError",
      "Uint8Array",
      "Uint8ClampedArray",
      "Uint16Array",
      "Uint32Array",
      "WeakMap",
      "_",
      "clearTimeout",
      "isFinite",
      "parseInt",
      "setTimeout"
    ], dh = -1, me = {};
    me[In] = me[Rn] = me[Pn] = me[Nn] = me[Sn] = me[On] = me[kn] = me[Bn] = me[Ln] = !0, me[je] = me[ft] = me[zt] = me[nt] = me[Rt] = me[rt] = me[ht] = me[It] = me[Ie] = me[vt] = me[Fe] = me[Vt] = me[$e] = me[Gt] = me[jt] = !1;
    var pe = {};
    pe[je] = pe[ft] = pe[zt] = pe[Rt] = pe[nt] = pe[rt] = pe[In] = pe[Rn] = pe[Pn] = pe[Nn] = pe[Sn] = pe[Ie] = pe[vt] = pe[Fe] = pe[Vt] = pe[$e] = pe[Gt] = pe[hn] = pe[On] = pe[kn] = pe[Bn] = pe[Ln] = !0, pe[ht] = pe[It] = pe[jt] = !1;
    var yh = {
      // Latin-1 Supplement block.
      À: "A",
      Á: "A",
      Â: "A",
      Ã: "A",
      Ä: "A",
      Å: "A",
      à: "a",
      á: "a",
      â: "a",
      ã: "a",
      ä: "a",
      å: "a",
      Ç: "C",
      ç: "c",
      Ð: "D",
      ð: "d",
      È: "E",
      É: "E",
      Ê: "E",
      Ë: "E",
      è: "e",
      é: "e",
      ê: "e",
      ë: "e",
      Ì: "I",
      Í: "I",
      Î: "I",
      Ï: "I",
      ì: "i",
      í: "i",
      î: "i",
      ï: "i",
      Ñ: "N",
      ñ: "n",
      Ò: "O",
      Ó: "O",
      Ô: "O",
      Õ: "O",
      Ö: "O",
      Ø: "O",
      ò: "o",
      ó: "o",
      ô: "o",
      õ: "o",
      ö: "o",
      ø: "o",
      Ù: "U",
      Ú: "U",
      Û: "U",
      Ü: "U",
      ù: "u",
      ú: "u",
      û: "u",
      ü: "u",
      Ý: "Y",
      ý: "y",
      ÿ: "y",
      Æ: "Ae",
      æ: "ae",
      Þ: "Th",
      þ: "th",
      ß: "ss",
      // Latin Extended-A block.
      Ā: "A",
      Ă: "A",
      Ą: "A",
      ā: "a",
      ă: "a",
      ą: "a",
      Ć: "C",
      Ĉ: "C",
      Ċ: "C",
      Č: "C",
      ć: "c",
      ĉ: "c",
      ċ: "c",
      č: "c",
      Ď: "D",
      Đ: "D",
      ď: "d",
      đ: "d",
      Ē: "E",
      Ĕ: "E",
      Ė: "E",
      Ę: "E",
      Ě: "E",
      ē: "e",
      ĕ: "e",
      ė: "e",
      ę: "e",
      ě: "e",
      Ĝ: "G",
      Ğ: "G",
      Ġ: "G",
      Ģ: "G",
      ĝ: "g",
      ğ: "g",
      ġ: "g",
      ģ: "g",
      Ĥ: "H",
      Ħ: "H",
      ĥ: "h",
      ħ: "h",
      Ĩ: "I",
      Ī: "I",
      Ĭ: "I",
      Į: "I",
      İ: "I",
      ĩ: "i",
      ī: "i",
      ĭ: "i",
      į: "i",
      ı: "i",
      Ĵ: "J",
      ĵ: "j",
      Ķ: "K",
      ķ: "k",
      ĸ: "k",
      Ĺ: "L",
      Ļ: "L",
      Ľ: "L",
      Ŀ: "L",
      Ł: "L",
      ĺ: "l",
      ļ: "l",
      ľ: "l",
      ŀ: "l",
      ł: "l",
      Ń: "N",
      Ņ: "N",
      Ň: "N",
      Ŋ: "N",
      ń: "n",
      ņ: "n",
      ň: "n",
      ŋ: "n",
      Ō: "O",
      Ŏ: "O",
      Ő: "O",
      ō: "o",
      ŏ: "o",
      ő: "o",
      Ŕ: "R",
      Ŗ: "R",
      Ř: "R",
      ŕ: "r",
      ŗ: "r",
      ř: "r",
      Ś: "S",
      Ŝ: "S",
      Ş: "S",
      Š: "S",
      ś: "s",
      ŝ: "s",
      ş: "s",
      š: "s",
      Ţ: "T",
      Ť: "T",
      Ŧ: "T",
      ţ: "t",
      ť: "t",
      ŧ: "t",
      Ũ: "U",
      Ū: "U",
      Ŭ: "U",
      Ů: "U",
      Ű: "U",
      Ų: "U",
      ũ: "u",
      ū: "u",
      ŭ: "u",
      ů: "u",
      ű: "u",
      ų: "u",
      Ŵ: "W",
      ŵ: "w",
      Ŷ: "Y",
      ŷ: "y",
      Ÿ: "Y",
      Ź: "Z",
      Ż: "Z",
      Ž: "Z",
      ź: "z",
      ż: "z",
      ž: "z",
      Ĳ: "IJ",
      ĳ: "ij",
      Œ: "Oe",
      œ: "oe",
      ŉ: "'n",
      ſ: "s"
    }, wh = {
      "&": "&amp;",
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;"
    }, _h = {
      "&amp;": "&",
      "&lt;": "<",
      "&gt;": ">",
      "&quot;": '"',
      "&#39;": "'"
    }, Ah = {
      "\\": "\\",
      "'": "'",
      "\n": "n",
      "\r": "r",
      "\u2028": "u2028",
      "\u2029": "u2029"
    }, vh = parseFloat, bh = parseInt, Jc = typeof Vr == "object" && Vr && Vr.Object === Object && Vr, Dh = typeof self == "object" && self && self.Object === Object && self, Re = Jc || Dh || Function("return this")(), eo = i && !i.nodeType && i, Mn = eo && !0 && o && !o.nodeType && o, Zc = Mn && Mn.exports === eo, to = Zc && Jc.process, pt = function() {
      try {
        var y = Mn && Mn.require && Mn.require("util").types;
        return y || to && to.binding && to.binding("util");
      } catch {
      }
    }(), Xc = pt && pt.isArrayBuffer, Qc = pt && pt.isDate, eu = pt && pt.isMap, tu = pt && pt.isRegExp, nu = pt && pt.isSet, ru = pt && pt.isTypedArray;
    function it(y, C, b) {
      switch (b.length) {
        case 0:
          return y.call(C);
        case 1:
          return y.call(C, b[0]);
        case 2:
          return y.call(C, b[0], b[1]);
        case 3:
          return y.call(C, b[0], b[1], b[2]);
      }
      return y.apply(C, b);
    }
    function Ch(y, C, b, B) {
      for (var j = -1, oe = y == null ? 0 : y.length; ++j < oe; ) {
        var De = y[j];
        C(B, De, b(De), y);
      }
      return B;
    }
    function mt(y, C) {
      for (var b = -1, B = y == null ? 0 : y.length; ++b < B && C(y[b], b, y) !== !1; )
        ;
      return y;
    }
    function Th(y, C) {
      for (var b = y == null ? 0 : y.length; b-- && C(y[b], b, y) !== !1; )
        ;
      return y;
    }
    function iu(y, C) {
      for (var b = -1, B = y == null ? 0 : y.length; ++b < B; )
        if (!C(y[b], b, y))
          return !1;
      return !0;
    }
    function pn(y, C) {
      for (var b = -1, B = y == null ? 0 : y.length, j = 0, oe = []; ++b < B; ) {
        var De = y[b];
        C(De, b, y) && (oe[j++] = De);
      }
      return oe;
    }
    function pi(y, C) {
      var b = y == null ? 0 : y.length;
      return !!b && nr(y, C, 0) > -1;
    }
    function no(y, C, b) {
      for (var B = -1, j = y == null ? 0 : y.length; ++B < j; )
        if (b(C, y[B]))
          return !0;
      return !1;
    }
    function de(y, C) {
      for (var b = -1, B = y == null ? 0 : y.length, j = Array(B); ++b < B; )
        j[b] = C(y[b], b, y);
      return j;
    }
    function mn(y, C) {
      for (var b = -1, B = C.length, j = y.length; ++b < B; )
        y[j + b] = C[b];
      return y;
    }
    function ro(y, C, b, B) {
      var j = -1, oe = y == null ? 0 : y.length;
      for (B && oe && (b = y[++j]); ++j < oe; )
        b = C(b, y[j], j, y);
      return b;
    }
    function Eh(y, C, b, B) {
      var j = y == null ? 0 : y.length;
      for (B && j && (b = y[--j]); j--; )
        b = C(b, y[j], j, y);
      return b;
    }
    function io(y, C) {
      for (var b = -1, B = y == null ? 0 : y.length; ++b < B; )
        if (C(y[b], b, y))
          return !0;
      return !1;
    }
    var xh = so("length");
    function Ih(y) {
      return y.split("");
    }
    function Rh(y) {
      return y.match(Mf) || [];
    }
    function su(y, C, b) {
      var B;
      return b(y, function(j, oe, De) {
        if (C(j, oe, De))
          return B = oe, !1;
      }), B;
    }
    function mi(y, C, b, B) {
      for (var j = y.length, oe = b + (B ? 1 : -1); B ? oe-- : ++oe < j; )
        if (C(y[oe], oe, y))
          return oe;
      return -1;
    }
    function nr(y, C, b) {
      return C === C ? qh(y, C, b) : mi(y, ou, b);
    }
    function Ph(y, C, b, B) {
      for (var j = b - 1, oe = y.length; ++j < oe; )
        if (B(y[j], C))
          return j;
      return -1;
    }
    function ou(y) {
      return y !== y;
    }
    function cu(y, C) {
      var b = y == null ? 0 : y.length;
      return b ? co(y, C) / b : at;
    }
    function so(y) {
      return function(C) {
        return C == null ? e : C[y];
      };
    }
    function oo(y) {
      return function(C) {
        return y == null ? e : y[C];
      };
    }
    function uu(y, C, b, B, j) {
      return j(y, function(oe, De, fe) {
        b = B ? (B = !1, oe) : C(b, oe, De, fe);
      }), b;
    }
    function Nh(y, C) {
      var b = y.length;
      for (y.sort(C); b--; )
        y[b] = y[b].value;
      return y;
    }
    function co(y, C) {
      for (var b, B = -1, j = y.length; ++B < j; ) {
        var oe = C(y[B]);
        oe !== e && (b = b === e ? oe : b + oe);
      }
      return b;
    }
    function uo(y, C) {
      for (var b = -1, B = Array(y); ++b < y; )
        B[b] = C(b);
      return B;
    }
    function Sh(y, C) {
      return de(C, function(b) {
        return [b, y[b]];
      });
    }
    function lu(y) {
      return y && y.slice(0, pu(y) + 1).replace(zs, "");
    }
    function st(y) {
      return function(C) {
        return y(C);
      };
    }
    function lo(y, C) {
      return de(C, function(b) {
        return y[b];
      });
    }
    function Rr(y, C) {
      return y.has(C);
    }
    function au(y, C) {
      for (var b = -1, B = y.length; ++b < B && nr(C, y[b], 0) > -1; )
        ;
      return b;
    }
    function fu(y, C) {
      for (var b = y.length; b-- && nr(C, y[b], 0) > -1; )
        ;
      return b;
    }
    function Oh(y, C) {
      for (var b = y.length, B = 0; b--; )
        y[b] === C && ++B;
      return B;
    }
    var kh = oo(yh), Bh = oo(wh);
    function Lh(y) {
      return "\\" + Ah[y];
    }
    function Mh(y, C) {
      return y == null ? e : y[C];
    }
    function rr(y) {
      return ph.test(y);
    }
    function Uh(y) {
      return mh.test(y);
    }
    function Fh(y) {
      for (var C, b = []; !(C = y.next()).done; )
        b.push(C.value);
      return b;
    }
    function ao(y) {
      var C = -1, b = Array(y.size);
      return y.forEach(function(B, j) {
        b[++C] = [j, B];
      }), b;
    }
    function hu(y, C) {
      return function(b) {
        return y(C(b));
      };
    }
    function gn(y, C) {
      for (var b = -1, B = y.length, j = 0, oe = []; ++b < B; ) {
        var De = y[b];
        (De === C || De === D) && (y[b] = D, oe[j++] = b);
      }
      return oe;
    }
    function gi(y) {
      var C = -1, b = Array(y.size);
      return y.forEach(function(B) {
        b[++C] = B;
      }), b;
    }
    function $h(y) {
      var C = -1, b = Array(y.size);
      return y.forEach(function(B) {
        b[++C] = [B, B];
      }), b;
    }
    function qh(y, C, b) {
      for (var B = b - 1, j = y.length; ++B < j; )
        if (y[B] === C)
          return B;
      return -1;
    }
    function Wh(y, C, b) {
      for (var B = b + 1; B--; )
        if (y[B] === C)
          return B;
      return B;
    }
    function ir(y) {
      return rr(y) ? Kh(y) : xh(y);
    }
    function bt(y) {
      return rr(y) ? Vh(y) : Ih(y);
    }
    function pu(y) {
      for (var C = y.length; C-- && Of.test(y.charAt(C)); )
        ;
      return C;
    }
    var Hh = oo(_h);
    function Kh(y) {
      for (var C = Qs.lastIndex = 0; Qs.test(y); )
        ++C;
      return C;
    }
    function Vh(y) {
      return y.match(Qs) || [];
    }
    function Gh(y) {
      return y.match(hh) || [];
    }
    var jh = function y(C) {
      C = C == null ? Re : sr.defaults(Re.Object(), C, sr.pick(Re, gh));
      var b = C.Array, B = C.Date, j = C.Error, oe = C.Function, De = C.Math, fe = C.Object, fo = C.RegExp, zh = C.String, gt = C.TypeError, di = b.prototype, Yh = oe.prototype, or = fe.prototype, yi = C["__core-js_shared__"], wi = Yh.toString, ue = or.hasOwnProperty, Jh = 0, mu = function() {
        var t = /[^.]+$/.exec(yi && yi.keys && yi.keys.IE_PROTO || "");
        return t ? "Symbol(src)_1." + t : "";
      }(), _i = or.toString, Zh = wi.call(fe), Xh = Re._, Qh = fo(
        "^" + wi.call(ue).replace(js, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
      ), Ai = Zc ? C.Buffer : e, dn = C.Symbol, vi = C.Uint8Array, gu = Ai ? Ai.allocUnsafe : e, bi = hu(fe.getPrototypeOf, fe), du = fe.create, yu = or.propertyIsEnumerable, Di = di.splice, wu = dn ? dn.isConcatSpreadable : e, Pr = dn ? dn.iterator : e, Un = dn ? dn.toStringTag : e, Ci = function() {
        try {
          var t = Hn(fe, "defineProperty");
          return t({}, "", {}), t;
        } catch {
        }
      }(), ep = C.clearTimeout !== Re.clearTimeout && C.clearTimeout, tp = B && B.now !== Re.Date.now && B.now, np = C.setTimeout !== Re.setTimeout && C.setTimeout, Ti = De.ceil, Ei = De.floor, ho = fe.getOwnPropertySymbols, rp = Ai ? Ai.isBuffer : e, _u = C.isFinite, ip = di.join, sp = hu(fe.keys, fe), Ce = De.max, Oe = De.min, op = B.now, cp = C.parseInt, Au = De.random, up = di.reverse, po = Hn(C, "DataView"), Nr = Hn(C, "Map"), mo = Hn(C, "Promise"), cr = Hn(C, "Set"), Sr = Hn(C, "WeakMap"), Or = Hn(fe, "create"), xi = Sr && new Sr(), ur = {}, lp = Kn(po), ap = Kn(Nr), fp = Kn(mo), hp = Kn(cr), pp = Kn(Sr), Ii = dn ? dn.prototype : e, kr = Ii ? Ii.valueOf : e, vu = Ii ? Ii.toString : e;
      function f(t) {
        if (_e(t) && !z(t) && !(t instanceof re)) {
          if (t instanceof dt)
            return t;
          if (ue.call(t, "__wrapped__"))
            return bl(t);
        }
        return new dt(t);
      }
      var lr = function() {
        function t() {
        }
        return function(n) {
          if (!we(n))
            return {};
          if (du)
            return du(n);
          t.prototype = n;
          var s = new t();
          return t.prototype = e, s;
        };
      }();
      function Ri() {
      }
      function dt(t, n) {
        this.__wrapped__ = t, this.__actions__ = [], this.__chain__ = !!n, this.__index__ = 0, this.__values__ = e;
      }
      f.templateSettings = {
        /**
         * Used to detect `data` property values to be HTML-escaped.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        escape: xf,
        /**
         * Used to detect code to be evaluated.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        evaluate: If,
        /**
         * Used to detect `data` property values to inject.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        interpolate: Pc,
        /**
         * Used to reference the data object in the template text.
         *
         * @memberOf _.templateSettings
         * @type {string}
         */
        variable: "",
        /**
         * Used to import variables into the compiled template.
         *
         * @memberOf _.templateSettings
         * @type {Object}
         */
        imports: {
          /**
           * A reference to the `lodash` function.
           *
           * @memberOf _.templateSettings.imports
           * @type {Function}
           */
          _: f
        }
      }, f.prototype = Ri.prototype, f.prototype.constructor = f, dt.prototype = lr(Ri.prototype), dt.prototype.constructor = dt;
      function re(t) {
        this.__wrapped__ = t, this.__actions__ = [], this.__dir__ = 1, this.__filtered__ = !1, this.__iteratees__ = [], this.__takeCount__ = Ee, this.__views__ = [];
      }
      function mp() {
        var t = new re(this.__wrapped__);
        return t.__actions__ = ze(this.__actions__), t.__dir__ = this.__dir__, t.__filtered__ = this.__filtered__, t.__iteratees__ = ze(this.__iteratees__), t.__takeCount__ = this.__takeCount__, t.__views__ = ze(this.__views__), t;
      }
      function gp() {
        if (this.__filtered__) {
          var t = new re(this);
          t.__dir__ = -1, t.__filtered__ = !0;
        } else
          t = this.clone(), t.__dir__ *= -1;
        return t;
      }
      function dp() {
        var t = this.__wrapped__.value(), n = this.__dir__, s = z(t), u = n < 0, a = s ? t.length : 0, p = Im(0, a, this.__views__), m = p.start, d = p.end, _ = d - m, E = u ? d : m - 1, x = this.__iteratees__, P = x.length, k = 0, L = Oe(_, this.__takeCount__);
        if (!s || !u && a == _ && L == _)
          return Vu(t, this.__actions__);
        var H = [];
        e:
          for (; _-- && k < L; ) {
            E += n;
            for (var Z = -1, K = t[E]; ++Z < P; ) {
              var te = x[Z], ie = te.iteratee, ut = te.type, He = ie(K);
              if (ut == Mt)
                K = He;
              else if (!He) {
                if (ut == Ge)
                  continue e;
                break e;
              }
            }
            H[k++] = K;
          }
        return H;
      }
      re.prototype = lr(Ri.prototype), re.prototype.constructor = re;
      function Fn(t) {
        var n = -1, s = t == null ? 0 : t.length;
        for (this.clear(); ++n < s; ) {
          var u = t[n];
          this.set(u[0], u[1]);
        }
      }
      function yp() {
        this.__data__ = Or ? Or(null) : {}, this.size = 0;
      }
      function wp(t) {
        var n = this.has(t) && delete this.__data__[t];
        return this.size -= n ? 1 : 0, n;
      }
      function _p(t) {
        var n = this.__data__;
        if (Or) {
          var s = n[t];
          return s === v ? e : s;
        }
        return ue.call(n, t) ? n[t] : e;
      }
      function Ap(t) {
        var n = this.__data__;
        return Or ? n[t] !== e : ue.call(n, t);
      }
      function vp(t, n) {
        var s = this.__data__;
        return this.size += this.has(t) ? 0 : 1, s[t] = Or && n === e ? v : n, this;
      }
      Fn.prototype.clear = yp, Fn.prototype.delete = wp, Fn.prototype.get = _p, Fn.prototype.has = Ap, Fn.prototype.set = vp;
      function Yt(t) {
        var n = -1, s = t == null ? 0 : t.length;
        for (this.clear(); ++n < s; ) {
          var u = t[n];
          this.set(u[0], u[1]);
        }
      }
      function bp() {
        this.__data__ = [], this.size = 0;
      }
      function Dp(t) {
        var n = this.__data__, s = Pi(n, t);
        if (s < 0)
          return !1;
        var u = n.length - 1;
        return s == u ? n.pop() : Di.call(n, s, 1), --this.size, !0;
      }
      function Cp(t) {
        var n = this.__data__, s = Pi(n, t);
        return s < 0 ? e : n[s][1];
      }
      function Tp(t) {
        return Pi(this.__data__, t) > -1;
      }
      function Ep(t, n) {
        var s = this.__data__, u = Pi(s, t);
        return u < 0 ? (++this.size, s.push([t, n])) : s[u][1] = n, this;
      }
      Yt.prototype.clear = bp, Yt.prototype.delete = Dp, Yt.prototype.get = Cp, Yt.prototype.has = Tp, Yt.prototype.set = Ep;
      function Jt(t) {
        var n = -1, s = t == null ? 0 : t.length;
        for (this.clear(); ++n < s; ) {
          var u = t[n];
          this.set(u[0], u[1]);
        }
      }
      function xp() {
        this.size = 0, this.__data__ = {
          hash: new Fn(),
          map: new (Nr || Yt)(),
          string: new Fn()
        };
      }
      function Ip(t) {
        var n = Wi(this, t).delete(t);
        return this.size -= n ? 1 : 0, n;
      }
      function Rp(t) {
        return Wi(this, t).get(t);
      }
      function Pp(t) {
        return Wi(this, t).has(t);
      }
      function Np(t, n) {
        var s = Wi(this, t), u = s.size;
        return s.set(t, n), this.size += s.size == u ? 0 : 1, this;
      }
      Jt.prototype.clear = xp, Jt.prototype.delete = Ip, Jt.prototype.get = Rp, Jt.prototype.has = Pp, Jt.prototype.set = Np;
      function $n(t) {
        var n = -1, s = t == null ? 0 : t.length;
        for (this.__data__ = new Jt(); ++n < s; )
          this.add(t[n]);
      }
      function Sp(t) {
        return this.__data__.set(t, v), this;
      }
      function Op(t) {
        return this.__data__.has(t);
      }
      $n.prototype.add = $n.prototype.push = Sp, $n.prototype.has = Op;
      function Dt(t) {
        var n = this.__data__ = new Yt(t);
        this.size = n.size;
      }
      function kp() {
        this.__data__ = new Yt(), this.size = 0;
      }
      function Bp(t) {
        var n = this.__data__, s = n.delete(t);
        return this.size = n.size, s;
      }
      function Lp(t) {
        return this.__data__.get(t);
      }
      function Mp(t) {
        return this.__data__.has(t);
      }
      function Up(t, n) {
        var s = this.__data__;
        if (s instanceof Yt) {
          var u = s.__data__;
          if (!Nr || u.length < c - 1)
            return u.push([t, n]), this.size = ++s.size, this;
          s = this.__data__ = new Jt(u);
        }
        return s.set(t, n), this.size = s.size, this;
      }
      Dt.prototype.clear = kp, Dt.prototype.delete = Bp, Dt.prototype.get = Lp, Dt.prototype.has = Mp, Dt.prototype.set = Up;
      function bu(t, n) {
        var s = z(t), u = !s && Vn(t), a = !s && !u && vn(t), p = !s && !u && !a && pr(t), m = s || u || a || p, d = m ? uo(t.length, zh) : [], _ = d.length;
        for (var E in t)
          (n || ue.call(t, E)) && !(m && // Safari 9 has enumerable `arguments.length` in strict mode.
          (E == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
          a && (E == "offset" || E == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
          p && (E == "buffer" || E == "byteLength" || E == "byteOffset") || // Skip index properties.
          en(E, _))) && d.push(E);
        return d;
      }
      function Du(t) {
        var n = t.length;
        return n ? t[Eo(0, n - 1)] : e;
      }
      function Fp(t, n) {
        return Hi(ze(t), qn(n, 0, t.length));
      }
      function $p(t) {
        return Hi(ze(t));
      }
      function go(t, n, s) {
        (s !== e && !Ct(t[n], s) || s === e && !(n in t)) && Zt(t, n, s);
      }
      function Br(t, n, s) {
        var u = t[n];
        (!(ue.call(t, n) && Ct(u, s)) || s === e && !(n in t)) && Zt(t, n, s);
      }
      function Pi(t, n) {
        for (var s = t.length; s--; )
          if (Ct(t[s][0], n))
            return s;
        return -1;
      }
      function qp(t, n, s, u) {
        return yn(t, function(a, p, m) {
          n(u, a, s(a), m);
        }), u;
      }
      function Cu(t, n) {
        return t && Nt(n, xe(n), t);
      }
      function Wp(t, n) {
        return t && Nt(n, Je(n), t);
      }
      function Zt(t, n, s) {
        n == "__proto__" && Ci ? Ci(t, n, {
          configurable: !0,
          enumerable: !0,
          value: s,
          writable: !0
        }) : t[n] = s;
      }
      function yo(t, n) {
        for (var s = -1, u = n.length, a = b(u), p = t == null; ++s < u; )
          a[s] = p ? e : Zo(t, n[s]);
        return a;
      }
      function qn(t, n, s) {
        return t === t && (s !== e && (t = t <= s ? t : s), n !== e && (t = t >= n ? t : n)), t;
      }
      function yt(t, n, s, u, a, p) {
        var m, d = n & I, _ = n & S, E = n & N;
        if (s && (m = a ? s(t, u, a, p) : s(t)), m !== e)
          return m;
        if (!we(t))
          return t;
        var x = z(t);
        if (x) {
          if (m = Pm(t), !d)
            return ze(t, m);
        } else {
          var P = ke(t), k = P == It || P == an;
          if (vn(t))
            return zu(t, d);
          if (P == Fe || P == je || k && !a) {
            if (m = _ || k ? {} : pl(t), !d)
              return _ ? _m(t, Wp(m, t)) : wm(t, Cu(m, t));
          } else {
            if (!pe[P])
              return a ? t : {};
            m = Nm(t, P, d);
          }
        }
        p || (p = new Dt());
        var L = p.get(t);
        if (L)
          return L;
        p.set(t, m), Wl(t) ? t.forEach(function(K) {
          m.add(yt(K, n, s, K, t, p));
        }) : $l(t) && t.forEach(function(K, te) {
          m.set(te, yt(K, n, s, te, t, p));
        });
        var H = E ? _ ? Mo : Lo : _ ? Je : xe, Z = x ? e : H(t);
        return mt(Z || t, function(K, te) {
          Z && (te = K, K = t[te]), Br(m, te, yt(K, n, s, te, t, p));
        }), m;
      }
      function Hp(t) {
        var n = xe(t);
        return function(s) {
          return Tu(s, t, n);
        };
      }
      function Tu(t, n, s) {
        var u = s.length;
        if (t == null)
          return !u;
        for (t = fe(t); u--; ) {
          var a = s[u], p = n[a], m = t[a];
          if (m === e && !(a in t) || !p(m))
            return !1;
        }
        return !0;
      }
      function Eu(t, n, s) {
        if (typeof t != "function")
          throw new gt(h);
        return Wr(function() {
          t.apply(e, s);
        }, n);
      }
      function Lr(t, n, s, u) {
        var a = -1, p = pi, m = !0, d = t.length, _ = [], E = n.length;
        if (!d)
          return _;
        s && (n = de(n, st(s))), u ? (p = no, m = !1) : n.length >= c && (p = Rr, m = !1, n = new $n(n));
        e:
          for (; ++a < d; ) {
            var x = t[a], P = s == null ? x : s(x);
            if (x = u || x !== 0 ? x : 0, m && P === P) {
              for (var k = E; k--; )
                if (n[k] === P)
                  continue e;
              _.push(x);
            } else
              p(n, P, u) || _.push(x);
          }
        return _;
      }
      var yn = Qu(Pt), xu = Qu(_o, !0);
      function Kp(t, n) {
        var s = !0;
        return yn(t, function(u, a, p) {
          return s = !!n(u, a, p), s;
        }), s;
      }
      function Ni(t, n, s) {
        for (var u = -1, a = t.length; ++u < a; ) {
          var p = t[u], m = n(p);
          if (m != null && (d === e ? m === m && !ct(m) : s(m, d)))
            var d = m, _ = p;
        }
        return _;
      }
      function Vp(t, n, s, u) {
        var a = t.length;
        for (s = Y(s), s < 0 && (s = -s > a ? 0 : a + s), u = u === e || u > a ? a : Y(u), u < 0 && (u += a), u = s > u ? 0 : Kl(u); s < u; )
          t[s++] = n;
        return t;
      }
      function Iu(t, n) {
        var s = [];
        return yn(t, function(u, a, p) {
          n(u, a, p) && s.push(u);
        }), s;
      }
      function Pe(t, n, s, u, a) {
        var p = -1, m = t.length;
        for (s || (s = Om), a || (a = []); ++p < m; ) {
          var d = t[p];
          n > 0 && s(d) ? n > 1 ? Pe(d, n - 1, s, u, a) : mn(a, d) : u || (a[a.length] = d);
        }
        return a;
      }
      var wo = el(), Ru = el(!0);
      function Pt(t, n) {
        return t && wo(t, n, xe);
      }
      function _o(t, n) {
        return t && Ru(t, n, xe);
      }
      function Si(t, n) {
        return pn(n, function(s) {
          return tn(t[s]);
        });
      }
      function Wn(t, n) {
        n = _n(n, t);
        for (var s = 0, u = n.length; t != null && s < u; )
          t = t[St(n[s++])];
        return s && s == u ? t : e;
      }
      function Pu(t, n, s) {
        var u = n(t);
        return z(t) ? u : mn(u, s(t));
      }
      function qe(t) {
        return t == null ? t === e ? Cr : xn : Un && Un in fe(t) ? xm(t) : $m(t);
      }
      function Ao(t, n) {
        return t > n;
      }
      function Gp(t, n) {
        return t != null && ue.call(t, n);
      }
      function jp(t, n) {
        return t != null && n in fe(t);
      }
      function zp(t, n, s) {
        return t >= Oe(n, s) && t < Ce(n, s);
      }
      function vo(t, n, s) {
        for (var u = s ? no : pi, a = t[0].length, p = t.length, m = p, d = b(p), _ = 1 / 0, E = []; m--; ) {
          var x = t[m];
          m && n && (x = de(x, st(n))), _ = Oe(x.length, _), d[m] = !s && (n || a >= 120 && x.length >= 120) ? new $n(m && x) : e;
        }
        x = t[0];
        var P = -1, k = d[0];
        e:
          for (; ++P < a && E.length < _; ) {
            var L = x[P], H = n ? n(L) : L;
            if (L = s || L !== 0 ? L : 0, !(k ? Rr(k, H) : u(E, H, s))) {
              for (m = p; --m; ) {
                var Z = d[m];
                if (!(Z ? Rr(Z, H) : u(t[m], H, s)))
                  continue e;
              }
              k && k.push(H), E.push(L);
            }
          }
        return E;
      }
      function Yp(t, n, s, u) {
        return Pt(t, function(a, p, m) {
          n(u, s(a), p, m);
        }), u;
      }
      function Mr(t, n, s) {
        n = _n(n, t), t = yl(t, n);
        var u = t == null ? t : t[St(_t(n))];
        return u == null ? e : it(u, t, s);
      }
      function Nu(t) {
        return _e(t) && qe(t) == je;
      }
      function Jp(t) {
        return _e(t) && qe(t) == zt;
      }
      function Zp(t) {
        return _e(t) && qe(t) == rt;
      }
      function Ur(t, n, s, u, a) {
        return t === n ? !0 : t == null || n == null || !_e(t) && !_e(n) ? t !== t && n !== n : Xp(t, n, s, u, Ur, a);
      }
      function Xp(t, n, s, u, a, p) {
        var m = z(t), d = z(n), _ = m ? ft : ke(t), E = d ? ft : ke(n);
        _ = _ == je ? Fe : _, E = E == je ? Fe : E;
        var x = _ == Fe, P = E == Fe, k = _ == E;
        if (k && vn(t)) {
          if (!vn(n))
            return !1;
          m = !0, x = !1;
        }
        if (k && !x)
          return p || (p = new Dt()), m || pr(t) ? al(t, n, s, u, a, p) : Tm(t, n, _, s, u, a, p);
        if (!(s & R)) {
          var L = x && ue.call(t, "__wrapped__"), H = P && ue.call(n, "__wrapped__");
          if (L || H) {
            var Z = L ? t.value() : t, K = H ? n.value() : n;
            return p || (p = new Dt()), a(Z, K, s, u, p);
          }
        }
        return k ? (p || (p = new Dt()), Em(t, n, s, u, a, p)) : !1;
      }
      function Qp(t) {
        return _e(t) && ke(t) == Ie;
      }
      function bo(t, n, s, u) {
        var a = s.length, p = a, m = !u;
        if (t == null)
          return !p;
        for (t = fe(t); a--; ) {
          var d = s[a];
          if (m && d[2] ? d[1] !== t[d[0]] : !(d[0] in t))
            return !1;
        }
        for (; ++a < p; ) {
          d = s[a];
          var _ = d[0], E = t[_], x = d[1];
          if (m && d[2]) {
            if (E === e && !(_ in t))
              return !1;
          } else {
            var P = new Dt();
            if (u)
              var k = u(E, x, _, t, n, P);
            if (!(k === e ? Ur(x, E, R | O, u, P) : k))
              return !1;
          }
        }
        return !0;
      }
      function Su(t) {
        if (!we(t) || Bm(t))
          return !1;
        var n = tn(t) ? Qh : Hf;
        return n.test(Kn(t));
      }
      function em(t) {
        return _e(t) && qe(t) == Vt;
      }
      function tm(t) {
        return _e(t) && ke(t) == $e;
      }
      function nm(t) {
        return _e(t) && Yi(t.length) && !!me[qe(t)];
      }
      function Ou(t) {
        return typeof t == "function" ? t : t == null ? Ze : typeof t == "object" ? z(t) ? Lu(t[0], t[1]) : Bu(t) : ta(t);
      }
      function Do(t) {
        if (!qr(t))
          return sp(t);
        var n = [];
        for (var s in fe(t))
          ue.call(t, s) && s != "constructor" && n.push(s);
        return n;
      }
      function rm(t) {
        if (!we(t))
          return Fm(t);
        var n = qr(t), s = [];
        for (var u in t)
          u == "constructor" && (n || !ue.call(t, u)) || s.push(u);
        return s;
      }
      function Co(t, n) {
        return t < n;
      }
      function ku(t, n) {
        var s = -1, u = Ye(t) ? b(t.length) : [];
        return yn(t, function(a, p, m) {
          u[++s] = n(a, p, m);
        }), u;
      }
      function Bu(t) {
        var n = Fo(t);
        return n.length == 1 && n[0][2] ? gl(n[0][0], n[0][1]) : function(s) {
          return s === t || bo(s, t, n);
        };
      }
      function Lu(t, n) {
        return qo(t) && ml(n) ? gl(St(t), n) : function(s) {
          var u = Zo(s, t);
          return u === e && u === n ? Xo(s, t) : Ur(n, u, R | O);
        };
      }
      function Oi(t, n, s, u, a) {
        t !== n && wo(n, function(p, m) {
          if (a || (a = new Dt()), we(p))
            im(t, n, m, s, Oi, u, a);
          else {
            var d = u ? u(Ho(t, m), p, m + "", t, n, a) : e;
            d === e && (d = p), go(t, m, d);
          }
        }, Je);
      }
      function im(t, n, s, u, a, p, m) {
        var d = Ho(t, s), _ = Ho(n, s), E = m.get(_);
        if (E) {
          go(t, s, E);
          return;
        }
        var x = p ? p(d, _, s + "", t, n, m) : e, P = x === e;
        if (P) {
          var k = z(_), L = !k && vn(_), H = !k && !L && pr(_);
          x = _, k || L || H ? z(d) ? x = d : Ae(d) ? x = ze(d) : L ? (P = !1, x = zu(_, !0)) : H ? (P = !1, x = Yu(_, !0)) : x = [] : Hr(_) || Vn(_) ? (x = d, Vn(d) ? x = Vl(d) : (!we(d) || tn(d)) && (x = pl(_))) : P = !1;
        }
        P && (m.set(_, x), a(x, _, u, p, m), m.delete(_)), go(t, s, x);
      }
      function Mu(t, n) {
        var s = t.length;
        if (s)
          return n += n < 0 ? s : 0, en(n, s) ? t[n] : e;
      }
      function Uu(t, n, s) {
        n.length ? n = de(n, function(p) {
          return z(p) ? function(m) {
            return Wn(m, p.length === 1 ? p[0] : p);
          } : p;
        }) : n = [Ze];
        var u = -1;
        n = de(n, st(q()));
        var a = ku(t, function(p, m, d) {
          var _ = de(n, function(E) {
            return E(p);
          });
          return { criteria: _, index: ++u, value: p };
        });
        return Nh(a, function(p, m) {
          return ym(p, m, s);
        });
      }
      function sm(t, n) {
        return Fu(t, n, function(s, u) {
          return Xo(t, u);
        });
      }
      function Fu(t, n, s) {
        for (var u = -1, a = n.length, p = {}; ++u < a; ) {
          var m = n[u], d = Wn(t, m);
          s(d, m) && Fr(p, _n(m, t), d);
        }
        return p;
      }
      function om(t) {
        return function(n) {
          return Wn(n, t);
        };
      }
      function To(t, n, s, u) {
        var a = u ? Ph : nr, p = -1, m = n.length, d = t;
        for (t === n && (n = ze(n)), s && (d = de(t, st(s))); ++p < m; )
          for (var _ = 0, E = n[p], x = s ? s(E) : E; (_ = a(d, x, _, u)) > -1; )
            d !== t && Di.call(d, _, 1), Di.call(t, _, 1);
        return t;
      }
      function $u(t, n) {
        for (var s = t ? n.length : 0, u = s - 1; s--; ) {
          var a = n[s];
          if (s == u || a !== p) {
            var p = a;
            en(a) ? Di.call(t, a, 1) : Ro(t, a);
          }
        }
        return t;
      }
      function Eo(t, n) {
        return t + Ei(Au() * (n - t + 1));
      }
      function cm(t, n, s, u) {
        for (var a = -1, p = Ce(Ti((n - t) / (s || 1)), 0), m = b(p); p--; )
          m[u ? p : ++a] = t, t += s;
        return m;
      }
      function xo(t, n) {
        var s = "";
        if (!t || n < 1 || n > Se)
          return s;
        do
          n % 2 && (s += t), n = Ei(n / 2), n && (t += t);
        while (n);
        return s;
      }
      function ee(t, n) {
        return Ko(dl(t, n, Ze), t + "");
      }
      function um(t) {
        return Du(mr(t));
      }
      function lm(t, n) {
        var s = mr(t);
        return Hi(s, qn(n, 0, s.length));
      }
      function Fr(t, n, s, u) {
        if (!we(t))
          return t;
        n = _n(n, t);
        for (var a = -1, p = n.length, m = p - 1, d = t; d != null && ++a < p; ) {
          var _ = St(n[a]), E = s;
          if (_ === "__proto__" || _ === "constructor" || _ === "prototype")
            return t;
          if (a != m) {
            var x = d[_];
            E = u ? u(x, _, d) : e, E === e && (E = we(x) ? x : en(n[a + 1]) ? [] : {});
          }
          Br(d, _, E), d = d[_];
        }
        return t;
      }
      var qu = xi ? function(t, n) {
        return xi.set(t, n), t;
      } : Ze, am = Ci ? function(t, n) {
        return Ci(t, "toString", {
          configurable: !0,
          enumerable: !1,
          value: ec(n),
          writable: !0
        });
      } : Ze;
      function fm(t) {
        return Hi(mr(t));
      }
      function wt(t, n, s) {
        var u = -1, a = t.length;
        n < 0 && (n = -n > a ? 0 : a + n), s = s > a ? a : s, s < 0 && (s += a), a = n > s ? 0 : s - n >>> 0, n >>>= 0;
        for (var p = b(a); ++u < a; )
          p[u] = t[u + n];
        return p;
      }
      function hm(t, n) {
        var s;
        return yn(t, function(u, a, p) {
          return s = n(u, a, p), !s;
        }), !!s;
      }
      function ki(t, n, s) {
        var u = 0, a = t == null ? u : t.length;
        if (typeof n == "number" && n === n && a <= qt) {
          for (; u < a; ) {
            var p = u + a >>> 1, m = t[p];
            m !== null && !ct(m) && (s ? m <= n : m < n) ? u = p + 1 : a = p;
          }
          return a;
        }
        return Io(t, n, Ze, s);
      }
      function Io(t, n, s, u) {
        var a = 0, p = t == null ? 0 : t.length;
        if (p === 0)
          return 0;
        n = s(n);
        for (var m = n !== n, d = n === null, _ = ct(n), E = n === e; a < p; ) {
          var x = Ei((a + p) / 2), P = s(t[x]), k = P !== e, L = P === null, H = P === P, Z = ct(P);
          if (m)
            var K = u || H;
          else
            E ? K = H && (u || k) : d ? K = H && k && (u || !L) : _ ? K = H && k && !L && (u || !Z) : L || Z ? K = !1 : K = u ? P <= n : P < n;
          K ? a = x + 1 : p = x;
        }
        return Oe(p, $t);
      }
      function Wu(t, n) {
        for (var s = -1, u = t.length, a = 0, p = []; ++s < u; ) {
          var m = t[s], d = n ? n(m) : m;
          if (!s || !Ct(d, _)) {
            var _ = d;
            p[a++] = m === 0 ? 0 : m;
          }
        }
        return p;
      }
      function Hu(t) {
        return typeof t == "number" ? t : ct(t) ? at : +t;
      }
      function ot(t) {
        if (typeof t == "string")
          return t;
        if (z(t))
          return de(t, ot) + "";
        if (ct(t))
          return vu ? vu.call(t) : "";
        var n = t + "";
        return n == "0" && 1 / t == -Ue ? "-0" : n;
      }
      function wn(t, n, s) {
        var u = -1, a = pi, p = t.length, m = !0, d = [], _ = d;
        if (s)
          m = !1, a = no;
        else if (p >= c) {
          var E = n ? null : Dm(t);
          if (E)
            return gi(E);
          m = !1, a = Rr, _ = new $n();
        } else
          _ = n ? [] : d;
        e:
          for (; ++u < p; ) {
            var x = t[u], P = n ? n(x) : x;
            if (x = s || x !== 0 ? x : 0, m && P === P) {
              for (var k = _.length; k--; )
                if (_[k] === P)
                  continue e;
              n && _.push(P), d.push(x);
            } else
              a(_, P, s) || (_ !== d && _.push(P), d.push(x));
          }
        return d;
      }
      function Ro(t, n) {
        return n = _n(n, t), t = yl(t, n), t == null || delete t[St(_t(n))];
      }
      function Ku(t, n, s, u) {
        return Fr(t, n, s(Wn(t, n)), u);
      }
      function Bi(t, n, s, u) {
        for (var a = t.length, p = u ? a : -1; (u ? p-- : ++p < a) && n(t[p], p, t); )
          ;
        return s ? wt(t, u ? 0 : p, u ? p + 1 : a) : wt(t, u ? p + 1 : 0, u ? a : p);
      }
      function Vu(t, n) {
        var s = t;
        return s instanceof re && (s = s.value()), ro(n, function(u, a) {
          return a.func.apply(a.thisArg, mn([u], a.args));
        }, s);
      }
      function Po(t, n, s) {
        var u = t.length;
        if (u < 2)
          return u ? wn(t[0]) : [];
        for (var a = -1, p = b(u); ++a < u; )
          for (var m = t[a], d = -1; ++d < u; )
            d != a && (p[a] = Lr(p[a] || m, t[d], n, s));
        return wn(Pe(p, 1), n, s);
      }
      function Gu(t, n, s) {
        for (var u = -1, a = t.length, p = n.length, m = {}; ++u < a; ) {
          var d = u < p ? n[u] : e;
          s(m, t[u], d);
        }
        return m;
      }
      function No(t) {
        return Ae(t) ? t : [];
      }
      function So(t) {
        return typeof t == "function" ? t : Ze;
      }
      function _n(t, n) {
        return z(t) ? t : qo(t, n) ? [t] : vl(ce(t));
      }
      var pm = ee;
      function An(t, n, s) {
        var u = t.length;
        return s = s === e ? u : s, !n && s >= u ? t : wt(t, n, s);
      }
      var ju = ep || function(t) {
        return Re.clearTimeout(t);
      };
      function zu(t, n) {
        if (n)
          return t.slice();
        var s = t.length, u = gu ? gu(s) : new t.constructor(s);
        return t.copy(u), u;
      }
      function Oo(t) {
        var n = new t.constructor(t.byteLength);
        return new vi(n).set(new vi(t)), n;
      }
      function mm(t, n) {
        var s = n ? Oo(t.buffer) : t.buffer;
        return new t.constructor(s, t.byteOffset, t.byteLength);
      }
      function gm(t) {
        var n = new t.constructor(t.source, Nc.exec(t));
        return n.lastIndex = t.lastIndex, n;
      }
      function dm(t) {
        return kr ? fe(kr.call(t)) : {};
      }
      function Yu(t, n) {
        var s = n ? Oo(t.buffer) : t.buffer;
        return new t.constructor(s, t.byteOffset, t.length);
      }
      function Ju(t, n) {
        if (t !== n) {
          var s = t !== e, u = t === null, a = t === t, p = ct(t), m = n !== e, d = n === null, _ = n === n, E = ct(n);
          if (!d && !E && !p && t > n || p && m && _ && !d && !E || u && m && _ || !s && _ || !a)
            return 1;
          if (!u && !p && !E && t < n || E && s && a && !u && !p || d && s && a || !m && a || !_)
            return -1;
        }
        return 0;
      }
      function ym(t, n, s) {
        for (var u = -1, a = t.criteria, p = n.criteria, m = a.length, d = s.length; ++u < m; ) {
          var _ = Ju(a[u], p[u]);
          if (_) {
            if (u >= d)
              return _;
            var E = s[u];
            return _ * (E == "desc" ? -1 : 1);
          }
        }
        return t.index - n.index;
      }
      function Zu(t, n, s, u) {
        for (var a = -1, p = t.length, m = s.length, d = -1, _ = n.length, E = Ce(p - m, 0), x = b(_ + E), P = !u; ++d < _; )
          x[d] = n[d];
        for (; ++a < m; )
          (P || a < p) && (x[s[a]] = t[a]);
        for (; E--; )
          x[d++] = t[a++];
        return x;
      }
      function Xu(t, n, s, u) {
        for (var a = -1, p = t.length, m = -1, d = s.length, _ = -1, E = n.length, x = Ce(p - d, 0), P = b(x + E), k = !u; ++a < x; )
          P[a] = t[a];
        for (var L = a; ++_ < E; )
          P[L + _] = n[_];
        for (; ++m < d; )
          (k || a < p) && (P[L + s[m]] = t[a++]);
        return P;
      }
      function ze(t, n) {
        var s = -1, u = t.length;
        for (n || (n = b(u)); ++s < u; )
          n[s] = t[s];
        return n;
      }
      function Nt(t, n, s, u) {
        var a = !s;
        s || (s = {});
        for (var p = -1, m = n.length; ++p < m; ) {
          var d = n[p], _ = u ? u(s[d], t[d], d, s, t) : e;
          _ === e && (_ = t[d]), a ? Zt(s, d, _) : Br(s, d, _);
        }
        return s;
      }
      function wm(t, n) {
        return Nt(t, $o(t), n);
      }
      function _m(t, n) {
        return Nt(t, fl(t), n);
      }
      function Li(t, n) {
        return function(s, u) {
          var a = z(s) ? Ch : qp, p = n ? n() : {};
          return a(s, t, q(u, 2), p);
        };
      }
      function ar(t) {
        return ee(function(n, s) {
          var u = -1, a = s.length, p = a > 1 ? s[a - 1] : e, m = a > 2 ? s[2] : e;
          for (p = t.length > 3 && typeof p == "function" ? (a--, p) : e, m && We(s[0], s[1], m) && (p = a < 3 ? e : p, a = 1), n = fe(n); ++u < a; ) {
            var d = s[u];
            d && t(n, d, u, p);
          }
          return n;
        });
      }
      function Qu(t, n) {
        return function(s, u) {
          if (s == null)
            return s;
          if (!Ye(s))
            return t(s, u);
          for (var a = s.length, p = n ? a : -1, m = fe(s); (n ? p-- : ++p < a) && u(m[p], p, m) !== !1; )
            ;
          return s;
        };
      }
      function el(t) {
        return function(n, s, u) {
          for (var a = -1, p = fe(n), m = u(n), d = m.length; d--; ) {
            var _ = m[t ? d : ++a];
            if (s(p[_], _, p) === !1)
              break;
          }
          return n;
        };
      }
      function Am(t, n, s) {
        var u = n & $, a = $r(t);
        function p() {
          var m = this && this !== Re && this instanceof p ? a : t;
          return m.apply(u ? s : this, arguments);
        }
        return p;
      }
      function tl(t) {
        return function(n) {
          n = ce(n);
          var s = rr(n) ? bt(n) : e, u = s ? s[0] : n.charAt(0), a = s ? An(s, 1).join("") : n.slice(1);
          return u[t]() + a;
        };
      }
      function fr(t) {
        return function(n) {
          return ro(Ql(Xl(n).replace(ah, "")), t, "");
        };
      }
      function $r(t) {
        return function() {
          var n = arguments;
          switch (n.length) {
            case 0:
              return new t();
            case 1:
              return new t(n[0]);
            case 2:
              return new t(n[0], n[1]);
            case 3:
              return new t(n[0], n[1], n[2]);
            case 4:
              return new t(n[0], n[1], n[2], n[3]);
            case 5:
              return new t(n[0], n[1], n[2], n[3], n[4]);
            case 6:
              return new t(n[0], n[1], n[2], n[3], n[4], n[5]);
            case 7:
              return new t(n[0], n[1], n[2], n[3], n[4], n[5], n[6]);
          }
          var s = lr(t.prototype), u = t.apply(s, n);
          return we(u) ? u : s;
        };
      }
      function vm(t, n, s) {
        var u = $r(t);
        function a() {
          for (var p = arguments.length, m = b(p), d = p, _ = hr(a); d--; )
            m[d] = arguments[d];
          var E = p < 3 && m[0] !== _ && m[p - 1] !== _ ? [] : gn(m, _);
          if (p -= E.length, p < s)
            return ol(
              t,
              n,
              Mi,
              a.placeholder,
              e,
              m,
              E,
              e,
              e,
              s - p
            );
          var x = this && this !== Re && this instanceof a ? u : t;
          return it(x, this, m);
        }
        return a;
      }
      function nl(t) {
        return function(n, s, u) {
          var a = fe(n);
          if (!Ye(n)) {
            var p = q(s, 3);
            n = xe(n), s = function(d) {
              return p(a[d], d, a);
            };
          }
          var m = t(n, s, u);
          return m > -1 ? a[p ? n[m] : m] : e;
        };
      }
      function rl(t) {
        return Qt(function(n) {
          var s = n.length, u = s, a = dt.prototype.thru;
          for (t && n.reverse(); u--; ) {
            var p = n[u];
            if (typeof p != "function")
              throw new gt(h);
            if (a && !m && qi(p) == "wrapper")
              var m = new dt([], !0);
          }
          for (u = m ? u : s; ++u < s; ) {
            p = n[u];
            var d = qi(p), _ = d == "wrapper" ? Uo(p) : e;
            _ && Wo(_[0]) && _[1] == (ae | Q | le | ye) && !_[4].length && _[9] == 1 ? m = m[qi(_[0])].apply(m, _[3]) : m = p.length == 1 && Wo(p) ? m[d]() : m.thru(p);
          }
          return function() {
            var E = arguments, x = E[0];
            if (m && E.length == 1 && z(x))
              return m.plant(x).value();
            for (var P = 0, k = s ? n[P].apply(this, E) : x; ++P < s; )
              k = n[P].call(this, k);
            return k;
          };
        });
      }
      function Mi(t, n, s, u, a, p, m, d, _, E) {
        var x = n & ae, P = n & $, k = n & G, L = n & (Q | he), H = n & be, Z = k ? e : $r(t);
        function K() {
          for (var te = arguments.length, ie = b(te), ut = te; ut--; )
            ie[ut] = arguments[ut];
          if (L)
            var He = hr(K), lt = Oh(ie, He);
          if (u && (ie = Zu(ie, u, a, L)), p && (ie = Xu(ie, p, m, L)), te -= lt, L && te < E) {
            var ve = gn(ie, He);
            return ol(
              t,
              n,
              Mi,
              K.placeholder,
              s,
              ie,
              ve,
              d,
              _,
              E - te
            );
          }
          var Tt = P ? s : this, rn = k ? Tt[t] : t;
          return te = ie.length, d ? ie = qm(ie, d) : H && te > 1 && ie.reverse(), x && _ < te && (ie.length = _), this && this !== Re && this instanceof K && (rn = Z || $r(rn)), rn.apply(Tt, ie);
        }
        return K;
      }
      function il(t, n) {
        return function(s, u) {
          return Yp(s, t, n(u), {});
        };
      }
      function Ui(t, n) {
        return function(s, u) {
          var a;
          if (s === e && u === e)
            return n;
          if (s !== e && (a = s), u !== e) {
            if (a === e)
              return u;
            typeof s == "string" || typeof u == "string" ? (s = ot(s), u = ot(u)) : (s = Hu(s), u = Hu(u)), a = t(s, u);
          }
          return a;
        };
      }
      function ko(t) {
        return Qt(function(n) {
          return n = de(n, st(q())), ee(function(s) {
            var u = this;
            return t(n, function(a) {
              return it(a, u, s);
            });
          });
        });
      }
      function Fi(t, n) {
        n = n === e ? " " : ot(n);
        var s = n.length;
        if (s < 2)
          return s ? xo(n, t) : n;
        var u = xo(n, Ti(t / ir(n)));
        return rr(n) ? An(bt(u), 0, t).join("") : u.slice(0, t);
      }
      function bm(t, n, s, u) {
        var a = n & $, p = $r(t);
        function m() {
          for (var d = -1, _ = arguments.length, E = -1, x = u.length, P = b(x + _), k = this && this !== Re && this instanceof m ? p : t; ++E < x; )
            P[E] = u[E];
          for (; _--; )
            P[E++] = arguments[++d];
          return it(k, a ? s : this, P);
        }
        return m;
      }
      function sl(t) {
        return function(n, s, u) {
          return u && typeof u != "number" && We(n, s, u) && (s = u = e), n = nn(n), s === e ? (s = n, n = 0) : s = nn(s), u = u === e ? n < s ? 1 : -1 : nn(u), cm(n, s, u, t);
        };
      }
      function $i(t) {
        return function(n, s) {
          return typeof n == "string" && typeof s == "string" || (n = At(n), s = At(s)), t(n, s);
        };
      }
      function ol(t, n, s, u, a, p, m, d, _, E) {
        var x = n & Q, P = x ? m : e, k = x ? e : m, L = x ? p : e, H = x ? e : p;
        n |= x ? le : ge, n &= ~(x ? ge : le), n & ne || (n &= ~($ | G));
        var Z = [
          t,
          n,
          a,
          L,
          P,
          H,
          k,
          d,
          _,
          E
        ], K = s.apply(e, Z);
        return Wo(t) && wl(K, Z), K.placeholder = u, _l(K, t, n);
      }
      function Bo(t) {
        var n = De[t];
        return function(s, u) {
          if (s = At(s), u = u == null ? 0 : Oe(Y(u), 292), u && _u(s)) {
            var a = (ce(s) + "e").split("e"), p = n(a[0] + "e" + (+a[1] + u));
            return a = (ce(p) + "e").split("e"), +(a[0] + "e" + (+a[1] - u));
          }
          return n(s);
        };
      }
      var Dm = cr && 1 / gi(new cr([, -0]))[1] == Ue ? function(t) {
        return new cr(t);
      } : rc;
      function cl(t) {
        return function(n) {
          var s = ke(n);
          return s == Ie ? ao(n) : s == $e ? $h(n) : Sh(n, t(n));
        };
      }
      function Xt(t, n, s, u, a, p, m, d) {
        var _ = n & G;
        if (!_ && typeof t != "function")
          throw new gt(h);
        var E = u ? u.length : 0;
        if (E || (n &= ~(le | ge), u = a = e), m = m === e ? m : Ce(Y(m), 0), d = d === e ? d : Y(d), E -= a ? a.length : 0, n & ge) {
          var x = u, P = a;
          u = a = e;
        }
        var k = _ ? e : Uo(t), L = [
          t,
          n,
          s,
          u,
          a,
          x,
          P,
          p,
          m,
          d
        ];
        if (k && Um(L, k), t = L[0], n = L[1], s = L[2], u = L[3], a = L[4], d = L[9] = L[9] === e ? _ ? 0 : t.length : Ce(L[9] - E, 0), !d && n & (Q | he) && (n &= ~(Q | he)), !n || n == $)
          var H = Am(t, n, s);
        else
          n == Q || n == he ? H = vm(t, n, d) : (n == le || n == ($ | le)) && !a.length ? H = bm(t, n, s, u) : H = Mi.apply(e, L);
        var Z = k ? qu : wl;
        return _l(Z(H, L), t, n);
      }
      function ul(t, n, s, u) {
        return t === e || Ct(t, or[s]) && !ue.call(u, s) ? n : t;
      }
      function ll(t, n, s, u, a, p) {
        return we(t) && we(n) && (p.set(n, t), Oi(t, n, e, ll, p), p.delete(n)), t;
      }
      function Cm(t) {
        return Hr(t) ? e : t;
      }
      function al(t, n, s, u, a, p) {
        var m = s & R, d = t.length, _ = n.length;
        if (d != _ && !(m && _ > d))
          return !1;
        var E = p.get(t), x = p.get(n);
        if (E && x)
          return E == n && x == t;
        var P = -1, k = !0, L = s & O ? new $n() : e;
        for (p.set(t, n), p.set(n, t); ++P < d; ) {
          var H = t[P], Z = n[P];
          if (u)
            var K = m ? u(Z, H, P, n, t, p) : u(H, Z, P, t, n, p);
          if (K !== e) {
            if (K)
              continue;
            k = !1;
            break;
          }
          if (L) {
            if (!io(n, function(te, ie) {
              if (!Rr(L, ie) && (H === te || a(H, te, s, u, p)))
                return L.push(ie);
            })) {
              k = !1;
              break;
            }
          } else if (!(H === Z || a(H, Z, s, u, p))) {
            k = !1;
            break;
          }
        }
        return p.delete(t), p.delete(n), k;
      }
      function Tm(t, n, s, u, a, p, m) {
        switch (s) {
          case Rt:
            if (t.byteLength != n.byteLength || t.byteOffset != n.byteOffset)
              return !1;
            t = t.buffer, n = n.buffer;
          case zt:
            return !(t.byteLength != n.byteLength || !p(new vi(t), new vi(n)));
          case nt:
          case rt:
          case vt:
            return Ct(+t, +n);
          case ht:
            return t.name == n.name && t.message == n.message;
          case Vt:
          case Gt:
            return t == n + "";
          case Ie:
            var d = ao;
          case $e:
            var _ = u & R;
            if (d || (d = gi), t.size != n.size && !_)
              return !1;
            var E = m.get(t);
            if (E)
              return E == n;
            u |= O, m.set(t, n);
            var x = al(d(t), d(n), u, a, p, m);
            return m.delete(t), x;
          case hn:
            if (kr)
              return kr.call(t) == kr.call(n);
        }
        return !1;
      }
      function Em(t, n, s, u, a, p) {
        var m = s & R, d = Lo(t), _ = d.length, E = Lo(n), x = E.length;
        if (_ != x && !m)
          return !1;
        for (var P = _; P--; ) {
          var k = d[P];
          if (!(m ? k in n : ue.call(n, k)))
            return !1;
        }
        var L = p.get(t), H = p.get(n);
        if (L && H)
          return L == n && H == t;
        var Z = !0;
        p.set(t, n), p.set(n, t);
        for (var K = m; ++P < _; ) {
          k = d[P];
          var te = t[k], ie = n[k];
          if (u)
            var ut = m ? u(ie, te, k, n, t, p) : u(te, ie, k, t, n, p);
          if (!(ut === e ? te === ie || a(te, ie, s, u, p) : ut)) {
            Z = !1;
            break;
          }
          K || (K = k == "constructor");
        }
        if (Z && !K) {
          var He = t.constructor, lt = n.constructor;
          He != lt && "constructor" in t && "constructor" in n && !(typeof He == "function" && He instanceof He && typeof lt == "function" && lt instanceof lt) && (Z = !1);
        }
        return p.delete(t), p.delete(n), Z;
      }
      function Qt(t) {
        return Ko(dl(t, e, Tl), t + "");
      }
      function Lo(t) {
        return Pu(t, xe, $o);
      }
      function Mo(t) {
        return Pu(t, Je, fl);
      }
      var Uo = xi ? function(t) {
        return xi.get(t);
      } : rc;
      function qi(t) {
        for (var n = t.name + "", s = ur[n], u = ue.call(ur, n) ? s.length : 0; u--; ) {
          var a = s[u], p = a.func;
          if (p == null || p == t)
            return a.name;
        }
        return n;
      }
      function hr(t) {
        var n = ue.call(f, "placeholder") ? f : t;
        return n.placeholder;
      }
      function q() {
        var t = f.iteratee || tc;
        return t = t === tc ? Ou : t, arguments.length ? t(arguments[0], arguments[1]) : t;
      }
      function Wi(t, n) {
        var s = t.__data__;
        return km(n) ? s[typeof n == "string" ? "string" : "hash"] : s.map;
      }
      function Fo(t) {
        for (var n = xe(t), s = n.length; s--; ) {
          var u = n[s], a = t[u];
          n[s] = [u, a, ml(a)];
        }
        return n;
      }
      function Hn(t, n) {
        var s = Mh(t, n);
        return Su(s) ? s : e;
      }
      function xm(t) {
        var n = ue.call(t, Un), s = t[Un];
        try {
          t[Un] = e;
          var u = !0;
        } catch {
        }
        var a = _i.call(t);
        return u && (n ? t[Un] = s : delete t[Un]), a;
      }
      var $o = ho ? function(t) {
        return t == null ? [] : (t = fe(t), pn(ho(t), function(n) {
          return yu.call(t, n);
        }));
      } : ic, fl = ho ? function(t) {
        for (var n = []; t; )
          mn(n, $o(t)), t = bi(t);
        return n;
      } : ic, ke = qe;
      (po && ke(new po(new ArrayBuffer(1))) != Rt || Nr && ke(new Nr()) != Ie || mo && ke(mo.resolve()) != fn || cr && ke(new cr()) != $e || Sr && ke(new Sr()) != jt) && (ke = function(t) {
        var n = qe(t), s = n == Fe ? t.constructor : e, u = s ? Kn(s) : "";
        if (u)
          switch (u) {
            case lp:
              return Rt;
            case ap:
              return Ie;
            case fp:
              return fn;
            case hp:
              return $e;
            case pp:
              return jt;
          }
        return n;
      });
      function Im(t, n, s) {
        for (var u = -1, a = s.length; ++u < a; ) {
          var p = s[u], m = p.size;
          switch (p.type) {
            case "drop":
              t += m;
              break;
            case "dropRight":
              n -= m;
              break;
            case "take":
              n = Oe(n, t + m);
              break;
            case "takeRight":
              t = Ce(t, n - m);
              break;
          }
        }
        return { start: t, end: n };
      }
      function Rm(t) {
        var n = t.match(Bf);
        return n ? n[1].split(Lf) : [];
      }
      function hl(t, n, s) {
        n = _n(n, t);
        for (var u = -1, a = n.length, p = !1; ++u < a; ) {
          var m = St(n[u]);
          if (!(p = t != null && s(t, m)))
            break;
          t = t[m];
        }
        return p || ++u != a ? p : (a = t == null ? 0 : t.length, !!a && Yi(a) && en(m, a) && (z(t) || Vn(t)));
      }
      function Pm(t) {
        var n = t.length, s = new t.constructor(n);
        return n && typeof t[0] == "string" && ue.call(t, "index") && (s.index = t.index, s.input = t.input), s;
      }
      function pl(t) {
        return typeof t.constructor == "function" && !qr(t) ? lr(bi(t)) : {};
      }
      function Nm(t, n, s) {
        var u = t.constructor;
        switch (n) {
          case zt:
            return Oo(t);
          case nt:
          case rt:
            return new u(+t);
          case Rt:
            return mm(t, s);
          case In:
          case Rn:
          case Pn:
          case Nn:
          case Sn:
          case On:
          case kn:
          case Bn:
          case Ln:
            return Yu(t, s);
          case Ie:
            return new u();
          case vt:
          case Gt:
            return new u(t);
          case Vt:
            return gm(t);
          case $e:
            return new u();
          case hn:
            return dm(t);
        }
      }
      function Sm(t, n) {
        var s = n.length;
        if (!s)
          return t;
        var u = s - 1;
        return n[u] = (s > 1 ? "& " : "") + n[u], n = n.join(s > 2 ? ", " : " "), t.replace(kf, `{
/* [wrapped with ` + n + `] */
`);
      }
      function Om(t) {
        return z(t) || Vn(t) || !!(wu && t && t[wu]);
      }
      function en(t, n) {
        var s = typeof t;
        return n = n ?? Se, !!n && (s == "number" || s != "symbol" && Vf.test(t)) && t > -1 && t % 1 == 0 && t < n;
      }
      function We(t, n, s) {
        if (!we(s))
          return !1;
        var u = typeof n;
        return (u == "number" ? Ye(s) && en(n, s.length) : u == "string" && n in s) ? Ct(s[n], t) : !1;
      }
      function qo(t, n) {
        if (z(t))
          return !1;
        var s = typeof t;
        return s == "number" || s == "symbol" || s == "boolean" || t == null || ct(t) ? !0 : Pf.test(t) || !Rf.test(t) || n != null && t in fe(n);
      }
      function km(t) {
        var n = typeof t;
        return n == "string" || n == "number" || n == "symbol" || n == "boolean" ? t !== "__proto__" : t === null;
      }
      function Wo(t) {
        var n = qi(t), s = f[n];
        if (typeof s != "function" || !(n in re.prototype))
          return !1;
        if (t === s)
          return !0;
        var u = Uo(s);
        return !!u && t === u[0];
      }
      function Bm(t) {
        return !!mu && mu in t;
      }
      var Lm = yi ? tn : sc;
      function qr(t) {
        var n = t && t.constructor, s = typeof n == "function" && n.prototype || or;
        return t === s;
      }
      function ml(t) {
        return t === t && !we(t);
      }
      function gl(t, n) {
        return function(s) {
          return s == null ? !1 : s[t] === n && (n !== e || t in fe(s));
        };
      }
      function Mm(t) {
        var n = ji(t, function(u) {
          return s.size === A && s.clear(), u;
        }), s = n.cache;
        return n;
      }
      function Um(t, n) {
        var s = t[1], u = n[1], a = s | u, p = a < ($ | G | ae), m = u == ae && s == Q || u == ae && s == ye && t[7].length <= n[8] || u == (ae | ye) && n[7].length <= n[8] && s == Q;
        if (!(p || m))
          return t;
        u & $ && (t[2] = n[2], a |= s & $ ? 0 : ne);
        var d = n[3];
        if (d) {
          var _ = t[3];
          t[3] = _ ? Zu(_, d, n[4]) : d, t[4] = _ ? gn(t[3], D) : n[4];
        }
        return d = n[5], d && (_ = t[5], t[5] = _ ? Xu(_, d, n[6]) : d, t[6] = _ ? gn(t[5], D) : n[6]), d = n[7], d && (t[7] = d), u & ae && (t[8] = t[8] == null ? n[8] : Oe(t[8], n[8])), t[9] == null && (t[9] = n[9]), t[0] = n[0], t[1] = a, t;
      }
      function Fm(t) {
        var n = [];
        if (t != null)
          for (var s in fe(t))
            n.push(s);
        return n;
      }
      function $m(t) {
        return _i.call(t);
      }
      function dl(t, n, s) {
        return n = Ce(n === e ? t.length - 1 : n, 0), function() {
          for (var u = arguments, a = -1, p = Ce(u.length - n, 0), m = b(p); ++a < p; )
            m[a] = u[n + a];
          a = -1;
          for (var d = b(n + 1); ++a < n; )
            d[a] = u[a];
          return d[n] = s(m), it(t, this, d);
        };
      }
      function yl(t, n) {
        return n.length < 2 ? t : Wn(t, wt(n, 0, -1));
      }
      function qm(t, n) {
        for (var s = t.length, u = Oe(n.length, s), a = ze(t); u--; ) {
          var p = n[u];
          t[u] = en(p, s) ? a[p] : e;
        }
        return t;
      }
      function Ho(t, n) {
        if (!(n === "constructor" && typeof t[n] == "function") && n != "__proto__")
          return t[n];
      }
      var wl = Al(qu), Wr = np || function(t, n) {
        return Re.setTimeout(t, n);
      }, Ko = Al(am);
      function _l(t, n, s) {
        var u = n + "";
        return Ko(t, Sm(u, Wm(Rm(u), s)));
      }
      function Al(t) {
        var n = 0, s = 0;
        return function() {
          var u = op(), a = tt - (u - s);
          if (s = u, a > 0) {
            if (++n >= et)
              return arguments[0];
          } else
            n = 0;
          return t.apply(e, arguments);
        };
      }
      function Hi(t, n) {
        var s = -1, u = t.length, a = u - 1;
        for (n = n === e ? u : n; ++s < n; ) {
          var p = Eo(s, a), m = t[p];
          t[p] = t[s], t[s] = m;
        }
        return t.length = n, t;
      }
      var vl = Mm(function(t) {
        var n = [];
        return t.charCodeAt(0) === 46 && n.push(""), t.replace(Nf, function(s, u, a, p) {
          n.push(a ? p.replace(Ff, "$1") : u || s);
        }), n;
      });
      function St(t) {
        if (typeof t == "string" || ct(t))
          return t;
        var n = t + "";
        return n == "0" && 1 / t == -Ue ? "-0" : n;
      }
      function Kn(t) {
        if (t != null) {
          try {
            return wi.call(t);
          } catch {
          }
          try {
            return t + "";
          } catch {
          }
        }
        return "";
      }
      function Wm(t, n) {
        return mt(Wt, function(s) {
          var u = "_." + s[0];
          n & s[1] && !pi(t, u) && t.push(u);
        }), t.sort();
      }
      function bl(t) {
        if (t instanceof re)
          return t.clone();
        var n = new dt(t.__wrapped__, t.__chain__);
        return n.__actions__ = ze(t.__actions__), n.__index__ = t.__index__, n.__values__ = t.__values__, n;
      }
      function Hm(t, n, s) {
        (s ? We(t, n, s) : n === e) ? n = 1 : n = Ce(Y(n), 0);
        var u = t == null ? 0 : t.length;
        if (!u || n < 1)
          return [];
        for (var a = 0, p = 0, m = b(Ti(u / n)); a < u; )
          m[p++] = wt(t, a, a += n);
        return m;
      }
      function Km(t) {
        for (var n = -1, s = t == null ? 0 : t.length, u = 0, a = []; ++n < s; ) {
          var p = t[n];
          p && (a[u++] = p);
        }
        return a;
      }
      function Vm() {
        var t = arguments.length;
        if (!t)
          return [];
        for (var n = b(t - 1), s = arguments[0], u = t; u--; )
          n[u - 1] = arguments[u];
        return mn(z(s) ? ze(s) : [s], Pe(n, 1));
      }
      var Gm = ee(function(t, n) {
        return Ae(t) ? Lr(t, Pe(n, 1, Ae, !0)) : [];
      }), jm = ee(function(t, n) {
        var s = _t(n);
        return Ae(s) && (s = e), Ae(t) ? Lr(t, Pe(n, 1, Ae, !0), q(s, 2)) : [];
      }), zm = ee(function(t, n) {
        var s = _t(n);
        return Ae(s) && (s = e), Ae(t) ? Lr(t, Pe(n, 1, Ae, !0), e, s) : [];
      });
      function Ym(t, n, s) {
        var u = t == null ? 0 : t.length;
        return u ? (n = s || n === e ? 1 : Y(n), wt(t, n < 0 ? 0 : n, u)) : [];
      }
      function Jm(t, n, s) {
        var u = t == null ? 0 : t.length;
        return u ? (n = s || n === e ? 1 : Y(n), n = u - n, wt(t, 0, n < 0 ? 0 : n)) : [];
      }
      function Zm(t, n) {
        return t && t.length ? Bi(t, q(n, 3), !0, !0) : [];
      }
      function Xm(t, n) {
        return t && t.length ? Bi(t, q(n, 3), !0) : [];
      }
      function Qm(t, n, s, u) {
        var a = t == null ? 0 : t.length;
        return a ? (s && typeof s != "number" && We(t, n, s) && (s = 0, u = a), Vp(t, n, s, u)) : [];
      }
      function Dl(t, n, s) {
        var u = t == null ? 0 : t.length;
        if (!u)
          return -1;
        var a = s == null ? 0 : Y(s);
        return a < 0 && (a = Ce(u + a, 0)), mi(t, q(n, 3), a);
      }
      function Cl(t, n, s) {
        var u = t == null ? 0 : t.length;
        if (!u)
          return -1;
        var a = u - 1;
        return s !== e && (a = Y(s), a = s < 0 ? Ce(u + a, 0) : Oe(a, u - 1)), mi(t, q(n, 3), a, !0);
      }
      function Tl(t) {
        var n = t == null ? 0 : t.length;
        return n ? Pe(t, 1) : [];
      }
      function eg(t) {
        var n = t == null ? 0 : t.length;
        return n ? Pe(t, Ue) : [];
      }
      function tg(t, n) {
        var s = t == null ? 0 : t.length;
        return s ? (n = n === e ? 1 : Y(n), Pe(t, n)) : [];
      }
      function ng(t) {
        for (var n = -1, s = t == null ? 0 : t.length, u = {}; ++n < s; ) {
          var a = t[n];
          u[a[0]] = a[1];
        }
        return u;
      }
      function El(t) {
        return t && t.length ? t[0] : e;
      }
      function rg(t, n, s) {
        var u = t == null ? 0 : t.length;
        if (!u)
          return -1;
        var a = s == null ? 0 : Y(s);
        return a < 0 && (a = Ce(u + a, 0)), nr(t, n, a);
      }
      function ig(t) {
        var n = t == null ? 0 : t.length;
        return n ? wt(t, 0, -1) : [];
      }
      var sg = ee(function(t) {
        var n = de(t, No);
        return n.length && n[0] === t[0] ? vo(n) : [];
      }), og = ee(function(t) {
        var n = _t(t), s = de(t, No);
        return n === _t(s) ? n = e : s.pop(), s.length && s[0] === t[0] ? vo(s, q(n, 2)) : [];
      }), cg = ee(function(t) {
        var n = _t(t), s = de(t, No);
        return n = typeof n == "function" ? n : e, n && s.pop(), s.length && s[0] === t[0] ? vo(s, e, n) : [];
      });
      function ug(t, n) {
        return t == null ? "" : ip.call(t, n);
      }
      function _t(t) {
        var n = t == null ? 0 : t.length;
        return n ? t[n - 1] : e;
      }
      function lg(t, n, s) {
        var u = t == null ? 0 : t.length;
        if (!u)
          return -1;
        var a = u;
        return s !== e && (a = Y(s), a = a < 0 ? Ce(u + a, 0) : Oe(a, u - 1)), n === n ? Wh(t, n, a) : mi(t, ou, a, !0);
      }
      function ag(t, n) {
        return t && t.length ? Mu(t, Y(n)) : e;
      }
      var fg = ee(xl);
      function xl(t, n) {
        return t && t.length && n && n.length ? To(t, n) : t;
      }
      function hg(t, n, s) {
        return t && t.length && n && n.length ? To(t, n, q(s, 2)) : t;
      }
      function pg(t, n, s) {
        return t && t.length && n && n.length ? To(t, n, e, s) : t;
      }
      var mg = Qt(function(t, n) {
        var s = t == null ? 0 : t.length, u = yo(t, n);
        return $u(t, de(n, function(a) {
          return en(a, s) ? +a : a;
        }).sort(Ju)), u;
      });
      function gg(t, n) {
        var s = [];
        if (!(t && t.length))
          return s;
        var u = -1, a = [], p = t.length;
        for (n = q(n, 3); ++u < p; ) {
          var m = t[u];
          n(m, u, t) && (s.push(m), a.push(u));
        }
        return $u(t, a), s;
      }
      function Vo(t) {
        return t == null ? t : up.call(t);
      }
      function dg(t, n, s) {
        var u = t == null ? 0 : t.length;
        return u ? (s && typeof s != "number" && We(t, n, s) ? (n = 0, s = u) : (n = n == null ? 0 : Y(n), s = s === e ? u : Y(s)), wt(t, n, s)) : [];
      }
      function yg(t, n) {
        return ki(t, n);
      }
      function wg(t, n, s) {
        return Io(t, n, q(s, 2));
      }
      function _g(t, n) {
        var s = t == null ? 0 : t.length;
        if (s) {
          var u = ki(t, n);
          if (u < s && Ct(t[u], n))
            return u;
        }
        return -1;
      }
      function Ag(t, n) {
        return ki(t, n, !0);
      }
      function vg(t, n, s) {
        return Io(t, n, q(s, 2), !0);
      }
      function bg(t, n) {
        var s = t == null ? 0 : t.length;
        if (s) {
          var u = ki(t, n, !0) - 1;
          if (Ct(t[u], n))
            return u;
        }
        return -1;
      }
      function Dg(t) {
        return t && t.length ? Wu(t) : [];
      }
      function Cg(t, n) {
        return t && t.length ? Wu(t, q(n, 2)) : [];
      }
      function Tg(t) {
        var n = t == null ? 0 : t.length;
        return n ? wt(t, 1, n) : [];
      }
      function Eg(t, n, s) {
        return t && t.length ? (n = s || n === e ? 1 : Y(n), wt(t, 0, n < 0 ? 0 : n)) : [];
      }
      function xg(t, n, s) {
        var u = t == null ? 0 : t.length;
        return u ? (n = s || n === e ? 1 : Y(n), n = u - n, wt(t, n < 0 ? 0 : n, u)) : [];
      }
      function Ig(t, n) {
        return t && t.length ? Bi(t, q(n, 3), !1, !0) : [];
      }
      function Rg(t, n) {
        return t && t.length ? Bi(t, q(n, 3)) : [];
      }
      var Pg = ee(function(t) {
        return wn(Pe(t, 1, Ae, !0));
      }), Ng = ee(function(t) {
        var n = _t(t);
        return Ae(n) && (n = e), wn(Pe(t, 1, Ae, !0), q(n, 2));
      }), Sg = ee(function(t) {
        var n = _t(t);
        return n = typeof n == "function" ? n : e, wn(Pe(t, 1, Ae, !0), e, n);
      });
      function Og(t) {
        return t && t.length ? wn(t) : [];
      }
      function kg(t, n) {
        return t && t.length ? wn(t, q(n, 2)) : [];
      }
      function Bg(t, n) {
        return n = typeof n == "function" ? n : e, t && t.length ? wn(t, e, n) : [];
      }
      function Go(t) {
        if (!(t && t.length))
          return [];
        var n = 0;
        return t = pn(t, function(s) {
          if (Ae(s))
            return n = Ce(s.length, n), !0;
        }), uo(n, function(s) {
          return de(t, so(s));
        });
      }
      function Il(t, n) {
        if (!(t && t.length))
          return [];
        var s = Go(t);
        return n == null ? s : de(s, function(u) {
          return it(n, e, u);
        });
      }
      var Lg = ee(function(t, n) {
        return Ae(t) ? Lr(t, n) : [];
      }), Mg = ee(function(t) {
        return Po(pn(t, Ae));
      }), Ug = ee(function(t) {
        var n = _t(t);
        return Ae(n) && (n = e), Po(pn(t, Ae), q(n, 2));
      }), Fg = ee(function(t) {
        var n = _t(t);
        return n = typeof n == "function" ? n : e, Po(pn(t, Ae), e, n);
      }), $g = ee(Go);
      function qg(t, n) {
        return Gu(t || [], n || [], Br);
      }
      function Wg(t, n) {
        return Gu(t || [], n || [], Fr);
      }
      var Hg = ee(function(t) {
        var n = t.length, s = n > 1 ? t[n - 1] : e;
        return s = typeof s == "function" ? (t.pop(), s) : e, Il(t, s);
      });
      function Rl(t) {
        var n = f(t);
        return n.__chain__ = !0, n;
      }
      function Kg(t, n) {
        return n(t), t;
      }
      function Ki(t, n) {
        return n(t);
      }
      var Vg = Qt(function(t) {
        var n = t.length, s = n ? t[0] : 0, u = this.__wrapped__, a = function(p) {
          return yo(p, t);
        };
        return n > 1 || this.__actions__.length || !(u instanceof re) || !en(s) ? this.thru(a) : (u = u.slice(s, +s + (n ? 1 : 0)), u.__actions__.push({
          func: Ki,
          args: [a],
          thisArg: e
        }), new dt(u, this.__chain__).thru(function(p) {
          return n && !p.length && p.push(e), p;
        }));
      });
      function Gg() {
        return Rl(this);
      }
      function jg() {
        return new dt(this.value(), this.__chain__);
      }
      function zg() {
        this.__values__ === e && (this.__values__ = Hl(this.value()));
        var t = this.__index__ >= this.__values__.length, n = t ? e : this.__values__[this.__index__++];
        return { done: t, value: n };
      }
      function Yg() {
        return this;
      }
      function Jg(t) {
        for (var n, s = this; s instanceof Ri; ) {
          var u = bl(s);
          u.__index__ = 0, u.__values__ = e, n ? a.__wrapped__ = u : n = u;
          var a = u;
          s = s.__wrapped__;
        }
        return a.__wrapped__ = t, n;
      }
      function Zg() {
        var t = this.__wrapped__;
        if (t instanceof re) {
          var n = t;
          return this.__actions__.length && (n = new re(this)), n = n.reverse(), n.__actions__.push({
            func: Ki,
            args: [Vo],
            thisArg: e
          }), new dt(n, this.__chain__);
        }
        return this.thru(Vo);
      }
      function Xg() {
        return Vu(this.__wrapped__, this.__actions__);
      }
      var Qg = Li(function(t, n, s) {
        ue.call(t, s) ? ++t[s] : Zt(t, s, 1);
      });
      function ed(t, n, s) {
        var u = z(t) ? iu : Kp;
        return s && We(t, n, s) && (n = e), u(t, q(n, 3));
      }
      function td(t, n) {
        var s = z(t) ? pn : Iu;
        return s(t, q(n, 3));
      }
      var nd = nl(Dl), rd = nl(Cl);
      function id(t, n) {
        return Pe(Vi(t, n), 1);
      }
      function sd(t, n) {
        return Pe(Vi(t, n), Ue);
      }
      function od(t, n, s) {
        return s = s === e ? 1 : Y(s), Pe(Vi(t, n), s);
      }
      function Pl(t, n) {
        var s = z(t) ? mt : yn;
        return s(t, q(n, 3));
      }
      function Nl(t, n) {
        var s = z(t) ? Th : xu;
        return s(t, q(n, 3));
      }
      var cd = Li(function(t, n, s) {
        ue.call(t, s) ? t[s].push(n) : Zt(t, s, [n]);
      });
      function ud(t, n, s, u) {
        t = Ye(t) ? t : mr(t), s = s && !u ? Y(s) : 0;
        var a = t.length;
        return s < 0 && (s = Ce(a + s, 0)), Ji(t) ? s <= a && t.indexOf(n, s) > -1 : !!a && nr(t, n, s) > -1;
      }
      var ld = ee(function(t, n, s) {
        var u = -1, a = typeof n == "function", p = Ye(t) ? b(t.length) : [];
        return yn(t, function(m) {
          p[++u] = a ? it(n, m, s) : Mr(m, n, s);
        }), p;
      }), ad = Li(function(t, n, s) {
        Zt(t, s, n);
      });
      function Vi(t, n) {
        var s = z(t) ? de : ku;
        return s(t, q(n, 3));
      }
      function fd(t, n, s, u) {
        return t == null ? [] : (z(n) || (n = n == null ? [] : [n]), s = u ? e : s, z(s) || (s = s == null ? [] : [s]), Uu(t, n, s));
      }
      var hd = Li(function(t, n, s) {
        t[s ? 0 : 1].push(n);
      }, function() {
        return [[], []];
      });
      function pd(t, n, s) {
        var u = z(t) ? ro : uu, a = arguments.length < 3;
        return u(t, q(n, 4), s, a, yn);
      }
      function md(t, n, s) {
        var u = z(t) ? Eh : uu, a = arguments.length < 3;
        return u(t, q(n, 4), s, a, xu);
      }
      function gd(t, n) {
        var s = z(t) ? pn : Iu;
        return s(t, zi(q(n, 3)));
      }
      function dd(t) {
        var n = z(t) ? Du : um;
        return n(t);
      }
      function yd(t, n, s) {
        (s ? We(t, n, s) : n === e) ? n = 1 : n = Y(n);
        var u = z(t) ? Fp : lm;
        return u(t, n);
      }
      function wd(t) {
        var n = z(t) ? $p : fm;
        return n(t);
      }
      function _d(t) {
        if (t == null)
          return 0;
        if (Ye(t))
          return Ji(t) ? ir(t) : t.length;
        var n = ke(t);
        return n == Ie || n == $e ? t.size : Do(t).length;
      }
      function Ad(t, n, s) {
        var u = z(t) ? io : hm;
        return s && We(t, n, s) && (n = e), u(t, q(n, 3));
      }
      var vd = ee(function(t, n) {
        if (t == null)
          return [];
        var s = n.length;
        return s > 1 && We(t, n[0], n[1]) ? n = [] : s > 2 && We(n[0], n[1], n[2]) && (n = [n[0]]), Uu(t, Pe(n, 1), []);
      }), Gi = tp || function() {
        return Re.Date.now();
      };
      function bd(t, n) {
        if (typeof n != "function")
          throw new gt(h);
        return t = Y(t), function() {
          if (--t < 1)
            return n.apply(this, arguments);
        };
      }
      function Sl(t, n, s) {
        return n = s ? e : n, n = t && n == null ? t.length : n, Xt(t, ae, e, e, e, e, n);
      }
      function Ol(t, n) {
        var s;
        if (typeof n != "function")
          throw new gt(h);
        return t = Y(t), function() {
          return --t > 0 && (s = n.apply(this, arguments)), t <= 1 && (n = e), s;
        };
      }
      var jo = ee(function(t, n, s) {
        var u = $;
        if (s.length) {
          var a = gn(s, hr(jo));
          u |= le;
        }
        return Xt(t, u, n, s, a);
      }), kl = ee(function(t, n, s) {
        var u = $ | G;
        if (s.length) {
          var a = gn(s, hr(kl));
          u |= le;
        }
        return Xt(n, u, t, s, a);
      });
      function Bl(t, n, s) {
        n = s ? e : n;
        var u = Xt(t, Q, e, e, e, e, e, n);
        return u.placeholder = Bl.placeholder, u;
      }
      function Ll(t, n, s) {
        n = s ? e : n;
        var u = Xt(t, he, e, e, e, e, e, n);
        return u.placeholder = Ll.placeholder, u;
      }
      function Ml(t, n, s) {
        var u, a, p, m, d, _, E = 0, x = !1, P = !1, k = !0;
        if (typeof t != "function")
          throw new gt(h);
        n = At(n) || 0, we(s) && (x = !!s.leading, P = "maxWait" in s, p = P ? Ce(At(s.maxWait) || 0, n) : p, k = "trailing" in s ? !!s.trailing : k);
        function L(ve) {
          var Tt = u, rn = a;
          return u = a = e, E = ve, m = t.apply(rn, Tt), m;
        }
        function H(ve) {
          return E = ve, d = Wr(te, n), x ? L(ve) : m;
        }
        function Z(ve) {
          var Tt = ve - _, rn = ve - E, na = n - Tt;
          return P ? Oe(na, p - rn) : na;
        }
        function K(ve) {
          var Tt = ve - _, rn = ve - E;
          return _ === e || Tt >= n || Tt < 0 || P && rn >= p;
        }
        function te() {
          var ve = Gi();
          if (K(ve))
            return ie(ve);
          d = Wr(te, Z(ve));
        }
        function ie(ve) {
          return d = e, k && u ? L(ve) : (u = a = e, m);
        }
        function ut() {
          d !== e && ju(d), E = 0, u = _ = a = d = e;
        }
        function He() {
          return d === e ? m : ie(Gi());
        }
        function lt() {
          var ve = Gi(), Tt = K(ve);
          if (u = arguments, a = this, _ = ve, Tt) {
            if (d === e)
              return H(_);
            if (P)
              return ju(d), d = Wr(te, n), L(_);
          }
          return d === e && (d = Wr(te, n)), m;
        }
        return lt.cancel = ut, lt.flush = He, lt;
      }
      var Dd = ee(function(t, n) {
        return Eu(t, 1, n);
      }), Cd = ee(function(t, n, s) {
        return Eu(t, At(n) || 0, s);
      });
      function Td(t) {
        return Xt(t, be);
      }
      function ji(t, n) {
        if (typeof t != "function" || n != null && typeof n != "function")
          throw new gt(h);
        var s = function() {
          var u = arguments, a = n ? n.apply(this, u) : u[0], p = s.cache;
          if (p.has(a))
            return p.get(a);
          var m = t.apply(this, u);
          return s.cache = p.set(a, m) || p, m;
        };
        return s.cache = new (ji.Cache || Jt)(), s;
      }
      ji.Cache = Jt;
      function zi(t) {
        if (typeof t != "function")
          throw new gt(h);
        return function() {
          var n = arguments;
          switch (n.length) {
            case 0:
              return !t.call(this);
            case 1:
              return !t.call(this, n[0]);
            case 2:
              return !t.call(this, n[0], n[1]);
            case 3:
              return !t.call(this, n[0], n[1], n[2]);
          }
          return !t.apply(this, n);
        };
      }
      function Ed(t) {
        return Ol(2, t);
      }
      var xd = pm(function(t, n) {
        n = n.length == 1 && z(n[0]) ? de(n[0], st(q())) : de(Pe(n, 1), st(q()));
        var s = n.length;
        return ee(function(u) {
          for (var a = -1, p = Oe(u.length, s); ++a < p; )
            u[a] = n[a].call(this, u[a]);
          return it(t, this, u);
        });
      }), zo = ee(function(t, n) {
        var s = gn(n, hr(zo));
        return Xt(t, le, e, n, s);
      }), Ul = ee(function(t, n) {
        var s = gn(n, hr(Ul));
        return Xt(t, ge, e, n, s);
      }), Id = Qt(function(t, n) {
        return Xt(t, ye, e, e, e, n);
      });
      function Rd(t, n) {
        if (typeof t != "function")
          throw new gt(h);
        return n = n === e ? n : Y(n), ee(t, n);
      }
      function Pd(t, n) {
        if (typeof t != "function")
          throw new gt(h);
        return n = n == null ? 0 : Ce(Y(n), 0), ee(function(s) {
          var u = s[n], a = An(s, 0, n);
          return u && mn(a, u), it(t, this, a);
        });
      }
      function Nd(t, n, s) {
        var u = !0, a = !0;
        if (typeof t != "function")
          throw new gt(h);
        return we(s) && (u = "leading" in s ? !!s.leading : u, a = "trailing" in s ? !!s.trailing : a), Ml(t, n, {
          leading: u,
          maxWait: n,
          trailing: a
        });
      }
      function Sd(t) {
        return Sl(t, 1);
      }
      function Od(t, n) {
        return zo(So(n), t);
      }
      function kd() {
        if (!arguments.length)
          return [];
        var t = arguments[0];
        return z(t) ? t : [t];
      }
      function Bd(t) {
        return yt(t, N);
      }
      function Ld(t, n) {
        return n = typeof n == "function" ? n : e, yt(t, N, n);
      }
      function Md(t) {
        return yt(t, I | N);
      }
      function Ud(t, n) {
        return n = typeof n == "function" ? n : e, yt(t, I | N, n);
      }
      function Fd(t, n) {
        return n == null || Tu(t, n, xe(n));
      }
      function Ct(t, n) {
        return t === n || t !== t && n !== n;
      }
      var $d = $i(Ao), qd = $i(function(t, n) {
        return t >= n;
      }), Vn = Nu(function() {
        return arguments;
      }()) ? Nu : function(t) {
        return _e(t) && ue.call(t, "callee") && !yu.call(t, "callee");
      }, z = b.isArray, Wd = Xc ? st(Xc) : Jp;
      function Ye(t) {
        return t != null && Yi(t.length) && !tn(t);
      }
      function Ae(t) {
        return _e(t) && Ye(t);
      }
      function Hd(t) {
        return t === !0 || t === !1 || _e(t) && qe(t) == nt;
      }
      var vn = rp || sc, Kd = Qc ? st(Qc) : Zp;
      function Vd(t) {
        return _e(t) && t.nodeType === 1 && !Hr(t);
      }
      function Gd(t) {
        if (t == null)
          return !0;
        if (Ye(t) && (z(t) || typeof t == "string" || typeof t.splice == "function" || vn(t) || pr(t) || Vn(t)))
          return !t.length;
        var n = ke(t);
        if (n == Ie || n == $e)
          return !t.size;
        if (qr(t))
          return !Do(t).length;
        for (var s in t)
          if (ue.call(t, s))
            return !1;
        return !0;
      }
      function jd(t, n) {
        return Ur(t, n);
      }
      function zd(t, n, s) {
        s = typeof s == "function" ? s : e;
        var u = s ? s(t, n) : e;
        return u === e ? Ur(t, n, e, s) : !!u;
      }
      function Yo(t) {
        if (!_e(t))
          return !1;
        var n = qe(t);
        return n == ht || n == Kt || typeof t.message == "string" && typeof t.name == "string" && !Hr(t);
      }
      function Yd(t) {
        return typeof t == "number" && _u(t);
      }
      function tn(t) {
        if (!we(t))
          return !1;
        var n = qe(t);
        return n == It || n == an || n == Ht || n == Dr;
      }
      function Fl(t) {
        return typeof t == "number" && t == Y(t);
      }
      function Yi(t) {
        return typeof t == "number" && t > -1 && t % 1 == 0 && t <= Se;
      }
      function we(t) {
        var n = typeof t;
        return t != null && (n == "object" || n == "function");
      }
      function _e(t) {
        return t != null && typeof t == "object";
      }
      var $l = eu ? st(eu) : Qp;
      function Jd(t, n) {
        return t === n || bo(t, n, Fo(n));
      }
      function Zd(t, n, s) {
        return s = typeof s == "function" ? s : e, bo(t, n, Fo(n), s);
      }
      function Xd(t) {
        return ql(t) && t != +t;
      }
      function Qd(t) {
        if (Lm(t))
          throw new j(l);
        return Su(t);
      }
      function ey(t) {
        return t === null;
      }
      function ty(t) {
        return t == null;
      }
      function ql(t) {
        return typeof t == "number" || _e(t) && qe(t) == vt;
      }
      function Hr(t) {
        if (!_e(t) || qe(t) != Fe)
          return !1;
        var n = bi(t);
        if (n === null)
          return !0;
        var s = ue.call(n, "constructor") && n.constructor;
        return typeof s == "function" && s instanceof s && wi.call(s) == Zh;
      }
      var Jo = tu ? st(tu) : em;
      function ny(t) {
        return Fl(t) && t >= -Se && t <= Se;
      }
      var Wl = nu ? st(nu) : tm;
      function Ji(t) {
        return typeof t == "string" || !z(t) && _e(t) && qe(t) == Gt;
      }
      function ct(t) {
        return typeof t == "symbol" || _e(t) && qe(t) == hn;
      }
      var pr = ru ? st(ru) : nm;
      function ry(t) {
        return t === e;
      }
      function iy(t) {
        return _e(t) && ke(t) == jt;
      }
      function sy(t) {
        return _e(t) && qe(t) == Tr;
      }
      var oy = $i(Co), cy = $i(function(t, n) {
        return t <= n;
      });
      function Hl(t) {
        if (!t)
          return [];
        if (Ye(t))
          return Ji(t) ? bt(t) : ze(t);
        if (Pr && t[Pr])
          return Fh(t[Pr]());
        var n = ke(t), s = n == Ie ? ao : n == $e ? gi : mr;
        return s(t);
      }
      function nn(t) {
        if (!t)
          return t === 0 ? t : 0;
        if (t = At(t), t === Ue || t === -Ue) {
          var n = t < 0 ? -1 : 1;
          return n * Ft;
        }
        return t === t ? t : 0;
      }
      function Y(t) {
        var n = nn(t), s = n % 1;
        return n === n ? s ? n - s : n : 0;
      }
      function Kl(t) {
        return t ? qn(Y(t), 0, Ee) : 0;
      }
      function At(t) {
        if (typeof t == "number")
          return t;
        if (ct(t))
          return at;
        if (we(t)) {
          var n = typeof t.valueOf == "function" ? t.valueOf() : t;
          t = we(n) ? n + "" : n;
        }
        if (typeof t != "string")
          return t === 0 ? t : +t;
        t = lu(t);
        var s = Wf.test(t);
        return s || Kf.test(t) ? bh(t.slice(2), s ? 2 : 8) : qf.test(t) ? at : +t;
      }
      function Vl(t) {
        return Nt(t, Je(t));
      }
      function uy(t) {
        return t ? qn(Y(t), -Se, Se) : t === 0 ? t : 0;
      }
      function ce(t) {
        return t == null ? "" : ot(t);
      }
      var ly = ar(function(t, n) {
        if (qr(n) || Ye(n)) {
          Nt(n, xe(n), t);
          return;
        }
        for (var s in n)
          ue.call(n, s) && Br(t, s, n[s]);
      }), Gl = ar(function(t, n) {
        Nt(n, Je(n), t);
      }), Zi = ar(function(t, n, s, u) {
        Nt(n, Je(n), t, u);
      }), ay = ar(function(t, n, s, u) {
        Nt(n, xe(n), t, u);
      }), fy = Qt(yo);
      function hy(t, n) {
        var s = lr(t);
        return n == null ? s : Cu(s, n);
      }
      var py = ee(function(t, n) {
        t = fe(t);
        var s = -1, u = n.length, a = u > 2 ? n[2] : e;
        for (a && We(n[0], n[1], a) && (u = 1); ++s < u; )
          for (var p = n[s], m = Je(p), d = -1, _ = m.length; ++d < _; ) {
            var E = m[d], x = t[E];
            (x === e || Ct(x, or[E]) && !ue.call(t, E)) && (t[E] = p[E]);
          }
        return t;
      }), my = ee(function(t) {
        return t.push(e, ll), it(jl, e, t);
      });
      function gy(t, n) {
        return su(t, q(n, 3), Pt);
      }
      function dy(t, n) {
        return su(t, q(n, 3), _o);
      }
      function yy(t, n) {
        return t == null ? t : wo(t, q(n, 3), Je);
      }
      function wy(t, n) {
        return t == null ? t : Ru(t, q(n, 3), Je);
      }
      function _y(t, n) {
        return t && Pt(t, q(n, 3));
      }
      function Ay(t, n) {
        return t && _o(t, q(n, 3));
      }
      function vy(t) {
        return t == null ? [] : Si(t, xe(t));
      }
      function by(t) {
        return t == null ? [] : Si(t, Je(t));
      }
      function Zo(t, n, s) {
        var u = t == null ? e : Wn(t, n);
        return u === e ? s : u;
      }
      function Dy(t, n) {
        return t != null && hl(t, n, Gp);
      }
      function Xo(t, n) {
        return t != null && hl(t, n, jp);
      }
      var Cy = il(function(t, n, s) {
        n != null && typeof n.toString != "function" && (n = _i.call(n)), t[n] = s;
      }, ec(Ze)), Ty = il(function(t, n, s) {
        n != null && typeof n.toString != "function" && (n = _i.call(n)), ue.call(t, n) ? t[n].push(s) : t[n] = [s];
      }, q), Ey = ee(Mr);
      function xe(t) {
        return Ye(t) ? bu(t) : Do(t);
      }
      function Je(t) {
        return Ye(t) ? bu(t, !0) : rm(t);
      }
      function xy(t, n) {
        var s = {};
        return n = q(n, 3), Pt(t, function(u, a, p) {
          Zt(s, n(u, a, p), u);
        }), s;
      }
      function Iy(t, n) {
        var s = {};
        return n = q(n, 3), Pt(t, function(u, a, p) {
          Zt(s, a, n(u, a, p));
        }), s;
      }
      var Ry = ar(function(t, n, s) {
        Oi(t, n, s);
      }), jl = ar(function(t, n, s, u) {
        Oi(t, n, s, u);
      }), Py = Qt(function(t, n) {
        var s = {};
        if (t == null)
          return s;
        var u = !1;
        n = de(n, function(p) {
          return p = _n(p, t), u || (u = p.length > 1), p;
        }), Nt(t, Mo(t), s), u && (s = yt(s, I | S | N, Cm));
        for (var a = n.length; a--; )
          Ro(s, n[a]);
        return s;
      });
      function Ny(t, n) {
        return zl(t, zi(q(n)));
      }
      var Sy = Qt(function(t, n) {
        return t == null ? {} : sm(t, n);
      });
      function zl(t, n) {
        if (t == null)
          return {};
        var s = de(Mo(t), function(u) {
          return [u];
        });
        return n = q(n), Fu(t, s, function(u, a) {
          return n(u, a[0]);
        });
      }
      function Oy(t, n, s) {
        n = _n(n, t);
        var u = -1, a = n.length;
        for (a || (a = 1, t = e); ++u < a; ) {
          var p = t == null ? e : t[St(n[u])];
          p === e && (u = a, p = s), t = tn(p) ? p.call(t) : p;
        }
        return t;
      }
      function ky(t, n, s) {
        return t == null ? t : Fr(t, n, s);
      }
      function By(t, n, s, u) {
        return u = typeof u == "function" ? u : e, t == null ? t : Fr(t, n, s, u);
      }
      var Yl = cl(xe), Jl = cl(Je);
      function Ly(t, n, s) {
        var u = z(t), a = u || vn(t) || pr(t);
        if (n = q(n, 4), s == null) {
          var p = t && t.constructor;
          a ? s = u ? new p() : [] : we(t) ? s = tn(p) ? lr(bi(t)) : {} : s = {};
        }
        return (a ? mt : Pt)(t, function(m, d, _) {
          return n(s, m, d, _);
        }), s;
      }
      function My(t, n) {
        return t == null ? !0 : Ro(t, n);
      }
      function Uy(t, n, s) {
        return t == null ? t : Ku(t, n, So(s));
      }
      function Fy(t, n, s, u) {
        return u = typeof u == "function" ? u : e, t == null ? t : Ku(t, n, So(s), u);
      }
      function mr(t) {
        return t == null ? [] : lo(t, xe(t));
      }
      function $y(t) {
        return t == null ? [] : lo(t, Je(t));
      }
      function qy(t, n, s) {
        return s === e && (s = n, n = e), s !== e && (s = At(s), s = s === s ? s : 0), n !== e && (n = At(n), n = n === n ? n : 0), qn(At(t), n, s);
      }
      function Wy(t, n, s) {
        return n = nn(n), s === e ? (s = n, n = 0) : s = nn(s), t = At(t), zp(t, n, s);
      }
      function Hy(t, n, s) {
        if (s && typeof s != "boolean" && We(t, n, s) && (n = s = e), s === e && (typeof n == "boolean" ? (s = n, n = e) : typeof t == "boolean" && (s = t, t = e)), t === e && n === e ? (t = 0, n = 1) : (t = nn(t), n === e ? (n = t, t = 0) : n = nn(n)), t > n) {
          var u = t;
          t = n, n = u;
        }
        if (s || t % 1 || n % 1) {
          var a = Au();
          return Oe(t + a * (n - t + vh("1e-" + ((a + "").length - 1))), n);
        }
        return Eo(t, n);
      }
      var Ky = fr(function(t, n, s) {
        return n = n.toLowerCase(), t + (s ? Zl(n) : n);
      });
      function Zl(t) {
        return Qo(ce(t).toLowerCase());
      }
      function Xl(t) {
        return t = ce(t), t && t.replace(Gf, kh).replace(fh, "");
      }
      function Vy(t, n, s) {
        t = ce(t), n = ot(n);
        var u = t.length;
        s = s === e ? u : qn(Y(s), 0, u);
        var a = s;
        return s -= n.length, s >= 0 && t.slice(s, a) == n;
      }
      function Gy(t) {
        return t = ce(t), t && Ef.test(t) ? t.replace(li, Bh) : t;
      }
      function jy(t) {
        return t = ce(t), t && Sf.test(t) ? t.replace(js, "\\$&") : t;
      }
      var zy = fr(function(t, n, s) {
        return t + (s ? "-" : "") + n.toLowerCase();
      }), Yy = fr(function(t, n, s) {
        return t + (s ? " " : "") + n.toLowerCase();
      }), Jy = tl("toLowerCase");
      function Zy(t, n, s) {
        t = ce(t), n = Y(n);
        var u = n ? ir(t) : 0;
        if (!n || u >= n)
          return t;
        var a = (n - u) / 2;
        return Fi(Ei(a), s) + t + Fi(Ti(a), s);
      }
      function Xy(t, n, s) {
        t = ce(t), n = Y(n);
        var u = n ? ir(t) : 0;
        return n && u < n ? t + Fi(n - u, s) : t;
      }
      function Qy(t, n, s) {
        t = ce(t), n = Y(n);
        var u = n ? ir(t) : 0;
        return n && u < n ? Fi(n - u, s) + t : t;
      }
      function ew(t, n, s) {
        return s || n == null ? n = 0 : n && (n = +n), cp(ce(t).replace(zs, ""), n || 0);
      }
      function tw(t, n, s) {
        return (s ? We(t, n, s) : n === e) ? n = 1 : n = Y(n), xo(ce(t), n);
      }
      function nw() {
        var t = arguments, n = ce(t[0]);
        return t.length < 3 ? n : n.replace(t[1], t[2]);
      }
      var rw = fr(function(t, n, s) {
        return t + (s ? "_" : "") + n.toLowerCase();
      });
      function iw(t, n, s) {
        return s && typeof s != "number" && We(t, n, s) && (n = s = e), s = s === e ? Ee : s >>> 0, s ? (t = ce(t), t && (typeof n == "string" || n != null && !Jo(n)) && (n = ot(n), !n && rr(t)) ? An(bt(t), 0, s) : t.split(n, s)) : [];
      }
      var sw = fr(function(t, n, s) {
        return t + (s ? " " : "") + Qo(n);
      });
      function ow(t, n, s) {
        return t = ce(t), s = s == null ? 0 : qn(Y(s), 0, t.length), n = ot(n), t.slice(s, s + n.length) == n;
      }
      function cw(t, n, s) {
        var u = f.templateSettings;
        s && We(t, n, s) && (n = e), t = ce(t), n = Zi({}, n, u, ul);
        var a = Zi({}, n.imports, u.imports, ul), p = xe(a), m = lo(a, p), d, _, E = 0, x = n.interpolate || ai, P = "__p += '", k = fo(
          (n.escape || ai).source + "|" + x.source + "|" + (x === Pc ? $f : ai).source + "|" + (n.evaluate || ai).source + "|$",
          "g"
        ), L = "//# sourceURL=" + (ue.call(n, "sourceURL") ? (n.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++dh + "]") + `
`;
        t.replace(k, function(K, te, ie, ut, He, lt) {
          return ie || (ie = ut), P += t.slice(E, lt).replace(jf, Lh), te && (d = !0, P += `' +
__e(` + te + `) +
'`), He && (_ = !0, P += `';
` + He + `;
__p += '`), ie && (P += `' +
((__t = (` + ie + `)) == null ? '' : __t) +
'`), E = lt + K.length, K;
        }), P += `';
`;
        var H = ue.call(n, "variable") && n.variable;
        if (!H)
          P = `with (obj) {
` + P + `
}
`;
        else if (Uf.test(H))
          throw new j(g);
        P = (_ ? P.replace(Er, "") : P).replace(xr, "$1").replace(Ir, "$1;"), P = "function(" + (H || "obj") + `) {
` + (H ? "" : `obj || (obj = {});
`) + "var __t, __p = ''" + (d ? ", __e = _.escape" : "") + (_ ? `, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
` : `;
`) + P + `return __p
}`;
        var Z = ea(function() {
          return oe(p, L + "return " + P).apply(e, m);
        });
        if (Z.source = P, Yo(Z))
          throw Z;
        return Z;
      }
      function uw(t) {
        return ce(t).toLowerCase();
      }
      function lw(t) {
        return ce(t).toUpperCase();
      }
      function aw(t, n, s) {
        if (t = ce(t), t && (s || n === e))
          return lu(t);
        if (!t || !(n = ot(n)))
          return t;
        var u = bt(t), a = bt(n), p = au(u, a), m = fu(u, a) + 1;
        return An(u, p, m).join("");
      }
      function fw(t, n, s) {
        if (t = ce(t), t && (s || n === e))
          return t.slice(0, pu(t) + 1);
        if (!t || !(n = ot(n)))
          return t;
        var u = bt(t), a = fu(u, bt(n)) + 1;
        return An(u, 0, a).join("");
      }
      function hw(t, n, s) {
        if (t = ce(t), t && (s || n === e))
          return t.replace(zs, "");
        if (!t || !(n = ot(n)))
          return t;
        var u = bt(t), a = au(u, bt(n));
        return An(u, a).join("");
      }
      function pw(t, n) {
        var s = Le, u = Me;
        if (we(n)) {
          var a = "separator" in n ? n.separator : a;
          s = "length" in n ? Y(n.length) : s, u = "omission" in n ? ot(n.omission) : u;
        }
        t = ce(t);
        var p = t.length;
        if (rr(t)) {
          var m = bt(t);
          p = m.length;
        }
        if (s >= p)
          return t;
        var d = s - ir(u);
        if (d < 1)
          return u;
        var _ = m ? An(m, 0, d).join("") : t.slice(0, d);
        if (a === e)
          return _ + u;
        if (m && (d += _.length - d), Jo(a)) {
          if (t.slice(d).search(a)) {
            var E, x = _;
            for (a.global || (a = fo(a.source, ce(Nc.exec(a)) + "g")), a.lastIndex = 0; E = a.exec(x); )
              var P = E.index;
            _ = _.slice(0, P === e ? d : P);
          }
        } else if (t.indexOf(ot(a), d) != d) {
          var k = _.lastIndexOf(a);
          k > -1 && (_ = _.slice(0, k));
        }
        return _ + u;
      }
      function mw(t) {
        return t = ce(t), t && Gs.test(t) ? t.replace(er, Hh) : t;
      }
      var gw = fr(function(t, n, s) {
        return t + (s ? " " : "") + n.toUpperCase();
      }), Qo = tl("toUpperCase");
      function Ql(t, n, s) {
        return t = ce(t), n = s ? e : n, n === e ? Uh(t) ? Gh(t) : Rh(t) : t.match(n) || [];
      }
      var ea = ee(function(t, n) {
        try {
          return it(t, e, n);
        } catch (s) {
          return Yo(s) ? s : new j(s);
        }
      }), dw = Qt(function(t, n) {
        return mt(n, function(s) {
          s = St(s), Zt(t, s, jo(t[s], t));
        }), t;
      });
      function yw(t) {
        var n = t == null ? 0 : t.length, s = q();
        return t = n ? de(t, function(u) {
          if (typeof u[1] != "function")
            throw new gt(h);
          return [s(u[0]), u[1]];
        }) : [], ee(function(u) {
          for (var a = -1; ++a < n; ) {
            var p = t[a];
            if (it(p[0], this, u))
              return it(p[1], this, u);
          }
        });
      }
      function ww(t) {
        return Hp(yt(t, I));
      }
      function ec(t) {
        return function() {
          return t;
        };
      }
      function _w(t, n) {
        return t == null || t !== t ? n : t;
      }
      var Aw = rl(), vw = rl(!0);
      function Ze(t) {
        return t;
      }
      function tc(t) {
        return Ou(typeof t == "function" ? t : yt(t, I));
      }
      function bw(t) {
        return Bu(yt(t, I));
      }
      function Dw(t, n) {
        return Lu(t, yt(n, I));
      }
      var Cw = ee(function(t, n) {
        return function(s) {
          return Mr(s, t, n);
        };
      }), Tw = ee(function(t, n) {
        return function(s) {
          return Mr(t, s, n);
        };
      });
      function nc(t, n, s) {
        var u = xe(n), a = Si(n, u);
        s == null && !(we(n) && (a.length || !u.length)) && (s = n, n = t, t = this, a = Si(n, xe(n)));
        var p = !(we(s) && "chain" in s) || !!s.chain, m = tn(t);
        return mt(a, function(d) {
          var _ = n[d];
          t[d] = _, m && (t.prototype[d] = function() {
            var E = this.__chain__;
            if (p || E) {
              var x = t(this.__wrapped__), P = x.__actions__ = ze(this.__actions__);
              return P.push({ func: _, args: arguments, thisArg: t }), x.__chain__ = E, x;
            }
            return _.apply(t, mn([this.value()], arguments));
          });
        }), t;
      }
      function Ew() {
        return Re._ === this && (Re._ = Xh), this;
      }
      function rc() {
      }
      function xw(t) {
        return t = Y(t), ee(function(n) {
          return Mu(n, t);
        });
      }
      var Iw = ko(de), Rw = ko(iu), Pw = ko(io);
      function ta(t) {
        return qo(t) ? so(St(t)) : om(t);
      }
      function Nw(t) {
        return function(n) {
          return t == null ? e : Wn(t, n);
        };
      }
      var Sw = sl(), Ow = sl(!0);
      function ic() {
        return [];
      }
      function sc() {
        return !1;
      }
      function kw() {
        return {};
      }
      function Bw() {
        return "";
      }
      function Lw() {
        return !0;
      }
      function Mw(t, n) {
        if (t = Y(t), t < 1 || t > Se)
          return [];
        var s = Ee, u = Oe(t, Ee);
        n = q(n), t -= Ee;
        for (var a = uo(u, n); ++s < t; )
          n(s);
        return a;
      }
      function Uw(t) {
        return z(t) ? de(t, St) : ct(t) ? [t] : ze(vl(ce(t)));
      }
      function Fw(t) {
        var n = ++Jh;
        return ce(t) + n;
      }
      var $w = Ui(function(t, n) {
        return t + n;
      }, 0), qw = Bo("ceil"), Ww = Ui(function(t, n) {
        return t / n;
      }, 1), Hw = Bo("floor");
      function Kw(t) {
        return t && t.length ? Ni(t, Ze, Ao) : e;
      }
      function Vw(t, n) {
        return t && t.length ? Ni(t, q(n, 2), Ao) : e;
      }
      function Gw(t) {
        return cu(t, Ze);
      }
      function jw(t, n) {
        return cu(t, q(n, 2));
      }
      function zw(t) {
        return t && t.length ? Ni(t, Ze, Co) : e;
      }
      function Yw(t, n) {
        return t && t.length ? Ni(t, q(n, 2), Co) : e;
      }
      var Jw = Ui(function(t, n) {
        return t * n;
      }, 1), Zw = Bo("round"), Xw = Ui(function(t, n) {
        return t - n;
      }, 0);
      function Qw(t) {
        return t && t.length ? co(t, Ze) : 0;
      }
      function e_(t, n) {
        return t && t.length ? co(t, q(n, 2)) : 0;
      }
      return f.after = bd, f.ary = Sl, f.assign = ly, f.assignIn = Gl, f.assignInWith = Zi, f.assignWith = ay, f.at = fy, f.before = Ol, f.bind = jo, f.bindAll = dw, f.bindKey = kl, f.castArray = kd, f.chain = Rl, f.chunk = Hm, f.compact = Km, f.concat = Vm, f.cond = yw, f.conforms = ww, f.constant = ec, f.countBy = Qg, f.create = hy, f.curry = Bl, f.curryRight = Ll, f.debounce = Ml, f.defaults = py, f.defaultsDeep = my, f.defer = Dd, f.delay = Cd, f.difference = Gm, f.differenceBy = jm, f.differenceWith = zm, f.drop = Ym, f.dropRight = Jm, f.dropRightWhile = Zm, f.dropWhile = Xm, f.fill = Qm, f.filter = td, f.flatMap = id, f.flatMapDeep = sd, f.flatMapDepth = od, f.flatten = Tl, f.flattenDeep = eg, f.flattenDepth = tg, f.flip = Td, f.flow = Aw, f.flowRight = vw, f.fromPairs = ng, f.functions = vy, f.functionsIn = by, f.groupBy = cd, f.initial = ig, f.intersection = sg, f.intersectionBy = og, f.intersectionWith = cg, f.invert = Cy, f.invertBy = Ty, f.invokeMap = ld, f.iteratee = tc, f.keyBy = ad, f.keys = xe, f.keysIn = Je, f.map = Vi, f.mapKeys = xy, f.mapValues = Iy, f.matches = bw, f.matchesProperty = Dw, f.memoize = ji, f.merge = Ry, f.mergeWith = jl, f.method = Cw, f.methodOf = Tw, f.mixin = nc, f.negate = zi, f.nthArg = xw, f.omit = Py, f.omitBy = Ny, f.once = Ed, f.orderBy = fd, f.over = Iw, f.overArgs = xd, f.overEvery = Rw, f.overSome = Pw, f.partial = zo, f.partialRight = Ul, f.partition = hd, f.pick = Sy, f.pickBy = zl, f.property = ta, f.propertyOf = Nw, f.pull = fg, f.pullAll = xl, f.pullAllBy = hg, f.pullAllWith = pg, f.pullAt = mg, f.range = Sw, f.rangeRight = Ow, f.rearg = Id, f.reject = gd, f.remove = gg, f.rest = Rd, f.reverse = Vo, f.sampleSize = yd, f.set = ky, f.setWith = By, f.shuffle = wd, f.slice = dg, f.sortBy = vd, f.sortedUniq = Dg, f.sortedUniqBy = Cg, f.split = iw, f.spread = Pd, f.tail = Tg, f.take = Eg, f.takeRight = xg, f.takeRightWhile = Ig, f.takeWhile = Rg, f.tap = Kg, f.throttle = Nd, f.thru = Ki, f.toArray = Hl, f.toPairs = Yl, f.toPairsIn = Jl, f.toPath = Uw, f.toPlainObject = Vl, f.transform = Ly, f.unary = Sd, f.union = Pg, f.unionBy = Ng, f.unionWith = Sg, f.uniq = Og, f.uniqBy = kg, f.uniqWith = Bg, f.unset = My, f.unzip = Go, f.unzipWith = Il, f.update = Uy, f.updateWith = Fy, f.values = mr, f.valuesIn = $y, f.without = Lg, f.words = Ql, f.wrap = Od, f.xor = Mg, f.xorBy = Ug, f.xorWith = Fg, f.zip = $g, f.zipObject = qg, f.zipObjectDeep = Wg, f.zipWith = Hg, f.entries = Yl, f.entriesIn = Jl, f.extend = Gl, f.extendWith = Zi, nc(f, f), f.add = $w, f.attempt = ea, f.camelCase = Ky, f.capitalize = Zl, f.ceil = qw, f.clamp = qy, f.clone = Bd, f.cloneDeep = Md, f.cloneDeepWith = Ud, f.cloneWith = Ld, f.conformsTo = Fd, f.deburr = Xl, f.defaultTo = _w, f.divide = Ww, f.endsWith = Vy, f.eq = Ct, f.escape = Gy, f.escapeRegExp = jy, f.every = ed, f.find = nd, f.findIndex = Dl, f.findKey = gy, f.findLast = rd, f.findLastIndex = Cl, f.findLastKey = dy, f.floor = Hw, f.forEach = Pl, f.forEachRight = Nl, f.forIn = yy, f.forInRight = wy, f.forOwn = _y, f.forOwnRight = Ay, f.get = Zo, f.gt = $d, f.gte = qd, f.has = Dy, f.hasIn = Xo, f.head = El, f.identity = Ze, f.includes = ud, f.indexOf = rg, f.inRange = Wy, f.invoke = Ey, f.isArguments = Vn, f.isArray = z, f.isArrayBuffer = Wd, f.isArrayLike = Ye, f.isArrayLikeObject = Ae, f.isBoolean = Hd, f.isBuffer = vn, f.isDate = Kd, f.isElement = Vd, f.isEmpty = Gd, f.isEqual = jd, f.isEqualWith = zd, f.isError = Yo, f.isFinite = Yd, f.isFunction = tn, f.isInteger = Fl, f.isLength = Yi, f.isMap = $l, f.isMatch = Jd, f.isMatchWith = Zd, f.isNaN = Xd, f.isNative = Qd, f.isNil = ty, f.isNull = ey, f.isNumber = ql, f.isObject = we, f.isObjectLike = _e, f.isPlainObject = Hr, f.isRegExp = Jo, f.isSafeInteger = ny, f.isSet = Wl, f.isString = Ji, f.isSymbol = ct, f.isTypedArray = pr, f.isUndefined = ry, f.isWeakMap = iy, f.isWeakSet = sy, f.join = ug, f.kebabCase = zy, f.last = _t, f.lastIndexOf = lg, f.lowerCase = Yy, f.lowerFirst = Jy, f.lt = oy, f.lte = cy, f.max = Kw, f.maxBy = Vw, f.mean = Gw, f.meanBy = jw, f.min = zw, f.minBy = Yw, f.stubArray = ic, f.stubFalse = sc, f.stubObject = kw, f.stubString = Bw, f.stubTrue = Lw, f.multiply = Jw, f.nth = ag, f.noConflict = Ew, f.noop = rc, f.now = Gi, f.pad = Zy, f.padEnd = Xy, f.padStart = Qy, f.parseInt = ew, f.random = Hy, f.reduce = pd, f.reduceRight = md, f.repeat = tw, f.replace = nw, f.result = Oy, f.round = Zw, f.runInContext = y, f.sample = dd, f.size = _d, f.snakeCase = rw, f.some = Ad, f.sortedIndex = yg, f.sortedIndexBy = wg, f.sortedIndexOf = _g, f.sortedLastIndex = Ag, f.sortedLastIndexBy = vg, f.sortedLastIndexOf = bg, f.startCase = sw, f.startsWith = ow, f.subtract = Xw, f.sum = Qw, f.sumBy = e_, f.template = cw, f.times = Mw, f.toFinite = nn, f.toInteger = Y, f.toLength = Kl, f.toLower = uw, f.toNumber = At, f.toSafeInteger = uy, f.toString = ce, f.toUpper = lw, f.trim = aw, f.trimEnd = fw, f.trimStart = hw, f.truncate = pw, f.unescape = mw, f.uniqueId = Fw, f.upperCase = gw, f.upperFirst = Qo, f.each = Pl, f.eachRight = Nl, f.first = El, nc(f, function() {
        var t = {};
        return Pt(f, function(n, s) {
          ue.call(f.prototype, s) || (t[s] = n);
        }), t;
      }(), { chain: !1 }), f.VERSION = r, mt(["bind", "bindKey", "curry", "curryRight", "partial", "partialRight"], function(t) {
        f[t].placeholder = f;
      }), mt(["drop", "take"], function(t, n) {
        re.prototype[t] = function(s) {
          s = s === e ? 1 : Ce(Y(s), 0);
          var u = this.__filtered__ && !n ? new re(this) : this.clone();
          return u.__filtered__ ? u.__takeCount__ = Oe(s, u.__takeCount__) : u.__views__.push({
            size: Oe(s, Ee),
            type: t + (u.__dir__ < 0 ? "Right" : "")
          }), u;
        }, re.prototype[t + "Right"] = function(s) {
          return this.reverse()[t](s).reverse();
        };
      }), mt(["filter", "map", "takeWhile"], function(t, n) {
        var s = n + 1, u = s == Ge || s == Ut;
        re.prototype[t] = function(a) {
          var p = this.clone();
          return p.__iteratees__.push({
            iteratee: q(a, 3),
            type: s
          }), p.__filtered__ = p.__filtered__ || u, p;
        };
      }), mt(["head", "last"], function(t, n) {
        var s = "take" + (n ? "Right" : "");
        re.prototype[t] = function() {
          return this[s](1).value()[0];
        };
      }), mt(["initial", "tail"], function(t, n) {
        var s = "drop" + (n ? "" : "Right");
        re.prototype[t] = function() {
          return this.__filtered__ ? new re(this) : this[s](1);
        };
      }), re.prototype.compact = function() {
        return this.filter(Ze);
      }, re.prototype.find = function(t) {
        return this.filter(t).head();
      }, re.prototype.findLast = function(t) {
        return this.reverse().find(t);
      }, re.prototype.invokeMap = ee(function(t, n) {
        return typeof t == "function" ? new re(this) : this.map(function(s) {
          return Mr(s, t, n);
        });
      }), re.prototype.reject = function(t) {
        return this.filter(zi(q(t)));
      }, re.prototype.slice = function(t, n) {
        t = Y(t);
        var s = this;
        return s.__filtered__ && (t > 0 || n < 0) ? new re(s) : (t < 0 ? s = s.takeRight(-t) : t && (s = s.drop(t)), n !== e && (n = Y(n), s = n < 0 ? s.dropRight(-n) : s.take(n - t)), s);
      }, re.prototype.takeRightWhile = function(t) {
        return this.reverse().takeWhile(t).reverse();
      }, re.prototype.toArray = function() {
        return this.take(Ee);
      }, Pt(re.prototype, function(t, n) {
        var s = /^(?:filter|find|map|reject)|While$/.test(n), u = /^(?:head|last)$/.test(n), a = f[u ? "take" + (n == "last" ? "Right" : "") : n], p = u || /^find/.test(n);
        a && (f.prototype[n] = function() {
          var m = this.__wrapped__, d = u ? [1] : arguments, _ = m instanceof re, E = d[0], x = _ || z(m), P = function(te) {
            var ie = a.apply(f, mn([te], d));
            return u && k ? ie[0] : ie;
          };
          x && s && typeof E == "function" && E.length != 1 && (_ = x = !1);
          var k = this.__chain__, L = !!this.__actions__.length, H = p && !k, Z = _ && !L;
          if (!p && x) {
            m = Z ? m : new re(this);
            var K = t.apply(m, d);
            return K.__actions__.push({ func: Ki, args: [P], thisArg: e }), new dt(K, k);
          }
          return H && Z ? t.apply(this, d) : (K = this.thru(P), H ? u ? K.value()[0] : K.value() : K);
        });
      }), mt(["pop", "push", "shift", "sort", "splice", "unshift"], function(t) {
        var n = di[t], s = /^(?:push|sort|unshift)$/.test(t) ? "tap" : "thru", u = /^(?:pop|shift)$/.test(t);
        f.prototype[t] = function() {
          var a = arguments;
          if (u && !this.__chain__) {
            var p = this.value();
            return n.apply(z(p) ? p : [], a);
          }
          return this[s](function(m) {
            return n.apply(z(m) ? m : [], a);
          });
        };
      }), Pt(re.prototype, function(t, n) {
        var s = f[n];
        if (s) {
          var u = s.name + "";
          ue.call(ur, u) || (ur[u] = []), ur[u].push({ name: n, func: s });
        }
      }), ur[Mi(e, G).name] = [{
        name: "wrapper",
        func: e
      }], re.prototype.clone = mp, re.prototype.reverse = gp, re.prototype.value = dp, f.prototype.at = Vg, f.prototype.chain = Gg, f.prototype.commit = jg, f.prototype.next = zg, f.prototype.plant = Jg, f.prototype.reverse = Zg, f.prototype.toJSON = f.prototype.valueOf = f.prototype.value = Xg, f.prototype.first = f.prototype.head, Pr && (f.prototype[Pr] = Yg), f;
    }, sr = jh();
    Mn ? ((Mn.exports = sr)._ = sr, eo._ = sr) : Re._ = sr;
  }).call(Vr);
})(is, is.exports);
var W = is.exports;
function mc(o, i) {
  return `/api/v1/${o}/${i}`;
}
class M {
  constructor(i) {
    w(this, "collectionName", "");
    this.id = i;
  }
  get resourceIdentifier() {
    return mc(this.collectionName, this.id);
  }
  update(i) {
    if (this.id !== i.id)
      return;
    const e = ["id", "collectionName"];
    Object.keys(this).filter((c) => !e.includes(c)).forEach((c) => {
      this[c] = i[c];
    });
  }
  clone() {
    return W.cloneDeep(this);
  }
  isEqual(i) {
    return W.isEqual(this, i);
  }
}
var jr = /* @__PURE__ */ ((o) => (o.DEFAULT = "default", o.SMART_MARKETING = "smart-marketing", o.WINCK = "winck", o))(jr || {}), Ba = /* @__PURE__ */ ((o) => (o.DEFAULT = "default", o.SMART_MARKETING = "smart-marketing", o))(Ba || {}), jn = /* @__PURE__ */ ((o) => (o.MALE = "male", o.FEMALE = "female", o.NEUTRAL = "neutral", o.UNKNOWN = "unknown", o))(jn || {});
const La = () => [
  "male",
  "female",
  "neutral",
  "unknown"
  /* UNKNOWN */
];
var Ke = /* @__PURE__ */ ((o) => (o.EMPLOYEE = "employee", o.TEAM_LEAD = "team-lead", o.BRANCH_MANAGER = "branch-manager", o.COMPANY_MANAGER = "company-manager", o))(Ke || {});
const pb = () => [
  "employee",
  "team-lead",
  "branch-manager",
  "company-manager"
  /* COMPANY_MANAGER */
], mb = () => [
  "user",
  "user_in",
  "user_out",
  "branches",
  "branches_in",
  "branches_out"
];
var Et = /* @__PURE__ */ ((o) => (o.ACCELERATE = "accelerate", o.ACTIVE_CAMPAIGN = "active_campaign", o.MAILCHIMP = "mailchimp", o.REALWORKS = "realworks", o.TYPEFORM = "typeform", o))(Et || {});
const gb = () => [
  "accelerate",
  "active_campaign",
  "mailchimp",
  "realworks",
  "typeform"
  /* TYPEFORM */
];
var CA = /* @__PURE__ */ ((o) => (o.REALTOR = "realtor", o.MORTGAGE = "mortgage", o))(CA || {});
const db = () => [
  "realtor",
  "mortgage"
  /* MORTGAGE */
];
var TA = /* @__PURE__ */ ((o) => (o.TEAM = "team", o.USER = "user", o))(TA || {});
const yb = () => [
  "team",
  "user"
  /* USER */
];
var EA = /* @__PURE__ */ ((o) => (o.BRANCH_LICENSE = "branch-license", o.MAQR_ONLY = "maqr-only", o.BASIC = "basic", o.BASIC_PLUS = "basic-plus", o.PREMIUM = "premium", o.PREMIUM_PLUS = "premium-plus", o.WINCK = "winck", o))(EA || {});
const wb = () => [
  "branch-license",
  "maqr-only",
  "basic",
  "basic-plus",
  "premium",
  "premium-plus",
  "winck"
  /* WINCK */
], _b = () => [
  "customer-portal",
  "orders",
  "doc-flow",
  "email-integration",
  "virtual-colleague",
  "gamification"
];
var xA = /* @__PURE__ */ ((o) => (o.IN = "in", o.OUT = "out", o))(xA || {});
const Ab = () => [
  "in",
  "out"
  /* OUT */
];
var gc = /* @__PURE__ */ ((o) => (o.APPRAISAL = "appraisal", o.EPA = "epa", o.INFORMATION = "information", o.MORTGAGE = "mortgage", o.PURCHASE = "purchase", o.PHOTO = "photo", o.SALE = "sale", o.SIGN_PLACEMENT = "sign-placement", o.TAXATION = "taxation", o.TECHNICAL_APPRAISAL = "technical-appraisal", o.NEW_BUILD = "new-build", o))(gc || {});
const vb = () => [
  "appraisal",
  "epa",
  "information",
  "mortgage",
  "purchase",
  "photo",
  "sale",
  "sign-placement",
  "taxation",
  "technical-appraisal",
  "new-build"
  /* NEW_BUILD */
];
var zr = /* @__PURE__ */ ((o) => (o.NEW = "new", o.APPOINTMENT = "appointment", o.PROPOSAL = "proposal", o.ON_HOLD = "on-hold", o.PENDING = "pending", o.UNREACHABLE = "unreachable", o.OPEN = "open", o.SUCCESSFUL = "successful", o.PROCESSED = "processed", o.CLOSED = "closed", o))(zr || {});
const bb = (o = null) => o && o.pipelinesEnabled ? [
  "open",
  "successful",
  "closed"
  /* CLOSED */
] : [
  "new",
  "appointment",
  "proposal",
  "on-hold",
  "pending",
  "unreachable",
  "successful",
  "processed",
  "closed"
  /* CLOSED */
], Db = (o, i) => {
  let e = {};
  switch (o) {
    default:
      e = {
        new: ["new", "appointment", "pending", "unreachable", "successful", "closed"],
        appointment: ["appointment", "proposal", "on-hold", "successful", "closed"],
        proposal: ["proposal", "on-hold", "successful", "closed"],
        "on-hold": ["appointment", "proposal", "on-hold", "successful", "closed"],
        pending: ["pending", "appointment", "proposal", "successful", "closed"],
        unreachable: ["appointment", "pending", "unreachable", "successful", "closed"],
        successful: ["successful", "closed"],
        processed: ["processed", "successful", "closed"],
        closed: ["closed", "successful"]
      };
      break;
  }
  return e[i];
};
var IA = /* @__PURE__ */ ((o) => (o.WAITING_INTERNAL = "waiting-internal", o.WAITING_EXTERNAL = "waiting-external", o.WAITING_CONTACT = "waiting-contact", o.INFORMATION = "information", o.NEGATIVE_ADVICE = "negative-advice", o.NO_SUITABLE_TIME = "no-suitable-time", o.NO_TIME = "no-time", o.NOT_INTERESTED = "not-interested", o.OTHER = "other", o.THINKING = "thinking", o.TO_COMPETITOR = "to-competitor", o.VOICEMAIL = "voicemail", o.WITHDRAWN = "withdrawn", o.WRONG_CONTACT = "wrong-contact", o.WRONG_CONTACT_DETAILS = "wrong-contact-details", o.REOPENED = "reopened", o.UNREACHABLE = "unreachable", o.LONG_TERM = "long-term", o.CONTACTED_PER_EMAIL = "contacted-per-email", o.WAITING_NEW_BUILD = "waiting-new-build", o.PROCESSED_REOPENED = "processed-reopened", o.PROCESSED_CLOSED = "processed-closed", o.AUTO_CLOSED = "auto-closed", o))(IA || {});
const Cb = () => [
  "waiting-internal",
  "waiting-external",
  "waiting-contact",
  "information",
  "negative-advice",
  "no-suitable-time",
  "no-time",
  "not-interested",
  "other",
  "thinking",
  "to-competitor",
  "voicemail",
  "withdrawn",
  "wrong-contact",
  "wrong-contact-details",
  "reopened",
  "unreachable",
  "long-term",
  "contacted-per-email",
  "waiting-new-build",
  "processed-reopened",
  "processed-closed",
  "auto-closed"
  /* AUTO_CLOSED */
], Tb = (o, i) => {
  let e = {};
  switch (o) {
    default:
      e = {
        new: [],
        appointment: [],
        proposal: [],
        "on-hold": ["waiting-internal", "waiting-external", "waiting-contact", "long-term", "waiting-new-build"],
        pending: ["information", "thinking", "no-suitable-time", "no-time", "wrong-contact", "other"],
        unreachable: ["voicemail", "wrong-contact-details", "contacted-per-email"],
        successful: [],
        processed: [],
        closed: ["not-interested", "negative-advice", "withdrawn", "to-competitor", "unreachable", "other"]
      };
      break;
  }
  return e[i];
};
var RA = /* @__PURE__ */ ((o) => (o.PURCHASE = "purchase", o.SALE = "sale", o.MORTGAGE = "mortgage", o))(RA || {});
const Eb = () => [
  "purchase",
  "sale",
  "mortgage"
  /* MORTGAGE */
];
var PA = /* @__PURE__ */ ((o) => (o.PENDING = "pending", o.SUCCESSFUL = "successful", o.UNSUCCESSFUL = "unsuccessful", o))(PA || {});
const xb = () => [
  "pending",
  "successful",
  "unsuccessful"
  /* UNSUCCESSFUL */
];
var NA = /* @__PURE__ */ ((o) => (o.APPRAISAL = "appraisal", o.EPA = "epa", o.INFORMATION = "information", o.MORTGAGE = "mortgage", o.PURCHASE = "purchase", o.PHOTO = "photo", o.SALE = "sale", o.SIGN_PLACEMENT = "sign-placement", o.TAXATION = "taxation", o.TECHNICAL_APPRAISAL = "technical-appraisal", o.NEW_BUILD = "new-build", o))(NA || {});
const Ib = () => [
  "appraisal",
  "epa",
  "information",
  "mortgage",
  "purchase",
  "photo",
  "sale",
  "sign-placement",
  "taxation",
  "technical-appraisal",
  "new-build"
  /* NEW_BUILD */
];
var SA = /* @__PURE__ */ ((o) => (o.change = "change", o.appointment = "appointment", o))(SA || {});
const Rb = () => [
  "change",
  "appointment"
  /* appointment */
];
var OA = /* @__PURE__ */ ((o) => (o.minute = "minute", o.hour = "hour", o.day = "day", o))(OA || {});
const Pb = () => [
  "day",
  "hour",
  "minute"
  /* minute */
];
var kA = /* @__PURE__ */ ((o) => (o.all = "all", o.internal = "internal", o.external = "external", o))(kA || {});
const Nb = () => [
  "external",
  "internal",
  "all"
  /* all */
];
var sn = /* @__PURE__ */ ((o) => (o.MEETING = "meeting", o.EMAIL = "email", o.CALL = "call", o.REMINDER = "reminder", o.LETTER = "letter", o.BILLING = "billing", o.UPDATE = "update", o.NOTIFICATION = "notification", o))(sn || {});
const Sb = () => [
  "billing",
  "call",
  "email",
  "letter",
  "meeting",
  "reminder",
  "update",
  "notification"
  /* NOTIFICATION */
];
var BA = /* @__PURE__ */ ((o) => (o.referredBy = "referred-by", o.assignedTo = "assigned-to", o.actionAssignedTo = "action-assigned-to", o))(BA || {});
const Ob = () => [
  "assigned-to",
  "referred-by",
  "action-assigned-to"
  /* actionAssignedTo */
];
var Gr = /* @__PURE__ */ ((o) => (o.VIDEO = "video", o.PHONE = "phone", o.OFFICE = "office", o.CUSTOMER = "customer", o))(Gr || {});
const kb = () => [
  "customer",
  "office",
  "phone",
  "video"
  /* VIDEO */
];
var LA = /* @__PURE__ */ ((o) => (o.CONTACT = "contact", o.ADDRESS = "address", o))(LA || {});
const Bb = () => [
  "contact",
  "address"
  /* ADDRESS */
];
var MA = /* @__PURE__ */ ((o) => (o.SYSTEM = "system", o.USER = "user", o.VIRTUAL_COLLEAGUE = "virtual-colleague", o))(MA || {}), UA = /* @__PURE__ */ ((o) => (o.PERSONAL = "personal", o.PRIVATE = "private", o.PUBLIC = "public", o))(UA || {});
const Lb = () => [
  "personal",
  "private",
  "public"
  /* PUBLIC */
];
var FA = /* @__PURE__ */ ((o) => (o.USER = "user", o.BRANCHES = "branches", o))(FA || {});
const Mb = () => [
  "user",
  "branches"
  /* BRANCHES */
];
var $A = /* @__PURE__ */ ((o) => (o.WEEKLY = "weekly", o.MONTHLY = "monthly", o))($A || {});
const Ub = () => [
  "weekly",
  "monthly"
  /* MONTHLY */
];
var qA = /* @__PURE__ */ ((o) => (o.EXISTING = "existing", o.NEW = "new", o))(qA || {});
const Fb = () => [
  "existing",
  "new"
  /* NEW */
];
var WA = /* @__PURE__ */ ((o) => (o.TYPE_ONCE = "once", o.TYPE_MONTHLY = "monthly", o.TYPE_YEARLY = "yearly", o))(WA || {});
const $b = () => [
  "once",
  "monthly",
  "yearly"
  /* TYPE_YEARLY */
];
var HA = /* @__PURE__ */ ((o) => (o.AVATAR = "avatar", o.POPUP = "popup", o))(HA || {}), KA = /* @__PURE__ */ ((o) => (o.AGENT = "agent", o.INFORMATION = "information", o.VALUATION = "valuation", o.CHECKLIST = "checklist", o))(KA || {}), VA = /* @__PURE__ */ ((o) => (o.CALL = "call", o.EMAIL = "email", o.CUSTOM = "custom", o.VALUATION = "valuation", o.CHECKLIST = "checklist", o.INFORMATION = "information", o.AGENT = "agent", o))(VA || {}), GA = /* @__PURE__ */ ((o) => (o.RECTANGLE = "rectangle", o.CIRCULAR = "circular", o.CARD = "card", o))(GA || {}), jA = /* @__PURE__ */ ((o) => (o.LEFT = "left", o.RIGHT = "right", o))(jA || {}), zA = /* @__PURE__ */ ((o) => (o.NONE = "none", o.OPEN = "OPEN", o))(zA || {}), YA = /* @__PURE__ */ ((o) => (o.ROBOTO = "Roboto", o.OPENSANS = "Open-sans", o.MONTSERRAT = "Montserrat", o))(YA || {}), JA = /* @__PURE__ */ ((o) => (o[o.A = 0] = "A", o[o.B = 1] = "B", o[o.C = 2] = "C", o))(JA || {}), ZA = /* @__PURE__ */ ((o) => (o.MOST_CREATED_LEADS = "most-created-leads", o.HIGHEST_REVENUE = "highest-revenue", o.HIGHEST_LEAD_QUALITY = "highest-lead-quality", o.FASTEST_CONVERSION = "fastest-conversion", o.MOST_CONVERSION = "most-conversion", o.MOST_APPOINTMENT = "most-appointment", o.MOST_PROPOSALS = "most-proposals", o.FASTEST_LEAD_PICKUP = "fastest-lead-pickup", o))(ZA || {});
const qb = [
  "most-created-leads",
  "highest-revenue",
  "highest-lead-quality",
  "fastest-conversion",
  "most-conversion",
  "most-appointment",
  "most-proposals",
  "fastest-lead-pickup"
  /* FASTEST_LEAD_PICKUP */
];
var XA = /* @__PURE__ */ ((o) => (o.GREEN = "keyvue-green", o.BLUE = "keyvue-blue", o.PINK = "keyvue-pink", o.GOLD = "gold", o.SILVER = "silver", o.BRONZE = "bronze", o))(XA || {});
const Wb = {
  gold: "#ffc552",
  silver: "#A8A8AA",
  bronze: "#ce853e"
};
var QA = /* @__PURE__ */ ((o) => (o.PURCHASE = "purchase", o.SALE = "sale", o.MORTGAGE = "mortgage", o.TAXATION = "taxation", o.SUSTAINABILITY = "sustainability", o.INSURANCE = "insurance", o.NEW_BUILD = "new-build", o.RENTAL = "rental", o.BUSINESS_REAL_ESTATE = "business-real-estate", o))(QA || {});
const Hb = [
  "purchase",
  "sale",
  "mortgage",
  "taxation",
  "sustainability",
  "insurance",
  "rental",
  "new-build",
  "business-real-estate"
  /* BUSINESS_REAL_ESTATE */
];
var zn = /* @__PURE__ */ ((o) => (o.ENTRY = "entry", o.APPROACH = "approach", o.DECISION = "decision", o))(zn || {});
const Kb = [
  "entry",
  "approach",
  "decision"
  /* DECISION */
];
var ev = /* @__PURE__ */ ((o) => (o.USER = "user", o.ONLINE = "online", o.REALWORKS = "realworks", o))(ev || {});
const Vb = () => [
  "user",
  "online",
  "realworks"
  /* REALWORKS */
];
class Ve extends M {
  constructor(e, r, c, l, h, g, v, A, D, I, S) {
    super(r);
    w(this, "collectionName", _f.collectionName);
    this.pipeline = e, this.id = r, this.name = c, this.category = l, this.color = h, this.sort = g, this.active = v, this.statusReasonRequired = A, this.noStatusReasonEnabled = D, this.createdAt = I, this.updatedAt = S;
  }
  compareTo(e) {
    const r = [
      zn.ENTRY,
      zn.APPROACH,
      zn.DECISION
    ], c = r.indexOf(this.category), l = r.indexOf(e.category);
    return c !== l ? c - l : this.sort - e.sort;
  }
  static fromData(e) {
    return e === null || typeof e == "string" || e instanceof Ve ? e : new Ve(
      e.pipeline ? J.fromData(e.pipeline) : null,
      e.id,
      e.name,
      e.category,
      e.color,
      e.sort,
      e.active,
      e.statusReasonRequired,
      e.noStatusReasonEnabled,
      e.createdAt,
      e.updatedAt
    );
  }
}
class J extends M {
  constructor(e, r, c, l, h, g, v, A, D, I, S, N, R, O) {
    super(l);
    w(this, "collectionName", wf.collectionName);
    this.company = e, this.branches = r, this.fallbackBranch = c, this.id = l, this.name = h, this.category = g, this.active = v, this.phases = A, this.potentialOrderValuePerReferral = D, this.conversionPercentage = I, this.afspraakTypes = S, this.autoCloseAfterDays = N, this.createdAt = R, this.updatedAt = O;
  }
  isExternal(e) {
    return this.company === null ? !1 : this.company && this.company.id !== e.id;
  }
  get firstPhase() {
    return this.phases.length === 0 ? null : this.phases[0];
  }
  get activePhases() {
    return this.phases.filter((e) => e.active);
  }
  getPhase(e) {
    return this.phases.find((r) => r.id === e) || null;
  }
  canViewPotentialOrderValue(e) {
    return this.potentialOrderValuePerReferral === null || e.company === null || this.isExternal(e.company) ? !1 : e.company.potentialOrderValueRoles.includes(e.role);
  }
  getPotentialOrderValue(e) {
    return this.potentialOrderValuePerReferral === null ? 0 : this.potentialOrderValuePerReferral * e;
  }
  getExpectedOrderValue(e) {
    return this.potentialOrderValuePerReferral === null ? 0 : this.potentialOrderValuePerReferral * e * (this.conversionPercentage || 0) / 100;
  }
  static fromData(e) {
    return e === null || typeof e == "string" || e instanceof J ? e : new J(
      e.company ? U.fromData(e.company) : null,
      Object.values(e.branches || {}).map((r) => X.fromData(r)),
      e.fallbackBranch ? X.fromData(e.fallbackBranch) : null,
      e.id,
      e.name,
      e.category,
      e.active,
      Object.values(e.phases || {}).map((r) => Ve.fromData(r)).sort((r, c) => r.compareTo(c)),
      e.potentialOrderValuePerReferral,
      e.conversionPercentage,
      e.afspraakTypes || [],
      e.autoCloseAfterDays,
      e.createdAt,
      e.updatedAt
    );
  }
}
class X extends M {
  constructor(e, r, c, l, h, g, v, A, D, I, S, N, R, O, $, G, ne, Q, he, le, ge, ae, ye) {
    super(c);
    w(this, "collectionName", qa.collectionName);
    this.company = e, this.pipelines = r, this.id = c, this.name = l, this.displayName = h, this.type = g, this.streetname = v, this.streetnumber = A, this.suffix = D, this.zipcode = I, this.city = S, this.country = N, this.phonenumber = R, this.email = O, this.website = $, this.logo = G, this.primaryColor = ne, this.acceptedReferralTypes = Q, this.assignedZipcodes = he, this.notifyOnReferralCreatedEmailList = le, this.notifyOnSmartMarketingReferralCreatedEmailList = ge, this.createdAt = ae, this.updatedAt = ye;
  }
  /**
   * Returns true if branch accepts specified referral type. False if not.
   * @param referralType
   */
  acceptsReferralType(e) {
    return typeof this.acceptedReferralTypes[e] > "u" ? !1 : this.acceptedReferralTypes[e];
  }
  static fromData(e) {
    return e === null || typeof e == "string" || e instanceof X ? e : new X(
      e.company ? U.fromData(e.company) : null,
      e.pipelines ? e.pipelines.map((r) => J.fromData(r)) : [],
      e.id,
      e.name,
      e.displayName,
      e.type,
      e.streetname,
      e.streetnumber,
      e.suffix,
      e.zipcode,
      e.city,
      e.country,
      e.phonenumber,
      e.email,
      e.website,
      e.logo,
      e.primaryColor,
      e.acceptedReferralTypes ? e.acceptedReferralTypes instanceof Array ? {} : e.acceptedReferralTypes : {},
      e.assignedZipcodes ? e.assignedZipcodes instanceof Array ? {} : e.assignedZipcodes : {},
      e.notifyOnReferralCreatedEmailList ?? [],
      e.notifyOnSmartMarketingReferralCreatedEmailList ?? [],
      e.createdAt,
      e.updatedAt
    );
  }
}
let Xi;
const tv = new Uint8Array(16);
function nv() {
  if (!Xi && (Xi = typeof crypto < "u" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto), !Xi))
    throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
  return Xi(tv);
}
const Ne = [];
for (let o = 0; o < 256; ++o)
  Ne.push((o + 256).toString(16).slice(1));
function rv(o, i = 0) {
  return (Ne[o[i + 0]] + Ne[o[i + 1]] + Ne[o[i + 2]] + Ne[o[i + 3]] + "-" + Ne[o[i + 4]] + Ne[o[i + 5]] + "-" + Ne[o[i + 6]] + Ne[o[i + 7]] + "-" + Ne[o[i + 8]] + Ne[o[i + 9]] + "-" + Ne[o[i + 10]] + Ne[o[i + 11]] + Ne[o[i + 12]] + Ne[o[i + 13]] + Ne[o[i + 14]] + Ne[o[i + 15]]).toLowerCase();
}
const iv = typeof crypto < "u" && crypto.randomUUID && crypto.randomUUID.bind(crypto), pa = {
  randomUUID: iv
};
function ln(o, i, e) {
  if (pa.randomUUID && !i && !o)
    return pa.randomUUID();
  o = o || {};
  const r = o.random || (o.rng || nv)();
  if (r[6] = r[6] & 15 | 64, r[8] = r[8] & 63 | 128, i) {
    e = e || 0;
    for (let c = 0; c < 16; ++c)
      i[e + c] = r[c];
    return i;
  }
  return rv(r);
}
class xt extends M {
  constructor(e, r, c, l, h, g, v, A) {
    super(r);
    w(this, "collectionName", za.collectionName);
    this.company = e, this.id = r, this.enabled = c, this.createdAt = l, this.createdBy = h, this.updatedAt = g, this.updatedBy = v, this.credentialsType = A;
  }
  static fromData(e) {
    if (e === null || typeof e == "string" || e instanceof xt)
      return e;
    switch (e.credentialsType) {
      case Et.ACCELERATE:
        return Tc.fromData(e);
      case Et.ACTIVE_CAMPAIGN:
        return ss.fromData(e);
      case Et.MAILCHIMP:
        return os.fromData(e);
      case Et.REALWORKS:
        return Tn.fromData(e);
      case Et.TYPEFORM:
        return cs.fromData(e);
      default:
        throw new Error(`Unknown credentials type: ${e.credentialsType}`);
    }
  }
}
class Tc extends xt {
  constructor(i, e, r, c, l, h, g, v) {
    super(i, e, r, c, l, h, g, Et.ACCELERATE), this.company = i, this.id = e, this.enabled = r, this.createdAt = c, this.createdBy = l, this.updatedAt = h, this.updatedBy = g, this.apiKey = v;
  }
  static fromData(i) {
    return new Tc(
      i.company ? U.fromData(i.company) : null,
      i.id,
      i.enabled,
      i.createdAt,
      i.createdBy ? F.fromData(i.createdBy) : null,
      i.updatedAt,
      i.updatedBy ? F.fromData(i.updatedBy) : null,
      i.apiKey
    );
  }
  // Convince Typescript that it is indeed an instance of the sub class
  clone() {
    return super.clone();
  }
}
class ss extends xt {
  constructor(i, e, r, c, l, h, g, v, A, D, I, S, N, R, O, $, G, ne, Q, he, le, ge, ae, ye, be, Le, Me, et, tt, Ge) {
    super(i, e, r, c, l, h, g, Et.ACTIVE_CAMPAIGN), this.company = i, this.id = e, this.enabled = r, this.createdAt = c, this.createdBy = l, this.updatedAt = h, this.updatedBy = g, this.includeInternalContacts = v, this.includeExternalContacts = A, this.includeRealworksRelaties = D, this.syncedRealworksKenmerken = I, this.excludedRealworksKenmerken = S, this.syncedRealworksRelatietypes = N, this.syncedRealworksStatus = R, this.updatedFrom = O, this.updatedUntil = $, this.apiUrl = G, this.apiKey = ne, this.eventTrackingAccountId = Q, this.eventTrackingKey = he, this.defaultTeams = le, this.defaultStatus = ge, this.syncedRealworksAgendatypes = ae, this.syncedRealworksTaaktypes = ye, this.listId = be, this.agendaListId = Le, this.taakListId = Me, this.viewingListId = et, this.emmaListId = tt, this.emmaDefaults = Ge;
  }
  static fromData(i) {
    return new ss(
      i.company ? U.fromData(i.company) : null,
      i.id,
      i.enabled,
      i.createdAt,
      i.createdBy ? F.fromData(i.createdBy) : null,
      i.updatedAt,
      i.updatedBy ? F.fromData(i.updatedBy) : null,
      i.includeInternalContacts,
      i.includeExternalContacts,
      i.includeRealworksRelaties,
      i.syncedRealworksKenmerken,
      i.excludedRealworksKenmerken,
      i.syncedRealworksRelatietypes,
      i.syncedRealworksStatus,
      i.updatedFrom,
      i.updatedUntil,
      i.apiUrl,
      i.apiKey,
      i.eventTrackingAccountId,
      i.eventTrackingKey,
      i.defaultTeams instanceof Array ? {} : i.defaultTeams,
      i.defaultStatus,
      i.syncedRealworksAgendatypes,
      i.syncedRealworksTaaktypes,
      i.listId,
      i.agendaListId,
      i.taakListId,
      i.viewingListId,
      i.emmaListId,
      i.emmaDefaults instanceof Array ? {} : i.emmaDefaults
    );
  }
  static create(i) {
    return new ss(
      "company" in i ? i.company : null,
      "id" in i ? i.id : ln(),
      "enabled" in i ? i.enabled : !1,
      /* @__PURE__ */ new Date(),
      "createdBy" in i ? i.createdBy : null,
      /* @__PURE__ */ new Date(),
      "updatedBy" in i ? i.updatedBy : null,
      "includeInternalContacts" in i ? i.includeInternalContacts : !0,
      "includeExternalContacts" in i ? i.includeExternalContacts : !1,
      "includeRealworksRelaties" in i ? i.includeRealworksRelaties : !1,
      "syncedRealworksKenmerken" in i ? i.syncedRealworksKenmerken : [],
      "excludedRealworksKenmerken" in i ? i.excludedRealworksKenmerken : [],
      "syncedRealworksRelatietypes" in i ? i.syncedRealworksRelatietypes : [],
      "syncedRealworksStatus" in i ? i.syncedRealworksStatus : !0,
      "updatedFrom" in i ? i.updatedFrom : null,
      "updatedUntil" in i ? i.updatedUntil : null,
      null,
      null,
      null,
      null,
      {},
      zr.PROCESSED,
      [],
      [],
      null,
      null,
      null,
      null,
      null,
      {}
    );
  }
  // Convince Typescript that it is indeed an instance of the sub class
  clone() {
    return super.clone();
  }
}
class os extends xt {
  constructor(i, e, r, c, l, h, g, v, A, D, I, S, N, R, O, $) {
    super(i, e, r, c, l, h, g, Et.MAILCHIMP), this.company = i, this.id = e, this.enabled = r, this.createdAt = c, this.createdBy = l, this.updatedAt = h, this.updatedBy = g, this.includeInternalContacts = v, this.includeExternalContacts = A, this.includeRealworksRelaties = D, this.syncedRealworksKenmerken = I, this.updatedFrom = S, this.updatedUntil = N, this.apiKey = R, this.server = O, this.listId = $;
  }
  static fromData(i) {
    return new os(
      i.company ? U.fromData(i.company) : null,
      i.id,
      i.enabled,
      i.createdAt,
      i.createdBy ? F.fromData(i.createdBy) : null,
      i.updatedAt,
      i.updatedBy ? F.fromData(i.updatedBy) : null,
      i.includeInternalContacts,
      i.includeExternalContacts,
      i.includeRealworksRelaties,
      i.syncedRealworksKenmerken,
      i.updatedFrom,
      i.updatedUntil,
      i.apiKey,
      i.server,
      i.listId
    );
  }
  static create(i) {
    return new os(
      "company" in i ? i.company : null,
      "id" in i ? i.id : ln(),
      "enabled" in i ? i.enabled : !1,
      /* @__PURE__ */ new Date(),
      "createdBy" in i ? i.createdBy : null,
      /* @__PURE__ */ new Date(),
      "updatedBy" in i ? i.updatedBy : null,
      "includeInternalContacts" in i ? i.includeInternalContacts : !0,
      "includeExternalContacts" in i ? i.includeExternalContacts : !1,
      "includeRealworksRelaties" in i ? i.includeRealworksRelaties : !1,
      "syncedRealworksKenmerken" in i ? i.syncedRealworksKenmerken : [],
      "updatedFrom" in i ? i.updatedFrom : null,
      "updatedUntil" in i ? i.updatedUntil : null,
      null,
      null,
      null
    );
  }
  // Convince Typescript that it is indeed an instance of the sub class
  clone() {
    return super.clone();
  }
}
class Tn extends xt {
  constructor(i, e, r, c, l, h, g, v, A, D, I, S, N, R, O) {
    super(i, e, r, c, l, h, g, Et.REALWORKS), this.company = i, this.id = e, this.enabled = r, this.createdAt = c, this.createdBy = l, this.updatedAt = h, this.updatedBy = g, this.apiKey = v, this.description = A, this.canRequestFacturen = D, this.canRequestObjecten = I, this.canRequestAgenda = S, this.canRequestTaken = N, this.canRequestRelaties = R, this.agendaBranch = O;
  }
  static fromData(i) {
    return new Tn(
      i.company ? U.fromData(i.company) : null,
      i.id,
      i.enabled,
      i.createdAt,
      i.createdBy ? F.fromData(i.createdBy) : null,
      i.updatedAt,
      i.updatedBy ? F.fromData(i.updatedBy) : null,
      i.apiKey,
      i.description,
      i.canRequestFacturen ?? !1,
      i.canRequestObjecten ?? !1,
      i.canRequestAgenda ?? !1,
      i.canRequestTaken ?? !1,
      i.canRequestRelaties ?? !1,
      i.agendaBranch ? X.fromData(i.agendaBranch) : null
    );
  }
  static create(i) {
    return new Tn(
      "company" in i ? i.company : null,
      "id" in i ? i.id : ln(),
      "enabled" in i ? i.enabled : !1,
      /* @__PURE__ */ new Date(),
      "createdBy" in i ? i.createdBy : null,
      /* @__PURE__ */ new Date(),
      "updatedBy" in i ? i.updatedBy : null,
      "apiKey" in i ? i.apiKey : "",
      "description" in i ? i.description : "",
      "canRequestFacturen" in i ? i.canRequestFacturen : !1,
      "canRequestObjecten" in i ? i.canRequestObjecten : !1,
      "canRequestAgenda" in i ? i.canRequestAgenda : !1,
      "canRequestTaken" in i ? i.canRequestTaken : !1,
      "canRequestRelaties" in i ? i.canRequestRelaties : !1,
      "agendaBranch" in i ? i.agendaBranch : null
    );
  }
  // Convince Typescript that it is indeed an instance of the sub class
  clone() {
    return super.clone();
  }
}
class cs extends xt {
  constructor(i, e, r, c, l, h, g, v, A, D, I) {
    super(i, e, r, c, l, h, g, Et.TYPEFORM), this.company = i, this.id = e, this.enabled = r, this.createdAt = c, this.createdBy = l, this.updatedAt = h, this.updatedBy = g, this.apiKey = v, this.workspaceId = A, this.firstViewingAgendaTypes = D, this.secondViewingAgendaTypes = I;
  }
  static fromData(i) {
    return new cs(
      i.company ? U.fromData(i.company) : null,
      i.id,
      i.enabled,
      i.createdAt,
      i.createdBy ? F.fromData(i.createdBy) : null,
      i.updatedAt,
      i.updatedBy ? F.fromData(i.updatedBy) : null,
      i.apiKey,
      i.workspaceId,
      i.firstViewingAgendaTypes,
      i.secondViewingAgendaTypes
    );
  }
  static create(i) {
    return new cs(
      "company" in i ? i.company : null,
      "id" in i ? i.id : ln(),
      "enabled" in i ? i.enabled : !1,
      /* @__PURE__ */ new Date(),
      "createdBy" in i ? i.createdBy : null,
      /* @__PURE__ */ new Date(),
      "updatedBy" in i ? i.updatedBy : null,
      null,
      null,
      "firstViewingAgendaTypes" in i ? i.firstViewingAgendaTypes : [],
      "secondViewingAgendaTypes" in i ? i.secondViewingAgendaTypes : []
    );
  }
  // Convince Typescript that it is indeed an instance of the sub class
  clone() {
    return super.clone();
  }
}
class En extends M {
  constructor(e, r, c, l, h, g) {
    super(e);
    w(this, "collectionName", Xa.collectionName);
    this.id = e, this.type = r, this.source = c, this.target = l, this.excludedReferralFields = h, this.active = g;
  }
  static fromData(e) {
    return e === null || typeof e == "string" || e instanceof En ? e : new En(
      e.id,
      e.type,
      e.source ? U.fromData(e.source) : null,
      e.target ? U.fromData(e.target) : null,
      e.excludedReferralFields || [],
      e.active
    );
  }
}
class Zr extends M {
  constructor(e, r, c, l, h, g, v, A, D) {
    super(e);
    w(this, "collectionName", Ka.collectionName);
    this.id = e, this.displayName = r, this.emailDomain = c, this.primaryColor = l, this.logo = h, this.logoPath = g, this.logoUrl = v, this.createdAt = A, this.updatedAt = D;
  }
  static fromData(e) {
    return e === null || typeof e == "string" || e instanceof Zr ? e : new Zr(
      e.id,
      e.displayName,
      e.emailDomain,
      e.primaryColor,
      e.logo,
      e.logoPath,
      e.logoUrl,
      e.createdAt,
      e.updatedAt
    );
  }
}
class Yn extends M {
  constructor(e, r, c, l, h, g, v) {
    super(e);
    w(this, "collectionName", "auto_close_settings");
    this.id = e, this.closeEnabled = r, this.closeEnabledAt = c, this.closeAfterDays = l, this.notificationEnabled = h, this.perPipelineEnabled = g, this.notificationBeforeDays = v;
  }
  static fromData(e) {
    return e === null || typeof e == "string" || e instanceof Yn ? e : new Yn(
      e.id,
      e.closeEnabled,
      e.closeEnabledAt,
      e.closeAfterDays,
      e.notificationEnabled,
      e.perPipelineEnabled,
      e.notificationBeforeDays
    );
  }
  static new(e) {
    return new Yn(
      e,
      !1,
      null,
      120,
      !0,
      !1,
      14
    );
  }
}
class Jn extends M {
  constructor(e, r, c, l, h, g) {
    super(e);
    w(this, "collectionName", "order_settings");
    this.id = e, this.enabled = r, this.enabledTypes = c, this.typeMapping = l, this.pipelineMapping = h, this.allowManualCreation = g;
  }
  getMapping(e) {
    return this.pipelineMapping[e] ? this.pipelineMapping[e] : this.typeMapping[e] ? this.typeMapping[e] : null;
  }
  static fromData(e) {
    return e === null || typeof e == "string" || e instanceof Jn ? e : new Jn(
      e.id,
      e.enabled,
      e.enabledTypes,
      e.typeMapping && e.typeMapping.length !== 0 ? e.typeMapping : {},
      e.pipelineMapping && e.pipelineMapping.length !== 0 ? e.pipelineMapping : {},
      e.allowManualCreation
    );
  }
  static new(e) {
    return new Jn(
      e,
      !1,
      [],
      {},
      {},
      !1
    );
  }
}
class Zn extends M {
  constructor(e, r, c, l, h, g) {
    super(e);
    w(this, "collectionName", "gamification_settings");
    this.id = e, this.enabled = r, this.resultsPerEmail = c, this.progressPerEmail = l, this.activatedBadges = h, this.company = g;
  }
  static fromData(e) {
    return e === null || typeof e == "string" || e instanceof Zn ? e : new Zn(
      e.id,
      e.enabled || !1,
      e.resultsPerEmail || !1,
      e.progressPerEmail || !1,
      e.activatedBadges || [],
      e.company ? U.fromData(e.company) : null
    );
  }
  static new(e) {
    return new Zn(
      e,
      !1,
      !1,
      !1,
      [],
      e
    );
  }
}
class Xn extends M {
  constructor(e, r, c, l, h, g, v, A, D, I, S, N, R, O, $, G, ne, Q, he, le, ge, ae, ye, be, Le, Me) {
    super(e);
    w(this, "collectionName", df.collectionName);
    this.id = e, this.logo = r, this.logoPath = c, this.name = l, this.url = h, this.email = g, this.fontFamily = v, this.buttonColorUpcoming = A, this.buttonColorCompleted = D, this.titleColorWelcomeUser = I, this.textColorWelcomeUser = S, this.subHeaderColorActive = N, this.subHeaderColorInactive = R, this.titleColorWoning = O, this.textColorInfoWoning = $, this.textColorWaardesWoning = G, this.svgColorWaardesWoning = ne, this.buttonColorRoute = Q, this.buttonBackgroundColorRoute = he, this.buttonColorRouteData = le, this.titleColorDate = ge, this.textColorDate = ae, this.buttonBackgroundColorCompleted = ye, this.backgroundColorHeader = be, this.backgroundColorPage = Le, this.emmaEnabled = Me;
  }
  get logoUrl() {
    return this.logoPath ? `${{}.VUE_APP_KEYVUE_BACKEND_BASEURL}/attachments/${this.logoPath}` : null;
  }
  static fromData(e) {
    return e === null || typeof e == "string" || e instanceof Xn ? e : new Xn(
      e.id,
      null,
      e.logoPath,
      e.name,
      e.url,
      e.email,
      e.fontFamily,
      e.buttonColorUpcoming,
      e.buttonColorCompleted,
      e.titleColorWelcomeUser,
      e.textColorWelcomeUser,
      e.subHeaderColorActive,
      e.subHeaderColorInactive,
      e.titleColorWoning,
      e.textColorInfoWoning,
      e.textColorWaardesWoning,
      e.svgColorWaardesWoning,
      e.buttonColorRoute,
      e.buttonBackgroundColorRoute,
      e.buttonColorRouteData,
      e.titleColorDate,
      e.textColorDate,
      e.buttonBackgroundColorCompleted,
      e.backgroundColorHeader,
      e.backgroundColorPage,
      e.emmaEnabled
    );
  }
  static new(e) {
    var r;
    return new Xn(
      e.id,
      null,
      "",
      ((r = e.branding) == null ? void 0 : r.displayName) ?? e.name ?? "",
      "",
      "",
      "Open Sans",
      "#55ee88",
      "#5588ee",
      "#111827",
      "#111827",
      "#0ea5e9",
      "#cbd5e1",
      "#111827",
      "#111827",
      "#111827",
      "#111827",
      "#f97316",
      "#fafafa",
      "#111827",
      "#38bdf8",
      "#111827",
      "#fafafa",
      "#e2e8f0",
      "#f1f5f9",
      !1
    );
  }
}
const Ot = class Ot extends M {
  constructor(e, r, c, l, h) {
    super(r);
    w(this, "collectionName", Cf.collectionName);
    this.company = e, this.id = r, this.name = c, this.active = l, this.channel = h;
  }
  static fromData(e) {
    return e === null || typeof e == "string" || e instanceof Ot ? e : new Ot(
      e.company ? U.fromData(e.company) : null,
      e.id,
      e.name,
      e.active,
      e.channel
    );
  }
  get isEmmaSource() {
    return this.active && this.name.toLowerCase() === Ot.EMMA;
  }
  get isSmartMarketingSource() {
    return this.active && this.name.toLowerCase() === Ot.SMART_MARKETING;
  }
  get isTypeformSource() {
    return this.active && this.name.toLowerCase() === Ot.TYPEFORM;
  }
  get isStaticSource() {
    return this.isEmmaSource || this.isSmartMarketingSource || this.isTypeformSource;
  }
  get isEditable() {
    return !this.isEmmaSource && !this.isSmartMarketingSource && !this.isTypeformSource;
  }
};
w(Ot, "EMMA", "emma"), w(Ot, "SMART_MARKETING", "smart-marketing"), w(Ot, "TYPEFORM", "typeform");
let Xe = Ot;
class U extends M {
  constructor(e, r, c, l, h, g, v, A, D, I, S, N, R, O, $, G, ne, Q, he, le, ge, ae, ye, be, Le, Me, et, tt, Ge, Mt, Ut, Ue, Se, Ft, at, Ee, $t, qt, Wt, je, ft, Ht, nt, rt, Kt, ht, It, an, Ie, vt, xn, Fe, fn, Dr, Vt, $e, Gt, hn, Cr, jt, Tr, zt, Rt, In, Rn, Pn, Nn, Sn, On, kn, Bn, Ln, Er, xr, Ir, er, li, Gs) {
    super(e);
    w(this, "collectionName", Yr.collectionName);
    w(this, "loadedIncomingReferrals", !1);
    w(this, "loadedOutgoingReferrals", !1);
    this.id = e, this.name = r, this.type = c, this.branding = l, this.targetType = h, this.invoiceEmail = g, this.defaultContactView = v, this.defaultCommentVisibility = A, this.defaultDateRange = D, this.potentialOrderValueRoles = I, this.powerBiCustomRoles = S, this.branches = N, this.incomingReferrals = R, this.outgoingReferrals = O, this.credentials = $, this.users = G, this.sources = ne, this.pipelinesEnabled = Q, this.widgetEnabled = he, this.widgetType = le, this.widgetFlowTypes = ge, this.activatedWidgetFlowTypes = ae, this.widgetGoals = ye, this.widgetPopupType = be, this.widgetPopupFlowType = Le, this.widgetPopupPosition = Me, this.widgetPopupAnimation = et, this.widgetPopupBackgroundColor = tt, this.widgetPopupTextColor = Ge, this.widgetPopupButtonColor = Mt, this.widgetPopupButtonTextColor = Ut, this.widgetPopupFont = Ue, this.widgetPopupContents = Se, this.widgetAvatarBackgroundColor = Ft, this.widgetAvatarTextColor = at, this.widgetInformationTopics = Ee, this.widgetChatTextBackground = $t, this.widgetChatText = qt, this.widgetChatUserText = Wt, this.widgetChatUserTextBorder = je, this.widgetChatInputBorder = ft, this.widgetChatInputText = Ht, this.widgetChatInputButtonActive = nt, this.widgetChatInputButtonInactive = rt, this.widgetChatInputButton = Kt, this.widgetChatInputButtonText = ht, this.widgetChatInputMultiText = It, this.widgetChatInputMultiBorder = an, this.widgetChatInputMultiSelectedText = Ie, this.widgetChatInputMultiSelectedBorder = vt, this.widgetChatInputButtonActiveText = xn, this.widgetChatInputButtonInactiveText = Fe, this.widgetAvatarCircle = fn, this.widgetAvatarStyle = Dr, this.widgetPopupOpenTime = Vt, this.winckCompanyId = $e, this.valuationPercentageModifierLow = Gt, this.valuationPercentageModifierBase = hn, this.valuationPercentageModifierHigh = Cr, this.autoCloseSettings = jt, this.orderSettings = Tr, this.gamificationSettings = zt, this.customerPortalBranding = Rt, this.permissions = In, this.license = Rn, this.note = Pn, this.pipelinePhaseShowAllTab = Nn, this.betaOptInAvailable = Sn, this.autoMailSettingsEnabled = On, this.licenseType = kn, this.modules = Bn, this.amountOfUsers = Ln, this.amountOfBranches = Er, this.virtualColleagueName = xr, this.virtualColleagueAvatar = Ir, this.virtualColleagueAiEnabled = er, this.createdAt = li, this.updatedAt = Gs;
  }
  hasCredentialsWithType(e) {
    return this.credentials.filter((r) => r instanceof xt).some((r) => r.credentialsType === e);
  }
  getCredentialsWithType(e) {
    return this.credentials.filter((r) => r instanceof xt).filter((r) => r.credentialsType === e);
  }
  getAvailableBranches(e = {}) {
    return this.branches.filter((r) => r.type === (e.type || jr.DEFAULT)).sort((r, c) => r.name.localeCompare(c.name));
  }
  getAvailableUsers(e = {}) {
    let r = this.users.filter((c) => c.active).filter((c) => c.type === (e.type || Ba.DEFAULT));
    return e.branch && (r = r.filter((c) => c.branches.some((l) => {
      var h;
      return l.id === ((h = e.branch) == null ? void 0 : h.id);
    }))), r.sort((c, l) => c.name.localeCompare(l.name));
  }
  /**
   * @deprecated to be replaced by pipelines
   */
  async ensureIncomingReferralsAreLoaded() {
    this.loadedIncomingReferrals === !1 && (this.loadedIncomingReferrals = !0, this.incomingReferrals = await Yr.getIncomingReferrals());
  }
  /**
   * @deprecated to be replaced by pipelines
   */
  async ensureOutgoingReferralsAreLoaded() {
    this.loadedOutgoingReferrals === !1 && (this.loadedOutgoingReferrals = !0, this.outgoingReferrals = await Yr.getOutgoingReferrals());
  }
  /**
   * @deprecated to be replaced by pipelines
   */
  get handledReferralTypes() {
    return this.ensureIncomingReferralsAreLoaded().then(), this.ensureOutgoingReferralsAreLoaded().then(), Array.from(/* @__PURE__ */ new Set([
      ...this.incomingReferrals,
      ...this.outgoingReferrals
    ])).filter((e) => e.active).map((e) => e.type);
  }
  /**
   * @deprecated to be replaced by pipelines
   */
  get handledInternalReferralTypes() {
    return this.ensureIncomingReferralsAreLoaded().then(), this.ensureOutgoingReferralsAreLoaded().then(), Array.from(/* @__PURE__ */ new Set([
      ...this.incomingReferrals,
      ...this.outgoingReferrals
    ])).filter((e) => e.active).filter((e) => {
      var r, c;
      return ((r = e.source) == null ? void 0 : r.id) === ((c = e.target) == null ? void 0 : c.id);
    }).map((e) => e.type);
  }
  /**
   * @deprecated to be replaced by pipelines
   */
  get handledIncomingReferralTypes() {
    return this.ensureIncomingReferralsAreLoaded().then(), Array.from(/* @__PURE__ */ new Set([
      ...this.incomingReferrals
    ])).filter((e) => e.active).map((e) => e.type);
  }
  /**
   * @deprecated to be replaced by pipelines
   */
  get handledOutgoingReferralTypes() {
    return this.ensureOutgoingReferralsAreLoaded().then(), Array.from(/* @__PURE__ */ new Set([
      ...this.outgoingReferrals
    ])).filter((e) => e.active).map((e) => e.type);
  }
  get activeSources() {
    return this.sources.filter((e) => e.active).sort((e, r) => e.name.localeCompare(r.name));
  }
  get emmaSource() {
    const e = this.activeSources.filter((r) => r.isEmmaSource);
    return e.length > 0 ? e[0] : null;
  }
  get smartMarketingSource() {
    const e = this.activeSources.filter((r) => r.isSmartMarketingSource);
    return e.length > 0 ? e[0] : null;
  }
  static fromData(e) {
    if (e === null || typeof e == "string" || e instanceof U)
      return e;
    const r = new U(
      e.id,
      e.name,
      e.type,
      e.branding ? Zr.fromData(e.branding) : null,
      e.targetType,
      e.invoiceEmail,
      e.defaultContactView,
      e.defaultCommentVisibility,
      e.defaultDateRange,
      e.potentialOrderValueRoles,
      e.powerBiCustomRoles,
      Object.values(e.branches || {}).map((c) => X.fromData(c)),
      Object.values(e.incomingReferrals || {}).map((c) => En.fromData(c)),
      Object.values(e.outgoingReferrals || {}).map((c) => En.fromData(c)),
      Object.values(e.credentials || {}).map((c) => xt.fromData(c)),
      Object.values(e.users || {}).map((c) => F.fromData(c)),
      Object.values(e.sources || {}).map((c) => Xe.fromData(c)),
      e.pipelinesEnabled,
      e.widgetEnabled,
      e.widgetType,
      e.widgetFlowTypes ?? [],
      e.activatedWidgetFlowTypes ?? [],
      e.widgetGoals ?? [],
      e.widgetPopupType,
      e.widgetPopupFlowType,
      e.widgetPopupPosition,
      e.widgetPopupAnimation,
      e.widgetPopupBackgroundColor,
      e.widgetPopupTextColor,
      e.widgetPopupButtonColor,
      e.widgetPopupButtonTextColor,
      e.widgetPopupFont,
      e.widgetPopupContents,
      e.widgetAvatarBackgroundColor,
      e.widgetAvatarTextColor,
      e.widgetInformationTopics,
      e.widgetChatTextBackground,
      e.widgetChatText,
      e.widgetChatUserText,
      e.widgetChatUserTextBorder,
      e.widgetChatInputBorder,
      e.widgetChatInputText,
      e.widgetChatInputButtonActive,
      e.widgetChatInputButtonInactive,
      e.widgetChatInputButton,
      e.widgetChatInputButtonText,
      e.widgetChatInputMultiText,
      e.widgetChatInputMultiBorder,
      e.widgetChatInputMultiSelectedText,
      e.widgetChatInputMultiSelectedBorder,
      e.widgetChatInputButtonActiveText,
      e.widgetChatInputButtonInactiveText,
      e.widgetAvatarCircle,
      e.widgetAvatarStyle,
      parseFloat(e.widgetPopupOpenTime),
      e.winckCompanyId,
      e.valuationPercentageModifierLow,
      e.valuationPercentageModifierBase,
      e.valuationPercentageModifierHigh,
      e.autoCloseSettings ? Yn.fromData(e.autoCloseSettings) : Yn.new(e.id),
      e.orderSettings ? Jn.fromData(e.orderSettings) : Jn.new(e.id),
      e.gamificationSettings ? Zn.fromData(e.gamificationSettings) : Zn.new(e.id),
      e.customerPortalBranding ? Xn.fromData(e.customerPortalBranding) : null,
      e.permissions,
      e.license,
      e.note,
      e.pipelinePhaseShowAllTab,
      e.betaOptInAvailable,
      e.autoMailSettingsEnabled,
      e.licenseType,
      e.modules,
      e.amountOfUsers,
      e.amountOfBranches,
      e.virtualColleagueName,
      e.virtualColleagueAvatar,
      e.virtualColleagueAiEnabled,
      e.createdAt,
      e.updatedAt
    );
    return r.loadedIncomingReferrals = r.incomingReferrals.length > 0, r.loadedOutgoingReferrals = r.outgoingReferrals.length > 0, r.branches.forEach((c) => c.company = c.company || r), r.users.forEach((c) => c.company = c.company || r), r;
  }
}
class Dn extends M {
  constructor(e, r, c, l, h, g) {
    super(r);
    w(this, "collectionName", sf.collectionName);
    this.user = e, this.id = r, this.dashboardId = c, this.schedule = l, this.createdAt = h, this.updatedAt = g;
  }
  static fromData(e) {
    return e === null || typeof e == "string" || e instanceof Dn ? e : new Dn(
      e.user ? F.fromData(e.user) : null,
      e.id,
      e.dashboardId,
      e.schedule,
      e.createdAt,
      e.updatedAt
    );
  }
}
class Xr extends M {
  constructor(e, r, c, l, h, g, v) {
    super(e);
    w(this, "collectionName", "gamification_badge");
    this.id = e, this.year = r, this.quarter = c, this.type = l, this.rank = h, this.points = g, this.user = v;
  }
  static fromData(e) {
    return e === null || typeof e == "string" || e instanceof Xr ? e : new Xr(
      e.id,
      e.year,
      e.quarter,
      e.type,
      e.rank,
      e.points,
      F.fromData(e.user)
    );
  }
}
class Qr extends M {
  constructor(e, r, c, l, h, g, v) {
    super(e);
    w(this, "collectionName", "gamification_score");
    this.id = e, this.year = r, this.quarter = c, this.type = l, this.score = h, this.relativeScore = g, this.user = v;
  }
  static fromData(e) {
    return e === null || typeof e == "string" || e instanceof Qr ? e : new Qr(
      e.id,
      e.year,
      e.quarter,
      e.type,
      e.score,
      e.relativeScore,
      F.fromData(e.user)
    );
  }
}
class us extends M {
  constructor(e, r, c, l, h, g, v, A, D, I, S) {
    super(r);
    w(this, "collectionName", cf.collectionName);
    this.company = e, this.id = r, this.direction = c, this.category = l, this.title = h, this.text = g, this.sort = v, this.component = A, this.cumulioId = D, this.cumulioExportId = I, this.powerBiId = S;
  }
  static fromData(e) {
    return e === null || typeof e == "string" || e instanceof us ? e : new us(
      e.company ? U.fromData(e.company) : null,
      e.id,
      e.direction,
      e.category,
      e.title,
      e.text,
      e.sort,
      e.component,
      e.cumulioId,
      e.cumulioExportId,
      e.powerBiId
    );
  }
}
class F extends M {
  constructor(e, r, c, l, h, g, v, A, D, I, S, N, R, O, $, G, ne, Q, he, le, ge, ae, ye, be, Le, Me, et, tt, Ge) {
    super(r);
    w(this, "collectionName", qs.collectionName);
    this.company = e, this.id = r, this.type = c, this.firstname = l, this.middlename = h, this.lastname = g, this.avatar = v, this.avatarUrl = A, this.email = D, this.password = I, this.role = S, this.birthdate = N, this.gender = R, this.phoneNumber = O, this.mobilePhoneNumber = $, this.absent = G, this.active = ne, this.branches = Q, this.gamificationBadges = he, this.gamificationScores = le, this.scheduledDashboardExports = ge, this.realworksAccountManager = ae, this.defaultDashboardView = ye, this.dashboardPermissions = be, this.superAdmin = Le, this.betaOptInEnabled = Me, this.autoDailyMailEnabled = et, this.autoAppointmentCreatedMailEnabled = tt, this.createdAt = Ge;
  }
  getAvailableBranches(e = {}) {
    return this.branches.filter((r) => r.type === (e.type || jr.DEFAULT)).sort((r, c) => r.name.localeCompare(c.name));
  }
  hasRole(e) {
    switch (e) {
      case Ke.EMPLOYEE:
        return this.isEmployee;
      case Ke.TEAM_LEAD:
        return this.isTeamLead;
      case Ke.BRANCH_MANAGER:
        return this.isBranchManager;
      case Ke.COMPANY_MANAGER:
        return this.isCompanyManager;
    }
    return !1;
  }
  get name() {
    return [this.firstname, this.middlename, this.lastname].filter((e) => e !== null && e !== "").join(" ");
  }
  get abbreviation() {
    return this.firstname && this.lastname ? this.firstname.substring(0, 1).toUpperCase() + this.lastname.substring(0, 1).toUpperCase() : this.firstname ? this.firstname.substring(0, 1).toUpperCase() : this.lastname ? this.lastname.substring(0, 1).toUpperCase() : "?";
  }
  get isEmployee() {
    return this.role === Ke.EMPLOYEE || this.role === Ke.TEAM_LEAD || this.role === Ke.BRANCH_MANAGER || this.role === Ke.COMPANY_MANAGER;
  }
  get isTeamLead() {
    return this.role === Ke.TEAM_LEAD || this.role === Ke.BRANCH_MANAGER || this.role === Ke.COMPANY_MANAGER;
  }
  get isBranchManager() {
    return this.role === Ke.BRANCH_MANAGER || this.role === Ke.COMPANY_MANAGER;
  }
  get isCompanyManager() {
    return this.role === Ke.COMPANY_MANAGER;
  }
  get keyVueBranches() {
    return this.branches.filter((e) => e.type !== jr.WINCK);
  }
  set keyVueBranches(e) {
    this.branches = [...e, ...this.winckBranches];
  }
  get winckBranches() {
    return this.branches.filter((e) => e.type === jr.WINCK);
  }
  set winckBranches(e) {
    this.branches = [...e, ...this.keyVueBranches];
  }
  get canViewReports() {
    return !!(this.isBranchManager || this.dashboardPermissions && this.dashboardPermissions.some((e) => e.permission === !0));
  }
  hasScheduledDashboardExport(e) {
    return this.scheduledDashboardExports.filter((r) => r instanceof Dn).some((r) => r.dashboardId === e);
  }
  getScheduledDashboardExport(e) {
    return this.scheduledDashboardExports.filter((r) => r instanceof Dn).find((r) => r.dashboardId === e) || null;
  }
  addScheduledDashboardExport(e, r) {
    const c = new Dn(
      this,
      ln(),
      e,
      r,
      /* @__PURE__ */ new Date(),
      /* @__PURE__ */ new Date()
    );
    return this.scheduledDashboardExports.push(c), c;
  }
  removeScheduledDashboardExport(e) {
    const r = this.getScheduledDashboardExport(e);
    return this.scheduledDashboardExports = this.scheduledDashboardExports.filter((c) => c !== r), r;
  }
  static get validGenders() {
    return La();
  }
  static fromData(e) {
    if (e === null || typeof e == "string" || e instanceof F)
      return e;
    const r = new F(
      e.company ? U.fromData(e.company) : null,
      e.id,
      e.type,
      e.firstname,
      e.middlename,
      e.lastname,
      e.avatar,
      e.avatarUrl,
      e.email,
      e.password,
      e.role,
      e.birthdate,
      e.gender,
      e.phoneNumber,
      e.mobilePhoneNumber,
      e.absent,
      e.active,
      Object.values(e.branches || {}).map((c) => X.fromData(c)),
      Object.values(e.gamificationBadges || {}).map((c) => Xr.fromData(c)),
      Object.values(e.gamificationScores || {}).map((c) => Qr.fromData(c)),
      Object.values(e.scheduledDashboardExports || {}).map((c) => Dn.fromData(c)),
      e.realworksAccountManagerId,
      e.defaultDashboardView,
      e.dashboardPermissions,
      e.superAdmin,
      e.betaOptInEnabled,
      e.autoDailyMailEnabled,
      e.autoAppointmentCreatedMailEnabled,
      e.createdAt
    );
    return r.branches.forEach((c) => c.company = c.company || r.company), r;
  }
  static fromOne(e) {
    var r, c, l, h;
    return F.fromData({
      // company: LegacyCompany.fromData({
      //     id: user.company?.id.toString(),
      // }),
      id: e.id.toString(),
      // type: UserType.DEFAULT,
      firstname: (r = e.name) == null ? void 0 : r.firstName,
      middlename: (c = e.name) == null ? void 0 : c.middleName,
      lastname: (l = e.name) == null ? void 0 : l.lastName,
      avatar: e.avatar,
      avatarUrl: e.avatar,
      email: (h = e.email) == null ? void 0 : h.toString(),
      // role: 'employee',
      gender: e.gender,
      active: e.active
      // branches: data.teams?.map((team: any) => Branch.fromData({
      //     id: team.id.toString(),
      //     name: team.name,
      // })),
    });
  }
}
class _r extends M {
  constructor(e, r, c, l, h, g, v, A) {
    super(e);
    w(this, "collectionName", ef.collectionName);
    this.id = e, this.event = r, this.eventData = c, this.loggedAt = l, this.contact = h, this.referral = g, this.pipelineName = v, this.loggedBy = A;
  }
  static fromData(e) {
    return e === null || typeof e == "string" || e instanceof _r ? e : new _r(
      e.id,
      e.event,
      e.eventData,
      e.loggedAt,
      e.contact,
      e.referral,
      e.pipelineName,
      e.loggedBy ? F.fromData(e.loggedBy) : null
    );
  }
  get name() {
    return this.loggedBy ? [this.loggedBy.firstname, this.loggedBy.middlename, this.loggedBy.lastname].filter((e) => e !== null).join(" ") : "AutoPilot";
  }
}
class Ar extends M {
  constructor(e, r, c, l, h, g, v, A, D, I, S, N, R, O, $, G, ne, Q, he, le, ge, ae, ye, be, Le, Me, et, tt, Ge, Mt, Ut, Ue, Se, Ft, at, Ee, $t, qt, Wt, je, ft, Ht, nt, rt, Kt, ht) {
    super(r);
    w(this, "collectionName", ja.collectionName);
    this.company = e, this.id = r, this.relatieCode = c, this.source = l, this.newSource = h, this.gender = g, this.initials = v, this.firstname = A, this.middlename = D, this.lastname = I, this.streetname = S, this.streetnumber = N, this.streetnumbersuffix = R, this.zipcode = O, this.city = $, this.country = G, this.latitude = ne, this.longitude = Q, this.birthDate = he, this.email = le, this.mobilePhonenumber = ge, this.phonenumber = ae, this.spouse = ye, this.spouseGender = be, this.spouseInitials = Le, this.spouseFirstname = Me, this.spouseMiddlename = et, this.spouseLastname = tt, this.spouseHasCustomAddress = Ge, this.spouseStreetname = Mt, this.spouseStreetnumber = Ut, this.spouseStreetnumbersuffix = Ue, this.spouseZipcode = Se, this.spouseCity = Ft, this.spouseCountry = at, this.spouseLatitude = Ee, this.spouseLongitude = $t, this.spouseBirthDate = qt, this.spouseHasCustomContactDetails = Wt, this.spouseEmail = je, this.spouseMobilePhonenumber = ft, this.spousePhonenumber = Ht, this.referrals = nt, this.eventLogs = rt, this.createdAt = Kt, this.updatedAt = ht;
  }
  get name() {
    return [this.firstname || this.initials, this.middlename, this.lastname].filter((e) => e !== null).join(" ").replaceAll(/\s+/g, " ").trim();
  }
  get spouseName() {
    return [this.spouseFirstname || this.spouseInitials, this.spouseMiddlename, this.spouseLastname].filter((e) => e !== null).join(" ").replaceAll(/\s+/g, " ").trim();
  }
  get title() {
    return this.gender === jn.MALE ? "dhr." : this.gender === jn.FEMALE ? "mevr." : "";
  }
  /**
   * Informal variant of title.
   */
  get titleInformal() {
    return this.gender === jn.MALE ? "heer" : this.gender === jn.FEMALE ? "mevrouw" : "heer/mevrouw";
  }
  /**
   * A friendly name, for use in forms. Will attempt to address a contact by firstname
   * If that fails, it will fall back to a more formal way.
   */
  get displayName() {
    return !this.firstname || this.firstname.length === 0 ? `${this.titleInformal} ${this.name}` : this.firstname;
  }
  get spouseTitle() {
    return this.spouseGender === jn.MALE ? "dhr." : this.spouseGender === jn.FEMALE ? "mevr." : "";
  }
  get address() {
    let e = "";
    return this.streetname && this.streetname.length > 0 && (e = e.trim(), e += ` ${this.streetname}`), this.streetnumber && this.streetnumber.length > 0 && (e = e.trim(), e += ` ${this.streetnumber}`), this.streetnumbersuffix && this.streetnumbersuffix.length > 0 && (e = e.trim(), e += ` ${this.streetnumbersuffix}`), this.city && this.city.length > 0 && (e = e.trim(), e += `, ${this.city}`), e;
  }
  static fromData(e) {
    return e === null || typeof e == "string" || e instanceof Ar ? e : new Ar(
      e.company ? U.fromData(e.company) : null,
      e.id,
      e.relatieCode,
      e.source,
      e.newSource ? Xe.fromData(e.newSource) : null,
      e.gender,
      e.initials,
      e.firstname,
      e.middlename,
      e.lastname,
      e.streetname,
      e.streetnumber,
      e.streetnumbersuffix,
      e.zipcode,
      e.city,
      e.country,
      e.latitude,
      e.longitude,
      e.birthDate,
      e.email,
      e.mobilePhonenumber,
      e.phonenumber,
      e.spouse || !1,
      e.spouseGender,
      e.spouseInitials,
      e.spouseFirstname,
      e.spouseMiddlename,
      e.spouseLastname,
      e.spouseHasCustomAddress || !1,
      e.spouseStreetname,
      e.spouseStreetnumber,
      e.spouseStreetnumbersuffix,
      e.spouseZipcode,
      e.spouseCity,
      e.spouseCountry,
      e.spouseLatitude,
      e.spouseLongitude,
      e.spouseBirthDate,
      e.spouseHasCustomContactDetails || !1,
      e.spouseEmail,
      e.spouseMobilePhonenumber,
      e.spousePhonenumber,
      Object.values(e.referrals || {}).map((r) => Qe.fromData(r)),
      Object.values(e.eventLogs || {}).map((r) => _r.fromData(r)),
      e.createdAt,
      e.updatedAt
    );
  }
  static get validGenders() {
    return La();
  }
}
class cn extends M {
  constructor(e, r, c, l, h, g, v, A, D) {
    super(l);
    w(this, "collectionName", bf.collectionName);
    this.company = e, this.pipeline = r, this.phases = c, this.id = l, this.status = h, this.name = g, this.active = v, this.createdAt = A, this.updatedAt = D;
  }
  static fromData(e) {
    return e === null || typeof e == "string" || e instanceof cn ? e : new cn(
      e.company ? U.fromData(e.company) : null,
      e.pipeline ? J.fromData(e.pipeline) : null,
      Object.values(e.phases || {}).map((r) => Ve.fromData(r)).sort((r, c) => r.compareTo(c)),
      e.id,
      e.status,
      e.name,
      e.active,
      e.createdAt,
      e.updatedAt
    );
  }
}
class ei extends M {
  constructor(e, r, c, l, h, g, v, A, D) {
    super(r);
    w(this, "collectionName", $a.collectionName);
    this.referral = e, this.id = r, this.name = c, this.description = l, this.source = h, this.uploadedByContact = g, this.url = v, this.createdAt = A, this.updatedAt = D;
  }
  static fromData(e) {
    return e === null || typeof e == "string" || e instanceof ei ? e : new ei(
      e.referral ? Qe.fromData(e.referral) : null,
      e.id,
      e.name,
      e.description,
      e.source,
      e.uploadedByContact ?? !1,
      e.url,
      e.createdAt,
      e.updatedAt
    );
  }
}
let Ma = class dc extends M {
  constructor(e, r, c, l, h, g, v, A) {
    super(c);
    w(this, "collectionName", Ga.collectionName);
    this.referral = e, this.user = r, this.id = c, this.comment = l, this.origin = h, this.visibility = g, this.createdAt = v, this.updatedAt = A;
  }
  static fromData(e) {
    return e === null || typeof e == "string" || e instanceof dc ? e : new dc(
      e.referral ? Qe.fromData(e.referral) : null,
      e.user ? F.fromData(e.user) : null,
      e.id,
      e.comment,
      e.origin,
      e.visibility,
      e.createdAt,
      e.updatedAt
    );
  }
};
class ti {
  constructor(i) {
    this.branches = i;
  }
  static fromData(i) {
    return i === null || i instanceof ti ? i : new ti(
      Object.values(i.branches || {}).map((e) => X.fromData(e))
    );
  }
}
class ni {
  constructor(i) {
    this.branch = i;
  }
  static fromData(i) {
    return i === null || i instanceof ni ? i : new ni(
      X.fromData(i.branch)
    );
  }
}
class ls {
  constructor(i, e, r, c, l, h, g) {
    this.type = i, this.senderName = e, this.senderEmail = r, this.subject = c, this.body = l, this.createdAt = h, this.updatedAt = g;
  }
  static fromData(i) {
    return i === null || i instanceof ls ? i : new ls(
      i.type,
      i.senderName,
      i.senderEmail,
      i.subject,
      i.body,
      i.createdAt,
      i.updatedAt
    );
  }
}
class Bt extends M {
  constructor(e, r, c, l, h, g, v, A, D) {
    super(r);
    w(this, "collectionName", Ya.collectionName);
    this.company = e, this.id = r, this.name = c, this.mortgageService = l, this.appraisalService = h, this.emailTemplates = g, this.active = v, this.createdAt = A, this.updatedAt = D;
  }
  static fromData(e) {
    return e === null || typeof e == "string" || e instanceof Bt ? e : new Bt(
      e.company ? U.fromData(e.company) : null,
      e.id,
      e.name,
      e.mortgageService ? ti.fromData(e.mortgageService) : null,
      e.appraisalService ? ni.fromData(e.appraisalService) : null,
      Object.values(e.emailTemplates || {}).map((r) => ls.fromData(r)),
      e.active,
      e.createdAt,
      e.updatedAt
    );
  }
}
class Qe extends M {
  constructor(e, r, c, l, h, g, v, A, D, I, S, N, R, O, $, G, ne, Q, he, le, ge, ae, ye, be, Le, Me, et, tt, Ge, Mt, Ut, Ue, Se, Ft, at, Ee, $t, qt, Wt, je, ft, Ht, nt, rt, Kt, ht, It, an, Ie, vt, xn, Fe, fn) {
    super(r);
    w(this, "collectionName", Ja.collectionName);
    this.contact = e, this.id = r, this.type = c, this.pipeline = l, this.phase = h, this.referredBy = g, this.referredByBranch = v, this.assignedTo = A, this.assignedToBranch = D, this.priority = I, this.status = S, this.statusReason = N, this.newStatusReason = R, this.nextActionAt = O, this.nextOrPreviousAction = $, this.nextOrPreviousAppointment = G, this.medianValuation = ne, this.manualValuation = Q, this.appointment = he, this.appointmentLocation = le, this.newBuildType = ge, this.futureStreetname = ae, this.futureStreetnumber = ye, this.futureStreetnumbersuffix = be, this.futureZipcode = Le, this.futureCity = Me, this.futureCountry = et, this.futureLatitude = tt, this.futureLongitude = Ge, this.futureFrom = Mt, this.project = Ut, this.assigneeProject = Ue, this.buildNumber = Se, this.assigneeBuildNumber = Ft, this.orderValue = at, this.leadCommission = Ee, this.nettoOrderValue = $t, this.channel = qt, this.source = Wt, this.newSource = je, this.transportDate = ft, this.productionDate = Ht, this.score = nt, this.data = rt, this.attachments = Kt, this.comments = ht, this.actions = It, this.eventLogs = an, this.permissions = Ie, this.createdAt = vt, this.updatedAt = xn, this.successfulAt = Fe, this.unsuccessfulAt = fn;
  }
  get hasNextActionData() {
    return this.nextActionAt !== null;
  }
  get hasFutureAddressData() {
    return this.futureStreetname !== null || this.futureStreetnumber !== null || this.futureStreetnumbersuffix !== null || this.futureZipcode !== null || this.futureCity !== null || this.futureCountry !== null;
  }
  get newSourceName() {
    var e;
    return typeof this.newSource == "string" ? null : ((e = this.newSource) == null ? void 0 : e.name) || null;
  }
  get hasEmmaSource() {
    return typeof this.newSource == "string" ? !1 : this.newSource ? this.newSource.isEmmaSource : !1;
  }
  get hasOrderValue() {
    return this.orderValue !== null && this.orderValue > 0;
  }
  get hasLeadCommission() {
    return this.leadCommission !== null && this.leadCommission > 0;
  }
  get hasNettoOrderValue() {
    return this.nettoOrderValue !== null && this.nettoOrderValue > 0;
  }
  get hasFinancialData() {
    return this.hasOrderValue || this.hasLeadCommission || this.hasNettoOrderValue;
  }
  get hasAttachments() {
    return this.attachments.length > 0;
  }
  get isEmmaAppraisal() {
    return "valuation" in this.data ? !0 : [gc.APPRAISAL, gc.SALE].includes(this.type) ? !!this.contact.zipcode && !!this.contact.streetnumber : !1;
  }
  get inactiveSince() {
    const e = [
      ...this.actions.map((c) => new Date(c.actionDate)),
      ...this.comments.map((c) => new Date(c.updatedAt))
    ];
    this.updatedAt && e.unshift(new Date(this.updatedAt));
    const r = new Date(Math.max(
      ...e.map((c) => c.getTime())
    ));
    return new Date(r.getTime() + 24 * 60 * 60 * 1e3);
  }
  get autoCloseDate() {
    var A, D, I, S;
    if (typeof this.assignedToBranch == "string")
      return null;
    const e = (D = (A = this.assignedToBranch) == null ? void 0 : A.company) == null ? void 0 : D.autoCloseSettings;
    if (!e || !e.closeEnabled)
      return null;
    const r = new Date(this.inactiveSince), c = e.notificationBeforeDays;
    let l = e.closeAfterDays;
    if (((I = this.pipeline) == null ? void 0 : I.autoCloseAfterDays) !== null && ((S = this.pipeline) == null ? void 0 : S.autoCloseAfterDays) !== void 0 && (l = this.pipeline.autoCloseAfterDays), !e.closeEnabledAt)
      return new Date(r.getTime() + l * 24 * 60 * 60 * 1e3);
    const h = new Date(e.closeEnabledAt), g = new Date(r.getTime() + l * 24 * 60 * 60 * 1e3), v = new Date(h.getTime() + (1 + c) * 24 * 60 * 60 * 1e3);
    return g.getTime() < v.getTime() ? v : g;
  }
  get autoCloseNotificationDate() {
    var l, h;
    if (typeof this.assignedToBranch == "string")
      return null;
    const e = (h = (l = this.assignedToBranch) == null ? void 0 : l.company) == null ? void 0 : h.autoCloseSettings;
    if (!this.autoCloseDate || !e || !e.closeEnabled || !e.notificationEnabled)
      return null;
    const r = e.notificationBeforeDays, c = new Date(this.autoCloseDate);
    return new Date(c.getTime() - r * 24 * 60 * 60 * 1e3);
  }
  static fromData(e) {
    return e === null || typeof e == "string" || e instanceof Qe ? e : new Qe(
      Ar.fromData(e.contact),
      e.id,
      e.type,
      e.pipeline ? J.fromData(e.pipeline) : null,
      e.phase ? Ve.fromData(e.phase) : null,
      e.referredBy ? F.fromData(e.referredBy) : null,
      e.referredByBranch ? X.fromData(e.referredByBranch) : null,
      e.assignedTo ? F.fromData(e.assignedTo) : null,
      e.assignedToBranch ? X.fromData(e.assignedToBranch) : null,
      e.priority || !1,
      e.status,
      e.statusReason,
      e.newStatusReason ? cn.fromData(e.newStatusReason) : null,
      e.nextActionAt,
      e.nextOrPreviousAction ? Qn.fromData(e.nextOrPreviousAction) : null,
      e.nextOrPreviousAppointment ? Qn.fromData(e.nextOrPreviousAppointment) : null,
      e.medianValuation,
      e.manualValuation,
      e.appointment,
      e.appointmentLocation,
      e.newBuildType,
      e.futureStreetname,
      e.futureStreetnumber,
      e.futureStreetnumbersuffix,
      e.futureZipcode,
      e.futureCity,
      e.futureCountry,
      e.futureLatitude,
      e.futureLongitude,
      e.futureFrom,
      e.project ? Bt.fromData(e.project) : null,
      e.assigneeProject ? Bt.fromData(e.assigneeProject) : null,
      e.buildNumber,
      e.assigneeBuildNumber,
      e.orderValue,
      e.leadCommission,
      e.nettoOrderValue,
      e.channel,
      e.source,
      e.newSource ? Xe.fromData(e.newSource) : null,
      e.transportDate,
      e.productionDate,
      e.score,
      e.data,
      Object.values(e.attachments || {}).map((r) => ei.fromData(r)),
      Object.values(e.comments || {}).map((r) => Ma.fromData(r)),
      Object.values(e.actions || {}).map((r) => Qn.fromData(r)),
      Object.values(e.eventLogs || {}).map((r) => _r.fromData(r)),
      e.permissions,
      e.createdAt,
      e.updatedAt,
      e.successfulAt,
      e.unsuccessfulAt
    );
  }
}
class Qn extends M {
  constructor(e, r, c, l, h, g, v, A, D, I, S, N = null, R = null, O = null) {
    super(r);
    w(this, "collectionName", Fa.collectionName);
    this.referral = e, this.id = r, this.type = c, this.appointmentType = l, this.actionDate = h, this.assignedTo = g, this.comment = v, this.completed = A, this.createdBy = D, this.createdAt = I, this.updatedAt = S, this.source = N, this.medewerker = R, this.realworksStatus = O;
  }
  static get availableTypes() {
    return [
      sn.MEETING,
      sn.EMAIL,
      sn.CALL,
      sn.REMINDER,
      sn.LETTER,
      sn.BILLING,
      sn.UPDATE,
      sn.NOTIFICATION
    ];
  }
  static get availableAppointmentTypes() {
    return [
      Gr.VIDEO,
      Gr.PHONE,
      Gr.OFFICE,
      Gr.CUSTOMER
    ];
  }
  static fromData(e) {
    return e === null || typeof e == "string" || e instanceof Qn ? e : new Qn(
      e.referral ? Qe.fromData(e.referral) : null,
      e.id,
      e.type,
      e.appointmentType,
      e.actionDate,
      Object.values(e.assignedTo || {}).map((r) => F.fromData(r)),
      e.comment,
      e.completed,
      e.createdBy ? F.fromData(e.createdBy) : null,
      e.createdAt,
      e.updatedAt,
      e.source ? e.source : null,
      e.medewerker,
      e.realworksStatus
    );
  }
}
class sv extends V {
  constructor() {
    super(...arguments);
    w(this, "collectionName", "actions");
    w(this, "parseData", Qn.fromData);
  }
  async create(e) {
    const r = W.cloneDeep(e);
    return e.referral instanceof Qe && (r.referral = e.referral.resourceIdentifier), e.assignedTo && (r.assignedTo = e.assignedTo.map((c) => c instanceof F ? c.resourceIdentifier : mc(qs.collectionName, c))), super.create(r);
  }
  async update(e, r) {
    const c = W.cloneDeep(r);
    return r.comment === null && (c.comment = ""), r.referral instanceof Qe && (c.referral = r.referral.resourceIdentifier), r.assignedTo && (c.assignedTo = r.assignedTo.map((l) => l instanceof F ? l.resourceIdentifier : mc(qs.collectionName, l))), super.update(e, c);
  }
  async getForUser(e) {
    return (await this.client.get(`${e.resourceIdentifier}/actions`)).data["hydra:member"].map((l) => this.parseData(l));
  }
}
class ov extends V {
  constructor() {
    super(...arguments);
    w(this, "collectionName", "attachments");
    w(this, "parseData", ei.fromData);
  }
  async create(e) {
    const r = new FormData();
    for (const [c, l] of Object.entries(e))
      l === void 0 || c === "collectionName" || r.append(c, l instanceof M ? l.resourceIdentifier : l);
    return await this.client.post(`${this.basePath}/attachments`, r, {
      headers: {
        "Content-Type": "multipart/form-data"
      }
    }), await this.wait(5), await this.get(e.id);
  }
  async createWithFile(e, r, c) {
    const l = new FormData();
    l.append("referral", e.resourceIdentifier), l.append("id", r), l.append("file", c), await this.client.post(`${this.basePath}/attachments`, l, {
      headers: {
        "Content-Type": "multipart/form-data"
      }
    }), await this.wait();
  }
}
class cv extends V {
  constructor() {
    super(...arguments);
    w(this, "collectionName", "branches");
    w(this, "parseData", X.fromData);
  }
  async create(e) {
    const r = W.cloneDeep(e);
    return e.company instanceof U && (r.company = e.company.resourceIdentifier), e.pipelines && (r.pipelines = e.pipelines.filter((c) => c instanceof J).map((c) => c.resourceIdentifier)), super.create(r);
  }
  async update(e, r) {
    const c = W.cloneDeep(r);
    return r.company instanceof U && (c.company = r.company.resourceIdentifier), super.update(e, c);
  }
  async canDelete(e) {
    return (await this.client.put(`${this.basePath}/${this.collectionName}/${e}/can_delete`, {})).data.canDelete;
  }
}
class as extends M {
  constructor(e, r, c, l, h, g, v, A, D, I, S, N) {
    super(r);
    w(this, "collectionName", Ha.collectionName);
    this.branch = e, this.id = r, this.fromDate = c, this.untilDate = l, this.referralPipeline = h, this.referralType = g, this.orderType = v, this.direction = A, this.quantity = D, this.turnover = I, this.createdAt = S, this.updatedAt = N;
  }
  static fromData(e) {
    return e === null || typeof e == "string" || e instanceof as ? e : new as(
      e.branch ? X.fromData(e.branch) : null,
      e.id,
      e.fromDate,
      e.untilDate,
      e.referralPipeline ? J.fromData(e.referralPipeline) : null,
      e.referralType,
      e.orderType,
      e.direction,
      e.quantity,
      e.turnover,
      e.createdAt,
      e.updatedAt
    );
  }
}
class uv extends V {
  constructor() {
    super(...arguments);
    w(this, "collectionName", "branch_targets");
    w(this, "parseData", as.fromData);
  }
  async create(e) {
    const r = W.cloneDeep(e);
    return e.referralPipeline instanceof J && (r.referralPipeline = e.referralPipeline.resourceIdentifier), super.create(r);
  }
  async update(e, r) {
    const c = W.cloneDeep(r);
    return r.referralPipeline instanceof J && (c.referralPipeline = r.referralPipeline.resourceIdentifier), super.update(e, c);
  }
}
class lv extends V {
  constructor() {
    super(...arguments);
    w(this, "collectionName", "brandings");
    w(this, "parseData", Zr.fromData);
  }
  async update(e, r) {
    const c = new FormData();
    return Object.keys(r).forEach((l) => {
      c.append(l, r[l]);
    }), await this.client.post(`${this.basePath}/${this.collectionName}/${e}`, c, {
      headers: {
        "Content-Type": "multipart/form-data"
      }
    }), await this.wait(), this.get(e);
  }
}
class fs extends M {
  constructor(e, r, c, l, h, g, v, A, D, I, S, N, R, O, $, G, ne, Q, he, le, ge, ae, ye, be, Le, Me, et, tt, Ge, Mt, Ut, Ue, Se, Ft, at, Ee, $t, qt, Wt, je, ft, Ht, nt, rt, Kt, ht, It, an, Ie, vt, xn, Fe, fn, Dr, Vt, $e, Gt, hn, Cr, jt, Tr, zt, Rt, In, Rn, Pn, Nn, Sn, On, kn, Bn, Ln, Er, xr, Ir, er) {
    super(e);
    w(this, "collectionName", Va.collectionName);
    this.id = e, this.aankoopmakelaar_1_min = r, this.aankoopmakelaar_1_max = c, this.aankoopmakelaar_1_price = l, this.aankoopmakelaar_2_min = h, this.aankoopmakelaar_2_max = g, this.aankoopmakelaar_2_price = v, this.aankoopmakelaar_3_min = A, this.aankoopmakelaar_3_max = D, this.aankoopmakelaar_3_price = I, this.aankoopmakelaar_4_min = S, this.aankoopmakelaar_4_max = N, this.aankoopmakelaar_4_price = R, this.aankoopmakelaar_5_min = O, this.aankoopmakelaar_5_max = $, this.aankoopmakelaar_5_price = G, this.taxatiekosten_1_min = ne, this.taxatiekosten_1_max = Q, this.taxatiekosten_1_price = he, this.taxatiekosten_2_min = le, this.taxatiekosten_2_max = ge, this.taxatiekosten_2_price = ae, this.taxatiekosten_3_min = ye, this.taxatiekosten_3_max = be, this.taxatiekosten_3_price = Le, this.taxatiekosten_4_min = Me, this.taxatiekosten_4_max = et, this.taxatiekosten_4_price = tt, this.taxatiekosten_5_min = Ge, this.taxatiekosten_5_max = Mt, this.taxatiekosten_5_price = Ut, this.notariskosten_kk_1_min = Ue, this.notariskosten_kk_1_max = Se, this.notariskosten_kk_1_price = Ft, this.notariskosten_kk_2_min = at, this.notariskosten_kk_2_max = Ee, this.notariskosten_kk_2_price = $t, this.notariskosten_kk_3_min = qt, this.notariskosten_kk_3_max = Wt, this.notariskosten_kk_3_price = je, this.notariskosten_kk_4_min = ft, this.notariskosten_kk_4_max = Ht, this.notariskosten_kk_4_price = nt, this.notariskosten_kk_5_min = rt, this.notariskosten_kk_5_max = Kt, this.notariskosten_kk_5_price = ht, this.notariskosten_von_1_min = It, this.notariskosten_von_1_max = an, this.notariskosten_von_1_price = Ie, this.notariskosten_von_2_min = vt, this.notariskosten_von_2_max = xn, this.notariskosten_von_2_price = Fe, this.notariskosten_von_3_min = fn, this.notariskosten_von_3_max = Dr, this.notariskosten_von_3_price = Vt, this.notariskosten_von_4_min = $e, this.notariskosten_von_4_max = Gt, this.notariskosten_von_4_price = hn, this.notariskosten_von_5_min = Cr, this.notariskosten_von_5_max = jt, this.notariskosten_von_5_price = Tr, this.advieskosten_1_min = zt, this.advieskosten_1_max = Rt, this.advieskosten_1_price = In, this.advieskosten_2_min = Rn, this.advieskosten_2_max = Pn, this.advieskosten_2_price = Nn, this.advieskosten_3_min = Sn, this.advieskosten_3_max = On, this.advieskosten_3_price = kn, this.advieskosten_4_min = Bn, this.advieskosten_4_max = Ln, this.advieskosten_4_price = Er, this.advieskosten_5_min = xr, this.advieskosten_5_max = Ir, this.advieskosten_5_price = er;
  }
  static fromData(e) {
    return e === null || typeof e == "string" || e instanceof fs ? e : new fs(
      e.id,
      e.aankoopmakelaar_1_min,
      e.aankoopmakelaar_1_max,
      e.aankoopmakelaar_1_price,
      e.aankoopmakelaar_2_min,
      e.aankoopmakelaar_2_max,
      e.aankoopmakelaar_2_price,
      e.aankoopmakelaar_3_min,
      e.aankoopmakelaar_3_max,
      e.aankoopmakelaar_3_price,
      e.aankoopmakelaar_4_min,
      e.aankoopmakelaar_4_max,
      e.aankoopmakelaar_4_price,
      e.aankoopmakelaar_5_min,
      e.aankoopmakelaar_5_max,
      e.aankoopmakelaar_5_price,
      e.taxatiekosten_1_min,
      e.taxatiekosten_1_max,
      e.taxatiekosten_1_price,
      e.taxatiekosten_2_min,
      e.taxatiekosten_2_max,
      e.taxatiekosten_2_price,
      e.taxatiekosten_3_min,
      e.taxatiekosten_3_max,
      e.taxatiekosten_3_price,
      e.taxatiekosten_4_min,
      e.taxatiekosten_4_max,
      e.taxatiekosten_4_price,
      e.taxatiekosten_5_min,
      e.taxatiekosten_5_max,
      e.taxatiekosten_5_price,
      e.notariskosten_kk_1_min,
      e.notariskosten_kk_1_max,
      e.notariskosten_kk_1_price,
      e.notariskosten_kk_2_min,
      e.notariskosten_kk_2_max,
      e.notariskosten_kk_2_price,
      e.notariskosten_kk_3_min,
      e.notariskosten_kk_3_max,
      e.notariskosten_kk_3_price,
      e.notariskosten_kk_4_min,
      e.notariskosten_kk_4_max,
      e.notariskosten_kk_4_price,
      e.notariskosten_kk_5_min,
      e.notariskosten_kk_5_max,
      e.notariskosten_kk_5_price,
      e.notariskosten_von_1_min,
      e.notariskosten_von_1_max,
      e.notariskosten_von_1_price,
      e.notariskosten_von_2_min,
      e.notariskosten_von_2_max,
      e.notariskosten_von_2_price,
      e.notariskosten_von_3_min,
      e.notariskosten_von_3_max,
      e.notariskosten_von_3_price,
      e.notariskosten_von_4_min,
      e.notariskosten_von_4_max,
      e.notariskosten_von_4_price,
      e.notariskosten_von_5_min,
      e.notariskosten_von_5_max,
      e.notariskosten_von_5_price,
      e.advieskosten_1_min,
      e.advieskosten_1_max,
      e.advieskosten_1_price,
      e.advieskosten_2_min,
      e.advieskosten_2_max,
      e.advieskosten_2_price,
      e.advieskosten_3_min,
      e.advieskosten_3_max,
      e.advieskosten_3_price,
      e.advieskosten_4_min,
      e.advieskosten_4_max,
      e.advieskosten_4_price,
      e.advieskosten_5_min,
      e.advieskosten_5_max,
      e.advieskosten_5_price
    );
  }
}
class av extends V {
  constructor() {
    super(...arguments);
    w(this, "collectionName", "checklist_settings");
    w(this, "parseData", fs.fromData);
  }
  async getForCompany(e) {
    const r = await this.client.get(`${this.basePath}/companies/${e.id}/${this.collectionName}`);
    return this.parseData(r.data);
  }
}
class fv extends V {
  constructor() {
    super(...arguments);
    w(this, "collectionName", "comments");
    w(this, "parseData", Ma.fromData);
  }
  async create(e) {
    var c;
    const r = {
      ...e,
      origin: (c = e.origin) == null ? void 0 : c.toString()
    };
    return await this.client.post(`${this.basePath}/${this.collectionName}`, r), await this.wait(), await this.get(e.id, !0);
  }
  async update(e, r) {
    var l;
    const c = {
      ...r,
      origin: (l = r.origin) == null ? void 0 : l.toString()
    };
    return await this.client.put(`${this.basePath}/${this.collectionName}/${e}`, c), await this.wait(), await this.get(e, !0);
  }
  async delete(e) {
    await this.client.delete(`${this.basePath}/${this.collectionName}/${e}`), await this.wait();
  }
}
class vr extends M {
  constructor(e, r, c, l, h, g, v) {
    super(e);
    w(this, "collectionName", Af.collectionName);
    this.id = e, this.pipeline = r, this.excludedFields = c, this.sourceCompany = l, this.sourceEnabled = h, this.targetCompany = g, this.targetEnabled = v;
  }
  get isActive() {
    return this.sourceEnabled && this.targetEnabled && this.pipeline !== null;
  }
  get isInterrupted() {
    return this.sourceEnabled === !1 || this.targetEnabled === !1 || this.pipeline === null;
  }
  get isInterruptedRemotely() {
    return this.sourceEnabled === !0 && this.targetEnabled === !1;
  }
  get isInterruptedLocally() {
    return this.sourceEnabled === !1 && this.targetEnabled === !0;
  }
  static fromData(e) {
    return e === null || typeof e == "string" || e instanceof vr ? e : new vr(
      e.id,
      e.pipeline ? J.fromData(e.pipeline) : null,
      e.excludedFields,
      U.fromData(e.sourceCompany),
      e.sourceEnabled,
      U.fromData(e.targetCompany),
      e.targetEnabled
    );
  }
}
class hv extends V {
  constructor() {
    super(...arguments);
    w(this, "collectionName", "companies");
    w(this, "parseData", U.fromData);
    w(this, "currentCompany", null);
  }
  async getForOneApp(e, r = !1) {
    if (!r && this.cache.has(e + "-one-app"))
      return this.cache.get(e + "-one-app");
    const c = await this.client.get(`${this.basePath}/${this.collectionName}/${e}/one_app`), l = this.parseData(c.data);
    return this.cache.set(e + "-one-app", l), this.cache.get(e + "-one-app");
  }
  async update(e, r) {
    const c = W.cloneDeep(r);
    return delete c.branches, delete c.incomingReferrals, delete c.outgoingReferrals, delete c.credentials, delete c.users, delete c.shares, r.customerPortalBranding instanceof Xn && (c.customerPortalBranding = r.customerPortalBranding.resourceIdentifier), super.update(e, c);
  }
  async getCurrentCompany() {
    return !this.currentCompany && this.isAuthenticated && this.decodedAccessToken && (this.currentCompany = await this.get(this.decodedAccessToken.companyId)), this.currentCompany;
  }
  async reloadCurrentCompany() {
    return this.isAuthenticated && this.decodedAccessToken && (this.currentCompany = await this.get(this.decodedAccessToken.companyId, !0)), this.currentCompany;
  }
  async getIncomingReferrals() {
    return this.decodedAccessToken ? (await this.client.get(`${this.basePath}/${this.collectionName}/${this.decodedAccessToken.companyId}/incoming_referrals`)).data["hydra:member"].map((r) => En.fromData(r)) : [];
  }
  async getOutgoingReferrals() {
    return this.decodedAccessToken ? (await this.client.get(`${this.basePath}/${this.collectionName}/${this.decodedAccessToken.companyId}/outgoing_referrals`)).data["hydra:member"].map((r) => En.fromData(r)) : [];
  }
  async getIncomingConnections() {
    return this.decodedAccessToken ? (await this.client.get(`${this.basePath}/${this.collectionName}/${this.decodedAccessToken.companyId}/incoming_connections`)).data["hydra:member"].map((r) => vr.fromData(r)) : [];
  }
  async getOutgoingConnections() {
    return this.decodedAccessToken ? (await this.client.get(`${this.basePath}/${this.collectionName}/${this.decodedAccessToken.companyId}/outgoing_connections`)).data["hydra:member"].map((r) => vr.fromData(r)) : [];
  }
  async updateWidgetSettings(e, r) {
    return await this.client.put(`${this.basePath}/${this.collectionName}/${e}/widget_settings`, {
      widgetEnabled: r.widgetEnabled,
      widgetType: r.widgetType,
      widgetFlowTypes: r.widgetFlowTypes,
      widgetGoals: r.widgetGoals,
      widgetPopupType: r.widgetPopupType,
      widgetPopupFlowType: r.widgetPopupFlowType,
      widgetPopupPosition: r.widgetPopupPosition,
      widgetPopupAnimation: r.widgetPopupAnimation,
      widgetPopupBackgroundColor: r.widgetPopupBackgroundColor,
      widgetPopupTextColor: r.widgetPopupTextColor,
      widgetPopupButtonColor: r.widgetPopupButtonColor,
      widgetPopupButtonTextColor: r.widgetPopupButtonTextColor,
      widgetPopupFont: r.widgetPopupFont,
      widgetPopupContents: r.widgetPopupContents,
      widgetAvatarBackgroundColor: r.widgetAvatarBackgroundColor,
      widgetAvatarTextColor: r.widgetAvatarTextColor,
      widgetInformationTopics: r.widgetInformationTopics,
      widgetChatTextBackground: r.widgetChatTextBackground,
      widgetChatText: r.widgetChatText,
      widgetChatUserText: r.widgetChatUserText,
      widgetChatUserTextBorder: r.widgetChatUserTextBorder,
      widgetChatInputBorder: r.widgetChatInputBorder,
      widgetChatInputText: r.widgetChatInputText,
      widgetChatInputButtonActive: r.widgetChatInputButtonActive,
      widgetChatInputButtonInactive: r.widgetChatInputButtonInactive,
      widgetChatInputButton: r.widgetChatInputButton,
      widgetChatInputButtonText: r.widgetChatInputButtonText,
      widgetChatInputMultiText: r.widgetChatInputMultiText,
      widgetChatInputMultiBorder: r.widgetChatInputMultiBorder,
      widgetChatInputMultiSelectedText: r.widgetChatInputMultiSelectedText,
      widgetChatInputMultiSelectedBorder: r.widgetChatInputMultiSelectedBorder,
      widgetChatInputButtonActiveText: r.widgetChatInputButtonActiveText,
      widgetChatInputButtonInactiveText: r.widgetChatInputButtonInactiveText,
      widgetAvatarCircle: r.widgetAvatarCircle,
      widgetAvatarStyle: r.widgetAvatarStyle,
      widgetPopupOpenTime: r.widgetPopupOpenTime
    }), await this.wait(), r;
  }
  async updateActiveCampaignCredentials(e, r) {
    await this.client.put(`${this.basePath}/${this.collectionName}/${e}/active_campaign_credentials`, {
      includeInternalContacts: r.includeInternalContacts,
      includeExternalContacts: r.includeExternalContacts,
      includeRealworksRelaties: r.includeRealworksRelaties,
      syncedRealworksKenmerken: r.syncedRealworksKenmerken,
      excludedRealworksKenmerken: r.excludedRealworksKenmerken,
      syncedRealworksRelatietypes: r.syncedRealworksRelatietypes,
      syncedRealworksStatus: r.syncedRealworksStatus,
      updatedFrom: r.updatedFrom,
      updatedUntil: r.updatedUntil,
      apiUrl: r.apiUrl,
      apiKey: r.apiKey,
      eventTrackingAccountId: r.eventTrackingAccountId,
      eventTrackingKey: r.eventTrackingKey,
      defaultTeams: r.defaultTeams,
      defaultStatus: r.defaultStatus,
      emmaDefaults: r.emmaDefaults || {},
      syncedRealworksAgendatypes: r.syncedRealworksAgendatypes,
      syncedRealworksTaaktypes: r.syncedRealworksTaaktypes,
      enabled: r.enabled,
      user: r.updatedBy instanceof F ? r.updatedBy.resourceIdentifier : null
    }), await this.wait();
  }
  async updateMailchimpCredentials(e, r) {
    await this.client.put(`${this.basePath}/${this.collectionName}/${e}/mailchimp_credentials`, {
      includeInternalContacts: r.includeInternalContacts,
      includeExternalContacts: r.includeExternalContacts,
      includeRealworksRelaties: r.includeRealworksRelaties,
      syncedRealworksKenmerken: r.syncedRealworksKenmerken,
      updatedFrom: r.updatedFrom,
      updatedUntil: r.updatedUntil,
      enabled: r.enabled,
      user: r.updatedBy instanceof F ? r.updatedBy.resourceIdentifier : null
    }), await this.wait();
  }
  async updateTypeformCredentials(e, r) {
    return await this.client.put(`${this.basePath}/${this.collectionName}/${e}/typeform_credentials`, {
      apiKey: r.apiKey,
      enabled: r.enabled,
      firstViewingAgendaTypes: r.firstViewingAgendaTypes,
      secondViewingAgendaTypes: r.secondViewingAgendaTypes,
      user: r.updatedBy instanceof F ? r.updatedBy.resourceIdentifier : null
    }), await this.wait(), r;
  }
  async getOrderSettings(e) {
    const r = await this.client.get(`${this.basePath}/${this.collectionName}/${e}/order_settings`);
    return Jn.fromData(r.data);
  }
  async updateOrderSettings(e, r) {
    return await this.client.put(`${this.basePath}/${this.collectionName}/${e}/order_settings`, r), await this.wait(), await this.getOrderSettings(e);
  }
  async getAutoCloseSettings(e) {
    const r = await this.client.get(`${this.basePath}/${this.collectionName}/${e}/auto_close_settings`);
    return Yn.fromData(r.data);
  }
  async updateAutoCloseSettings(e, r) {
    return await this.client.put(`${this.basePath}/${this.collectionName}/${e}/auto_close_settings`, r), await this.wait(), await this.getAutoCloseSettings(e);
  }
}
class pv extends V {
  constructor() {
    super(...arguments);
    w(this, "collectionName", "contacts");
    w(this, "parseData", Ar.fromData);
  }
}
class mv extends V {
  constructor() {
    super(...arguments);
    w(this, "collectionName", "credentials");
    w(this, "parseData", xt.fromData);
  }
}
class gv extends V {
  async mention(i, e) {
    return await super.axiosClient.post(`${this.basePath}/mention`, {
      comment: i.resourceIdentifier,
      users: e.map((r) => r.resourceIdentifier)
    });
  }
}
class dv extends V {
  constructor() {
    super(...arguments);
    w(this, "collectionName", "projects");
    w(this, "parseData", Bt.fromData);
  }
  async update(e, r) {
    const c = W.cloneDeep(r);
    return r.mortgageService instanceof ti && (c.mortgageService.branches = r.mortgageService.branches.map((l) => l.resourceIdentifier)), r.appraisalService instanceof ni && r.appraisalService.branch instanceof X && (c.appraisalService.branch = r.appraisalService.branch.resourceIdentifier), super.update(e, c);
  }
}
class Ec {
  constructor() {
    w(this, "age90", 0);
    w(this, "age180", 0);
    w(this, "age365", 0);
    w(this, "ageOther", 0);
    w(this, "scorePositive", 0);
    w(this, "scoreNeutral", 0);
    w(this, "scoreNegative", 0);
    w(this, "countsForAllPipelines", 0);
    w(this, "countsPerPipeline", []);
    w(this, "countsPerPhase", []);
    w(this, "countsPerCategory", []);
    w(this, "countsPerStatus", []);
  }
  findWithContent(i, e, r = null) {
    return r = r || Object.keys(this[i]), r.find((c) => {
      for (const l of this.countsPerCategory)
        if (l[e] === c && l.count > 0)
          return l[e];
    }) || null;
  }
  firstPhaseWithContent(i = null) {
    return this.findWithContent("countsPerPhase", "phase", i);
  }
  firstCategoryWithContent() {
    return this.findWithContent("countsPerCategory", "category", [
      zn.ENTRY,
      zn.APPROACH,
      zn.DECISION
    ]);
  }
  firstStatusWithContent() {
    return this.findWithContent("countsPerStatus", "status", [
      zr.PROCESSED,
      zr.SUCCESSFUL,
      zr.CLOSED
    ]);
  }
  countForPipeline(i) {
    var e;
    return i === null ? this.countsForAllPipelines : (i instanceof J && (i = i.id), ((e = this.countsPerPipeline.find((r) => r.pipeline === i)) == null ? void 0 : e.count) ?? 0);
  }
  countForPhase(i) {
    var e;
    return ((e = this.countsPerPhase.find((r) => r.phase === i)) == null ? void 0 : e.count) ?? 0;
  }
  countForCategory(i) {
    var e;
    return ((e = this.countsPerCategory.find((r) => r.category === i)) == null ? void 0 : e.count) ?? 0;
  }
  countForStatus(i) {
    var e;
    return ((e = this.countsPerStatus.find((r) => r.status === i)) == null ? void 0 : e.count) ?? 0;
  }
  get hasAgeData() {
    return this.age90 > 0 || this.age180 > 0 || this.age365 > 0 || this.ageOther > 0;
  }
  get hasScoreData() {
    return this.scorePositive > 0 || this.scoreNeutral > 0 || this.scoreNegative > 0;
  }
  get hasPipelineData() {
    return this.countsForAllPipelines > 0 || this.countsPerPipeline.length > 0 || this.countsPerPhase.length > 0 || this.countsPerCategory.length > 0 || this.countsPerStatus.length > 0;
  }
  static fromJson(i) {
    const e = new Ec();
    return e.age90 = Number.parseInt(i.age90, 10), e.age180 = Number.parseInt(i.age180, 10), e.age365 = Number.parseInt(i.age365, 10), e.ageOther = Number.parseInt(i.ageOther, 10), e.scorePositive = Number.parseInt(i.scorePositive, 10), e.scoreNeutral = Number.parseInt(i.scoreNeutral, 10), e.scoreNegative = Number.parseInt(i.scoreNegative, 10), e.countsForAllPipelines = Number.parseInt(i.countsForAllPipelines, 10), e.countsPerPipeline = i.countsPerPipeline.map((r) => ({
      pipeline: r.pipeline,
      count: Number.parseInt(r.count, 10)
    })), e.countsPerPhase = i.countsPerPhase.map((r) => ({
      phase: r.phase,
      count: Number.parseInt(r.count, 10)
    })), e.countsPerCategory = i.countsPerCategory.map((r) => ({
      category: r.category,
      count: Number.parseInt(r.count, 10)
    })), e.countsPerStatus = i.countsPerStatus.map((r) => ({
      status: r.status,
      count: Number.parseInt(r.count, 10)
    })), e;
  }
}
class yv extends V {
  constructor() {
    super(...arguments);
    w(this, "collectionName", "referrals");
    w(this, "parseData", Qe.fromData);
  }
  async create(e) {
    const r = W.cloneDeep(e);
    return e.project instanceof Bt && (r.project = e.project.resourceIdentifier), e.newSource instanceof Xe && (r.newSource = e.newSource.resourceIdentifier), e.assigneeProject instanceof Bt && (r.assigneeProject = e.assigneeProject.resourceIdentifier), e.phase instanceof Ve && (r.phase = e.phase.resourceIdentifier), e.pipeline instanceof J && (r.pipeline = e.pipeline.resourceIdentifier), super.create(r);
  }
  async update(e, r) {
    const c = W.cloneDeep(r);
    return r.assignedTo instanceof F && (c.assignedTo = r.assignedTo.resourceIdentifier), r.newSource instanceof Xe && (c.newSource = r.newSource.resourceIdentifier), r.assignedToBranch instanceof X && (c.assignedToBranch = r.assignedToBranch.resourceIdentifier), r.contact instanceof Ar && (c.contact = r.contact.resourceIdentifier), r.referredBy instanceof F && (c.referredBy = r.referredBy.resourceIdentifier), r.referredByBranch instanceof X && (c.referredByBranch = r.referredByBranch.resourceIdentifier), r.project instanceof Bt && (c.project = r.project.resourceIdentifier), r.assigneeProject instanceof Bt && (c.assigneeProject = r.assigneeProject.resourceIdentifier), r.phase instanceof Ve && (c.phase = r.phase.resourceIdentifier), r.pipeline instanceof J && (c.pipeline = r.pipeline.resourceIdentifier), r.newStatusReason instanceof cn && (c.newStatusReason = r.newStatusReason.resourceIdentifier), r.orderValue !== null && (c.orderValue = Number(r.orderValue)), r.leadCommission !== null && (c.leadCommission = Number(r.leadCommission)), r.futureFrom === "" && (c.futureFrom = null), super.update(e, c);
  }
  async delete(e) {
    await this.client.put(`${this.basePath}/${this.collectionName}/${e}/delete`, {
      id: e
    }), await this.wait();
  }
  async updateScore(e, r) {
    await this.client.put(`${this.basePath}/${this.collectionName}/${e}/update_score`, {
      score: r
    }), await this.wait();
  }
  async updateManualValuationData(e, r, c) {
    await this.client.put(`${this.basePath}/${this.collectionName}/${e}/update_manual_valuation_data`, {
      valuation: r,
      user: c.resourceIdentifier
    }), await this.wait();
  }
  async updateReferredBy(e, r, c, l) {
    await this.client.put(`${this.basePath}/${this.collectionName}/${r}/update_referred_by`, {
      company: e.resourceIdentifier,
      referredBy: c.resourceIdentifier,
      changedBy: l.resourceIdentifier
    }), await this.wait();
  }
  async updateHousetypeData(e, r) {
    await this.client.put(`${this.basePath}/${this.collectionName}/${e}/update_housetype_data`, {
      housetype: r
    }), await this.wait();
  }
  async notify(e, r, c) {
    await this.client.put(
      `${this.basePath}/${this.collectionName}/${e}/notify`,
      { type: r, targets: c }
    ), await this.wait();
  }
  async sendNewBuildProjectReferralEmail(e, r) {
    await this.client.put(`${this.basePath}/${this.collectionName}/${e}/notify/send-new-build-project-referral-email`, {
      referralId: e,
      type: r
    }), await this.wait();
  }
  async previewProjectEmailTemplate(e, r) {
    const c = await this.client.put(`${this.basePath}/${this.collectionName}/${e}/project/preview-email-template`, {
      id: e,
      type: r
    });
    return await this.wait(), c.data;
  }
  async updateExtendedAppraisal(e) {
    await this.client.put(`${this.basePath}/${this.collectionName}/${e}/update-extended-appraisal`, {
      id: e
    }, {
      headers: {
        "Content-Type": "application/json"
      }
    }), await this.wait();
  }
  async getReferralCountForStatus(e, r) {
    return (await this.client.post(`${this.basePath}/${this.collectionName}/counts/list`, {
      status: e
    }, {
      params: {
        ...r,
        status: null
      }
    })).data;
  }
  async getCounts(e, r, c, l, h) {
    const g = await this.client.post(`${this.basePath}/${this.collectionName}/new_counts`, {
      pipeline: e,
      phase: r,
      status: c,
      category: l
    }, {
      params: {
        ...h,
        pipeline: null,
        phase: null,
        status: null,
        category: null
      }
    });
    return Ec.fromJson(g.data);
  }
}
class wv extends V {
  constructor() {
    super(...arguments);
    w(this, "collectionName", "referral_nodes");
    w(this, "parseData", En.fromData);
  }
  async create(e) {
    const r = W.cloneDeep(e);
    return e.source instanceof U && (r.source = e.source.resourceIdentifier), e.target instanceof U && (r.target = e.target.resourceIdentifier), await super.create(r);
  }
  async update(e, r) {
    const c = W.cloneDeep(r);
    return r.source instanceof U && (c.source = r.source.resourceIdentifier), r.target instanceof U && (c.target = r.target.resourceIdentifier), await super.update(e, c);
  }
}
class _v extends V {
  constructor() {
    super(...arguments);
    w(this, "collectionName", "realworks_credentials");
    w(this, "parseData", Tn.fromData);
  }
  buildData(e) {
    return e.company instanceof U && (e.company = e.company.resourceIdentifier), e.createdBy instanceof F && (e.user = e.createdBy.resourceIdentifier, delete e.createdBy), e.updatedBy instanceof F && (e.user = e.updatedBy.resourceIdentifier, delete e.updatedBy), e.agendaBranch instanceof X && (e.agendaBranch = e.agendaBranch.resourceIdentifier), e;
  }
  async create(e) {
    return super.create(
      this.buildData(e)
    );
  }
  async update(e, r) {
    return super.update(
      e,
      this.buildData(r)
    );
  }
  async validate(e) {
    return (await this.client.post(`${this.basePath}/service/realworks/validate_credentials`, {
      apiKey: e.apiKey
    })).data;
  }
}
class Av extends V {
  constructor() {
    super(...arguments);
    w(this, "collectionName", "users");
    w(this, "parseData", F.fromData);
    w(this, "currentUser", null);
  }
  async getForOneApp(e, r = !1) {
    if (!r && this.cache.has(e + "-one-app"))
      return this.cache.get(e + "-one-app");
    const c = await this.client.get(`${this.basePath}/${this.collectionName}/${e}/one_app`), l = this.parseData(c.data);
    return this.cache.set(e + "-one-app", l), this.cache.get(e + "-one-app");
  }
  async getCurrentUser() {
    return !this.currentUser && this.isAuthenticated && this.decodedAccessToken && (this.currentUser = await this.get(this.decodedAccessToken.id)), this.currentUser;
  }
  async create(e) {
    const r = W.cloneDeep(e);
    e.company instanceof U && (r.company = e.company.resourceIdentifier), r.branches = e.branches.map((l) => l.resourceIdentifier);
    const c = new FormData();
    return Object.keys(r).forEach((l) => {
      r[l] && (Array.isArray(r[l]) ? r[l].forEach((g) => c.append(`${l}[]`, g)) : c.append(l, r[l]));
    }), await this.client.post(
      `${this.basePath}/${this.collectionName}`,
      c,
      {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      }
    ), await this.wait(), await this.get(e.id, !0);
  }
  async update(e, r) {
    const c = W.cloneDeep(r);
    r.company instanceof U && (c.company = r.company.resourceIdentifier), c.branches = r.branches.map((h) => h.id);
    const l = new FormData();
    return Object.keys(c).forEach((h) => {
      h !== "active" && h !== "dashboardPermissions" && !c[h] || (Array.isArray(c[h]) ? c[h].forEach((v) => l.append(`${h}[]`, v)) : l.append(h, c[h]));
    }), await this.client.post(
      `${this.basePath}/${this.collectionName}/${e}`,
      l,
      {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      }
    ), await this.client.put(
      `${this.basePath}/${this.collectionName}/${e}/update_dashboard_permissions`,
      c
    ), await this.wait(), await this.get(e, !0);
  }
  async updateAvatar(e, r) {
    const c = new FormData();
    return c.append("avatar", r), await this.client.post(
      `${this.basePath}/${this.collectionName}/${e}/update_avatar`,
      c,
      {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      }
    ), await this.get(e, !0);
  }
  async canDelete(e) {
    return (await this.client.put(`${this.basePath}/${this.collectionName}/${e}/can_delete`, {})).data.canDelete;
  }
}
class hs extends M {
  constructor(e, r, c, l, h, g, v, A, D, I, S, N) {
    super(r);
    w(this, "collectionName", Qa.collectionName);
    this.user = e, this.id = r, this.fromDate = c, this.untilDate = l, this.referralPipeline = h, this.referralType = g, this.orderType = v, this.direction = A, this.quantity = D, this.turnover = I, this.createdAt = S, this.updatedAt = N;
  }
  static fromData(e) {
    return e === null || typeof e == "string" || e instanceof hs ? e : new hs(
      e.user ? F.fromData(e.user) : null,
      e.id,
      e.fromDate,
      e.untilDate,
      e.referralPipeline ? J.fromData(e.referralPipeline) : null,
      e.referralType,
      e.orderType,
      e.direction,
      e.quantity,
      e.turnover,
      e.createdAt,
      e.updatedAt
    );
  }
}
class vv extends V {
  constructor() {
    super(...arguments);
    w(this, "collectionName", "user_targets");
    w(this, "parseData", hs.fromData);
  }
  async create(e) {
    const r = W.cloneDeep(e);
    return e.referralPipeline instanceof J && (r.referralPipeline = e.referralPipeline.resourceIdentifier), super.create(r);
  }
  async update(e, r) {
    const c = W.cloneDeep(r);
    return r.referralPipeline instanceof J && (c.referralPipeline = r.referralPipeline.resourceIdentifier), super.update(e, c);
  }
}
class bv extends V {
  constructor() {
    super(...arguments);
    w(this, "collectionName", "event_logs");
    w(this, "parseData", _r.fromData);
  }
}
class ps extends M {
  constructor(e, r, c, l, h, g, v, A, D, I, S, N, R, O, $, G, ne, Q) {
    super(r);
    w(this, "collectionName", tf.collectionName);
    this.company = e, this.id = r, this.triggerType = c, this.changedField = l, this.changedFieldValue = h, this.emptyField = g, this.delayQuantity = v, this.delayUnit = A, this.referralPipeline = D, this.referralType = I, this.referralOrigin = S, this.actionType = N, this.actionAppointmentType = R, this.actionAssignTo = O, this.actionAssignToType = $, this.actionComment = G, this.createdAt = ne, this.updatedAt = Q;
  }
  static fromData(e) {
    return e == null || typeof e == "string" || e instanceof ps ? e : new ps(
      e.company,
      e.id,
      e.triggerType,
      e.changedField,
      e.changedFieldValue,
      e.emptyField,
      e.delayQuantity,
      e.delayUnit,
      e.referralPipeline ? J.fromData(e.referralPipeline) : null,
      e.referralType,
      e.referralOrigin,
      e.actionType,
      e.actionAppointmentType,
      Object.values(e.actionAssignTo || {}).map((r) => F.fromData(r)),
      e.actionAssignToType,
      e.actionComment,
      e.createdAt,
      e.updatedAt
    );
  }
}
class Dv extends V {
  constructor() {
    super(...arguments);
    w(this, "collectionName", "triggered_actions");
    w(this, "parseData", ps.fromData);
  }
  async create(e) {
    const r = W.cloneDeep(e);
    return e.actionAssignTo && (r.actionAssignTo = e.actionAssignTo.filter((c) => c instanceof F).map((c) => c.resourceIdentifier)), e.company instanceof U && (r.company = e.company.resourceIdentifier), e.referralPipeline instanceof J && (r.referralPipeline = e.referralPipeline.resourceIdentifier), e.actionComment === null && (r.actionComment = ""), super.create(r);
  }
  async update(e, r) {
    const c = W.cloneDeep(r);
    return r.referralPipeline instanceof J && (c.referralPipeline = r.referralPipeline.resourceIdentifier), r.actionComment === null && (c.actionComment = ""), r.actionAssignTo && (c.actionAssignTo = r.actionAssignTo.filter((l) => l instanceof F).map((l) => l.resourceIdentifier)), super.update(e, c);
  }
}
class ms extends M {
  constructor(e, r, c, l, h, g, v, A, D, I, S, N, R, O, $, G, ne, Q) {
    super(e);
    w(this, "collectionName", nf.collectionName);
    this.id = e, this.company = r, this.realworksCredentials = c, this.realworksKenmerkId = l, this.referralPipeline = h, this.referralType = g, this.referralReferredByPreference = v, this.referralReferredByBranch = A, this.referralReferredBy = D, this.referralAssignedToBranch = I, this.referralAssignedTo = S, this.referralSource = N, this.referralNewSource = R, this.referralComment = O, this.maxDaysForExistingReferrals = $, this.active = G, this.createdAt = ne, this.updatedAt = Q;
  }
  static fromData(e) {
    return e === null || typeof e == "string" || e instanceof ms ? e : new ms(
      e.id,
      U.fromData(e.company),
      e.realworksCredentials ? Tn.fromData(e.realworksCredentials) : null,
      e.realworksKenmerkId,
      e.referralPipeline ? J.fromData(e.referralPipeline) : null,
      e.referralType,
      e.referralReferredByPreference,
      e.referralReferredByBranch ? X.fromData(e.referralReferredByBranch) : null,
      e.referralReferredBy ? F.fromData(e.referralReferredBy) : null,
      e.referralAssignedToBranch ? X.fromData(e.referralAssignedToBranch) : null,
      e.referralAssignedTo ? F.fromData(e.referralAssignedTo) : null,
      e.referralSource,
      e.referralNewSource ? Xe.fromData(e.referralNewSource) : null,
      e.referralComment,
      e.maxDaysForExistingReferrals,
      e.active,
      e.createdAt,
      e.updatedAt
    );
  }
}
class Cv extends V {
  constructor() {
    super(...arguments);
    w(this, "collectionName", "triggered_referrals");
    w(this, "parseData", ms.fromData);
  }
  async create(e) {
    const r = W.cloneDeep(e);
    return r.realworksKenmerkId = e.realworksKenmerkId.toString(), W.isEmpty(e.referralComment) && (r.referralComment = ""), e.company instanceof U && (r.company = e.company.resourceIdentifier), e.realworksCredentials instanceof Tn && (r.realworksCredentials = e.realworksCredentials.resourceIdentifier), e.referralPipeline instanceof J && (r.referralPipeline = e.referralPipeline.resourceIdentifier), e.referralAssignedToBranch instanceof X && (r.referralAssignedToBranch = e.referralAssignedToBranch.resourceIdentifier), e.referralAssignedTo instanceof F && (r.referralAssignedTo = e.referralAssignedTo.resourceIdentifier), e.referralReferredByBranch instanceof X && (r.referralReferredByBranch = e.referralReferredByBranch.resourceIdentifier), e.referralReferredBy instanceof F && (r.referralReferredBy = e.referralReferredBy.resourceIdentifier), e.referralNewSource instanceof Xe && (r.referralNewSource = e.referralNewSource.resourceIdentifier), super.create(r);
  }
  async update(e, r) {
    const c = W.cloneDeep(r);
    return c.realworksKenmerkId = r.realworksKenmerkId.toString(), W.isEmpty(r.referralComment) && (c.referralComment = ""), r.company instanceof U && (c.company = r.company.resourceIdentifier), r.realworksCredentials instanceof Tn && (c.realworksCredentials = r.realworksCredentials.resourceIdentifier), r.referralPipeline instanceof J && (c.referralPipeline = r.referralPipeline.resourceIdentifier), r.referralAssignedToBranch instanceof X && (c.referralAssignedToBranch = r.referralAssignedToBranch.resourceIdentifier), r.referralAssignedTo instanceof F && (c.referralAssignedTo = r.referralAssignedTo.resourceIdentifier), r.referralReferredByBranch instanceof X && (c.referralReferredByBranch = r.referralReferredByBranch.resourceIdentifier), r.referralReferredBy instanceof F && (c.referralReferredBy = r.referralReferredBy.resourceIdentifier), r.referralNewSource instanceof Xe && (c.referralNewSource = r.referralNewSource.resourceIdentifier), super.update(e, c);
  }
}
class xc extends M {
  constructor(e, r, c, l) {
    super(e);
    w(this, "collectionName", rf.collectionName);
    this.id = e, this.groep = r, this.omschrijving = c, this.actief = l;
  }
  static fromData(e) {
    return new xc(
      e.id,
      e.company,
      e.omschrijving,
      e.actief
    );
  }
}
class Tv extends V {
  constructor() {
    super(...arguments);
    w(this, "collectionName", "service/realworks/kenmerken");
    w(this, "parseData", xc.fromData);
  }
}
class Ev extends V {
  constructor() {
    super(...arguments);
    w(this, "collectionName", "scheduled_dashboard_exports");
    w(this, "parseData", Dn.fromData);
  }
  async create(e) {
    const r = W.cloneDeep(e);
    return e.user instanceof F && (r.user = e.user.resourceIdentifier), super.create(r);
  }
  async update(e, r) {
    const c = W.cloneDeep(r);
    return r.user instanceof F && (c.user = r.user.resourceIdentifier), super.update(e, c);
  }
}
class gs extends M {
  constructor(e, r, c, l, h, g, v) {
    super(r);
    w(this, "collectionName", of.collectionName);
    this.company = e, this.id = r, this.type = c, this.orderType = l, this.referralType = h, this.referralPipeline = g, this.percentage = v;
  }
  static fromData(e) {
    return e === null || typeof e == "string" || e instanceof gs ? e : new gs(
      U.fromData(e.company),
      e.id,
      e.type,
      e.orderType,
      e.referralType,
      J.fromData(e.referralPipeline),
      e.percentage
    );
  }
}
class xv extends V {
  constructor() {
    super(...arguments);
    w(this, "collectionName", "shares");
    w(this, "parseData", gs.fromData);
  }
  async create(e) {
    const r = W.cloneDeep(e);
    return e.company instanceof U && (r.company = e.company.resourceIdentifier), e.referralPipeline instanceof J && (r.referralPipeline = e.referralPipeline.resourceIdentifier), super.create(r);
  }
  async update(e, r) {
    const c = W.cloneDeep(r);
    return r.company instanceof U && (c.company = r.company.resourceIdentifier), r.referralPipeline instanceof J && (c.referralPipeline = r.referralPipeline.resourceIdentifier), super.update(e, c);
  }
}
class Iv extends V {
  constructor() {
    super(...arguments);
    w(this, "collectionName", "dashboards");
    w(this, "parseData", us.fromData);
  }
  async create(e) {
    const r = W.cloneDeep(e);
    return e.company instanceof U && (r.company = e.company.resourceIdentifier), super.create(r);
  }
}
class ri extends M {
  constructor(e, r, c, l, h, g, v, A, D = !1) {
    super(r);
    w(this, "collectionName", ff.collectionName);
    this.offer = e, this.id = r, this.name = c, this.description = l, this.price = h, this.type = g, this.optional = v, this.widgetFlowType = A, this.included = D;
  }
  static fromData(e) {
    return e === null || typeof e == "string" || e instanceof ri ? e : new ri(
      ii.fromData(e.offer),
      e.id,
      e.name,
      e.description,
      e.price,
      e.type,
      e.optional,
      e.widgetFlowType,
      !e.optional
    );
  }
}
class ii extends M {
  constructor(e, r, c, l, h, g, v) {
    super(e);
    w(this, "collectionName", uf.collectionName);
    this.id = e, this.name = r, this.description = c, this.imageUrl = l, this.url = h, this.tags = g, this.products = v;
  }
  static fromData(e) {
    return e === null || typeof e == "string" || e instanceof ii ? e : new ii(
      e.id,
      e.name,
      e.description,
      e.imageUrl,
      e.url,
      e.tags,
      Object.values(e.products || {}).map((r) => ri.fromData(r))
    );
  }
}
class Rv extends V {
  constructor() {
    super(...arguments);
    w(this, "collectionName", "offers");
    w(this, "parseData", ii.fromData);
  }
  async requestOffer(e) {
    await this.client.post(`${this.basePath}/${this.collectionName}`, {
      offer: e.offer,
      user: e.user.resourceIdentifier
    }), await this.wait();
  }
}
class ds {
  constructor(i, e, r, c, l, h) {
    this.id = i, this.branch = e, this.user = r, this.orderValue = c, this.createdAt = l, this.updatedAt = h;
  }
  static fromData(i) {
    return i === null || typeof i == "string" || i instanceof ds ? i : new ds(
      i.id,
      i.branch ? X.fromData(i.branch) : null,
      i.user ? F.fromData(i.user) : null,
      i.orderValue,
      i.createdAt,
      i.updatedAt
    );
  }
}
class ys extends M {
  constructor(e, r, c, l, h, g, v, A, D, I, S, N, R, O, $) {
    super(r);
    w(this, "collectionName", lf.collectionName);
    this.referral = e, this.id = r, this.type = c, this.assignedToBranch = l, this.assignedTo = h, this.status = g, this.transactionDate = v, this.transactionValue = A, this.askingPrice = D, this.orderValue = I, this.involvedUsers = S, this.orderValueShares = N, this.productionDate = R, this.createdAt = O, this.updatedAt = $;
  }
  static fromData(e) {
    return e === null || typeof e == "string" || e instanceof ys ? e : new ys(
      Qe.fromData(e.referral),
      e.id,
      e.type,
      e.assignedToBranch ? X.fromData(e.assignedToBranch) : null,
      e.assignedTo ? F.fromData(e.assignedTo) : null,
      e.status,
      e.transactionDate ? new Date(e.transactionDate) : null,
      e.transactionValue || 0,
      e.askingPrice || 0,
      e.orderValue || 0,
      Object.values(e.involvedUsers || {}).map((r) => F.fromData(r)),
      Object.values(e.orderValueShares || {}).map((r) => ds.fromData(r)),
      e.productionDate ? new Date(e.productionDate) : null,
      e.createdAt,
      e.updatedAt
    );
  }
}
class Pv extends V {
  constructor() {
    super(...arguments);
    w(this, "collectionName", "orders");
    w(this, "parseData", ys.fromData);
  }
  async update(e, r) {
    const c = W.cloneDeep(r);
    return c.orderValue = Number(r.orderValue), c.transactionValue = Number(r.transactionValue), c.askingPrice = Number(r.askingPrice), c.orderValue === 0 && (c.orderValue = null), c.transactionValue === 0 && (c.transactionValue = null), c.askingPrice === 0 && (c.askingPrice = null), r.referral instanceof Qe && (c.referral = r.referral.resourceIdentifier), r.assignedTo instanceof F && (c.assignedTo = r.assignedTo.resourceIdentifier), r.assignedToBranch instanceof X && (c.assignedToBranch = r.assignedToBranch.resourceIdentifier), r.involvedUsers && (c.involvedUsers = r.involvedUsers.map((l) => l instanceof F ? l.resourceIdentifier : l)), c.orderValueShares = r.orderValueShares.map((l) => ({
      ...l,
      orderValue: l.orderValue || 0,
      user: l.user instanceof F ? l.user.resourceIdentifier : l.user,
      branch: l.branch instanceof X ? l.branch.resourceIdentifier : l.branch,
      order: r.resourceIdentifier
    })), super.update(e, c);
  }
  async getOrderCountForType(e, r) {
    return (await this.client.post(`${this.basePath}/${this.collectionName}/counts/list`, {
      type: e
    }, {
      params: r
    })).data;
  }
}
class Nv extends V {
  constructor() {
    super(...arguments);
    w(this, "collectionName", "products");
    w(this, "parseData", ri.fromData);
  }
}
class ws extends M {
  constructor(e, r, c, l, h, g, v, A, D) {
    super(r);
    w(this, "collectionName", hf.collectionName);
    this.company = e, this.id = r, this.name = c, this.description = l, this.url = h, this.productId = g, this.active = v, this.createdAt = A, this.updatedAt = D;
  }
  static fromData(e) {
    return e === null || typeof e == "string" || e instanceof ws ? e : new ws(
      e.company ? U.fromData(e.company) : null,
      e.id,
      e.name,
      e.description,
      e.url,
      e.productId,
      e.active,
      e.createdAt,
      e.updatedAt
    );
  }
}
class Sv extends V {
  constructor() {
    super(...arguments);
    w(this, "collectionName", "printable_documents");
    w(this, "parseData", ws.fromData);
  }
  async create(e) {
    const r = new FormData();
    for (const [c, l] of Object.entries(e))
      l === void 0 || c === "collectionName" || r.append(c, l instanceof M ? l.resourceIdentifier : l);
    return await this.client.post(`${this.basePath}/printable_documents`, r, {
      headers: {
        "Content-Type": "multipart/form-data"
      }
    }), await this.wait(), await this.get(e.id, !0);
  }
  async createWithFile(e, r) {
    return e.file = r, await this.create(e);
  }
  async update(e, r) {
    const c = new FormData();
    for (const [l, h] of Object.entries(r))
      h === void 0 || l === "collectionName" || c.append(l, h instanceof M ? h.resourceIdentifier : h);
    return await this.client.post(`${this.basePath}/printable_documents/${e}`, c, {
      headers: {
        "Content-Type": "multipart/form-data"
      }
    }), await this.wait(), await this.get(r.id, !0);
  }
  async updateWithFile(e, r, c) {
    return r.file = c, await this.update(e, r);
  }
}
class _s extends M {
  constructor(e, r, c, l, h, g, v, A, D, I, S, N, R, O, $, G, ne, Q) {
    super(r);
    w(this, "collectionName", pf.collectionName);
    this.company = e, this.id = r, this.documentId = c, this.documentName = l, this.documentDescription = h, this.productId = g, this.shippingCompanyName = v, this.shippingName = A, this.shippingStreetname = D, this.shippingStreetnumber = I, this.shippingStreetnumbersuffix = S, this.shippingZipcode = N, this.shippingCity = R, this.shippingCountry = O, this.status = $, this.trackingUrl = G, this.createdAt = ne, this.updatedAt = Q;
  }
  static fromData(e) {
    return e === null || typeof e == "string" || e instanceof _s ? e : new _s(
      e.company ? U.fromData(e.company) : null,
      e.id,
      e.documentId,
      e.documentName,
      e.documentDescription,
      e.productId,
      e.shippingCompanyName,
      e.shippingName,
      e.shippingStreetname,
      e.shippingStreetnumber,
      e.shippingStreetnumbersuffix,
      e.shippingZipcode,
      e.shippingCity,
      e.shippingCountry,
      e.status,
      e.trackingUrl,
      e.createdAt,
      e.updatedAt
    );
  }
}
class Ov extends V {
  constructor() {
    super(...arguments);
    w(this, "collectionName", "printed_documents");
    w(this, "parseData", _s.fromData);
  }
}
class As extends M {
  constructor(e, r, c, l, h, g, v, A, D, I, S, N, R, O, $, G, ne, Q, he, le, ge, ae, ye, be) {
    super(e);
    w(this, "collectionName", mf.collectionName);
    this.id = e, this.company = r, this.kenmerken = c, this.agendaTypes = l, this.agendaStatus = h, this.taakTypes = g, this.taakStatus = v, this.referralTypes = A, this.statuses = D, this.statusReasons = I, this.pipeline = S, this.phases = N, this.toStatus = R, this.toStatusReason = O, this.toNewStatusReason = $, this.toPhase = G, this.assignToMedewerker = ne, this.comment = Q, this.notifyAssignedTo = he, this.active = le, this.applyToTriggeredReferrals = ge, this.applyToTriggeredReferralsPastDays = ae, this.createdAt = ye, this.updatedAt = be;
  }
  get triggerType() {
    return this.kenmerken.length > 0 ? "kenmerken" : this.agendaTypes.length > 0 ? "agendaTypes" : this.taakTypes.length > 0 ? "taakTypes" : "kenmerken";
  }
  static fromData(e) {
    return e === null || typeof e == "string" || e instanceof As ? e : new As(
      e.id,
      e.company,
      e.kenmerken,
      e.agendaTypes,
      e.agendaStatus,
      e.taakTypes,
      e.taakStatus,
      e.referralTypes,
      e.statuses,
      e.statusReasons,
      e.pipeline ? J.fromData(e.pipeline) : null,
      e.phases ? e.phases.map((r) => Ve.fromData(r)) : [],
      e.toStatus,
      e.toStatusReason,
      e.toNewStatusReason ? cn.fromData(e.toNewStatusReason) : null,
      e.toPhase ? Ve.fromData(e.toPhase) : null,
      e.assignToMedewerker,
      e.comment,
      e.notifyAssignedTo,
      e.active,
      e.applyToTriggeredReferrals,
      e.applyToTriggeredReferralsPastDays,
      e.createdAt,
      e.updatedAt
    );
  }
}
class kv extends V {
  constructor() {
    super(...arguments);
    w(this, "collectionName", "realworks_status_rules");
    w(this, "parseData", As.fromData);
  }
  async create(e) {
    const r = W.cloneDeep(e);
    return e.company instanceof U && (r.company = e.company.resourceIdentifier), e.pipeline instanceof J && (r.pipeline = e.pipeline.resourceIdentifier), r.phases = e.phases.map((c) => c.resourceIdentifier), e.toNewStatusReason instanceof cn && (r.toNewStatusReason = e.toNewStatusReason.resourceIdentifier), e.toPhase instanceof Ve && (r.toPhase = e.toPhase.resourceIdentifier), e.comment === null && (r.comment = ""), super.create(r);
  }
  async update(e, r) {
    const c = W.cloneDeep(r);
    return r.company instanceof U && (c.company = r.company.resourceIdentifier), r.pipeline instanceof J && (c.pipeline = r.pipeline.resourceIdentifier), c.phases = r.phases.map((l) => l.resourceIdentifier), r.toNewStatusReason instanceof cn && (c.toNewStatusReason = r.toNewStatusReason.resourceIdentifier), r.toPhase instanceof Ve && (c.toPhase = r.toPhase.resourceIdentifier), r.comment === null && (c.comment = ""), super.update(e, c);
  }
}
class vs extends M {
  constructor(e, r, c, l, h, g, v, A, D, I, S, N, R, O, $, G, ne) {
    super(ln());
    w(this, "collectionName", Za.collectionName);
    this.openLeads = e, this.newLeads = r, this.unreachableLeads = c, this.pendingLeads = l, this.appointmentLeads = h, this.proposalLeads = g, this.onHoldLeads = v, this.processedLeads = A, this.successfulLeads = D, this.unsuccessfulLeads = I, this.chanceHighLeads = S, this.chanceNeutralLeads = N, this.chanceLowLeads = R, this.age90Leads = O, this.age180Leads = $, this.age365Leads = G, this.teams = ne, this.openLeads = e, this.newLeads = r, this.unreachableLeads = c, this.pendingLeads = l, this.appointmentLeads = h, this.proposalLeads = g, this.onHoldLeads = v, this.processedLeads = A, this.successfulLeads = D, this.unsuccessfulLeads = I, this.chanceHighLeads = S, this.chanceNeutralLeads = N, this.chanceLowLeads = R, this.age90Leads = O, this.age180Leads = $, this.age365Leads = G, this.teams = ne;
  }
  static fromData(e) {
    return e === null || typeof e == "string" || e instanceof vs ? e : new vs(
      e.openLeads,
      e.newLeads,
      e.unreachableLeads,
      e.pendingLeads,
      e.appointmentLeads,
      e.proposalLeads,
      e.onHoldLeads,
      e.processedLeads,
      e.successfulLeads,
      e.unsuccessfulLeads,
      e.chanceHighLeads,
      e.chanceNeutralLeads,
      e.chanceLowLeads,
      e.age90Leads,
      e.age180Leads,
      e.age365Leads,
      e.teams
    );
  }
}
class Bv extends V {
  constructor() {
    super(...arguments);
    w(this, "collectionName", "referrals");
  }
  async getReferralCount(e, r, c) {
    const l = await this.client.post(`${this.basePath}/${this.collectionName}/count`, {
      owner: e ? "user" : "team",
      type: r ? "assigned" : "created",
      selectedTeam: c
    });
    return vs.fromData(l.data);
  }
}
class bs extends M {
  constructor(e, r, c) {
    super(ln());
    w(this, "collectionName", af.collectionName);
    this.pendingOrders = e, this.successfulOrders = r, this.unsuccessfulOrders = c, this.pendingOrders = e, this.successfulOrders = r, this.unsuccessfulOrders = c;
  }
  static fromData(e) {
    return e === null || typeof e == "string" || e instanceof bs ? e : new bs(
      e.pendingOrders,
      e.successfulOrders,
      e.unsuccessfulOrders
    );
  }
}
class Lv extends V {
  constructor() {
    super(...arguments);
    w(this, "collectionName", "orders");
  }
  async getOrderCount(e, r) {
    const c = await this.client.post(`${this.basePath}/${this.collectionName}/count`, {
      owner: e ? "user" : "team",
      type: r ? "assigned" : "created"
    });
    return bs.fromData(c.data);
  }
}
class Ds extends M {
  constructor(e, r, c, l, h, g, v, A, D = 0, I = !1, S, N, R) {
    super(r);
    w(this, "collectionName", gf.collectionName);
    this.company = e, this.id = r, this.name = c, this.referralType = l, this.pipeline = h, this.assignedToCompany = g, this.assignedToBranch = v, this.status = A, this.score = D, this.priority = I, this.source = S, this.newSource = N, this.additionalComment = R;
  }
  get url() {
    if (!this.company)
      throw new Error("Cannot generate URL; company is not set");
    return [
      {}.VUE_APP_KEYVUE_BACKEND_BASEURL,
      {}.VUE_APP_KEYVUE_BACKEND_BASEPATH,
      "/service/active_campaign/referral?",
      new URLSearchParams({
        company: this.company.id,
        webhook: this.id
      }).toString()
    ].join("");
  }
  static fromData(e) {
    return e === null || typeof e == "string" || e instanceof Ds ? e : new Ds(
      e.company ? U.fromData(e.company) : null,
      e.id,
      e.name,
      e.referralType,
      e.pipeline ? J.fromData(e.pipeline) : null,
      e.assignedToCompany ? U.fromData(e.assignedToCompany) : null,
      e.assignedToBranch ? X.fromData(e.assignedToBranch) : null,
      e.status,
      e.score,
      e.priority,
      e.source,
      e.newSource ? Xe.fromData(e.newSource) : null,
      e.additionalComment
    );
  }
}
class Mv extends V {
  constructor() {
    super(...arguments);
    w(this, "collectionName", "webhooks");
    w(this, "parseData", Ds.fromData);
  }
  async create(e) {
    const r = W.cloneDeep(e);
    return e.company instanceof U && (r.company = e.company.resourceIdentifier), e.assignedToCompany instanceof U && (r.assignedToCompany = e.assignedToCompany.resourceIdentifier), e.assignedToBranch instanceof X && (r.assignedToBranch = e.assignedToBranch.resourceIdentifier), e.pipeline instanceof J && (r.pipeline = e.pipeline.resourceIdentifier), e.newSource instanceof Xe && (r.newSource = e.newSource.resourceIdentifier), super.create(r);
  }
  async update(e, r) {
    const c = W.cloneDeep(r);
    return delete c.company, r.assignedToCompany instanceof U && (c.assignedToCompany = r.assignedToCompany.resourceIdentifier), r.assignedToBranch instanceof X && (c.assignedToBranch = r.assignedToBranch.resourceIdentifier), r.pipeline instanceof J && (c.pipeline = r.pipeline.resourceIdentifier), r.newSource instanceof Xe && (c.newSource = r.newSource.resourceIdentifier), super.update(e, c);
  }
}
class Uv extends V {
  constructor() {
    super(...arguments);
    w(this, "collectionName", "gamification_settings");
    w(this, "parseData", Zn.fromData);
  }
  async create(e) {
    const r = W.cloneDeep(e);
    return e.company instanceof U && (r.company = e.company.resourceIdentifier), super.create(r);
  }
  async update(e, r) {
    const c = W.cloneDeep(r);
    return r.company instanceof U && (c.company = r.company.resourceIdentifier), super.update(e, c);
  }
}
class Fv extends V {
  constructor() {
    super(...arguments);
    w(this, "collectionName", "gamification_badges");
    w(this, "parseData", Xr.fromData);
  }
}
class $v extends V {
  constructor() {
    super(...arguments);
    w(this, "collectionName", "gamification_scores");
    w(this, "parseData", Qr.fromData);
  }
}
class Cs {
  constructor(i) {
    this.href = i;
  }
  static fromData(i) {
    return i === null || typeof i == "string" || i instanceof Cs ? i : new Cs(
      i.href
    );
  }
}
class Ts {
  constructor(i) {
    this.href = i;
  }
  static fromData(i) {
    return i === null || typeof i == "string" || i instanceof Ts ? i : new Ts(
      i.href
    );
  }
}
class gr {
  constructor(i, e, r, c, l, h) {
    this.id = i, this.ref = e, this.title = r, this.properties = c, this.attachment = l, this.layout = h, this.initProperties(this.properties);
  }
  get description() {
    return this.properties.description;
  }
  set description(i) {
    this.properties.description = i;
  }
  get type() {
    return "welcome_screen";
  }
  initProperties(i = {}) {
    const e = {
      description: { default: "" },
      show_button: { default: !1 },
      button_text: { default: "" }
    };
    for (const r of Object.keys(e)) {
      const c = e[r], l = r in this.properties ? this.properties[r] : null, h = "default" in c ? c.default : null;
      i[r] = l ?? h;
    }
    this.properties = i;
  }
  getAllowedReferenceOptions(i, e) {
    const r = [];
    return i.hidden.forEach((c) => {
      r.push({
        label: c,
        value: e("hidden", c)
      });
    }), r;
  }
  getAllowedReferences(i, e) {
    return this.getAllowedReferenceOptions(i, e).map((r) => r.value);
  }
  toRequestData() {
    const i = {
      id: this.id,
      ref: this.ref,
      title: this.title,
      properties: this.properties
    };
    return this.attachment && (i.attachment = this.attachment), this.layout && (i.layout = this.layout), i;
  }
  static fromData(i) {
    return i === null || typeof i == "string" || i instanceof gr ? i : new gr(
      i.id,
      i.ref,
      i.title || "",
      i.properties || {},
      i.attachment,
      i.layout
    );
  }
}
class si {
  constructor(i, e, r) {
    this.id = i, this.op = e, this.vars = r;
  }
  toRequestData() {
    return {
      op: this.op,
      vars: this.vars
    };
  }
  static fromData(i) {
    return i === null || typeof i == "string" || i instanceof si ? i : new si(
      i.id || ln(),
      i.op,
      i.vars
    );
  }
}
class ui {
  constructor(i, e, r, c) {
    this.id = i, this.op = e, this.vars = r, this.flattenedOp = c;
  }
  toCondition() {
    return new si(
      this.id,
      this.op,
      this.vars
    );
  }
  static fromCondition(i, e) {
    return new ui(
      i.id,
      i.op,
      i.vars,
      e
    );
  }
  static getFieldType(i) {
    if (!i)
      return "text";
    const e = {
      text: ["short_text", "long_text", "dropdown", "email", "website"],
      numeric: ["number", "opinion_scale", "rating"],
      date: ["date"],
      choice: ["multiple_choice", "picture_choice", "yes_no", "legal"],
      file: ["file_upload"]
    };
    for (const r of Object.keys(e))
      if (e[r].includes(i.type))
        return r;
    return null;
  }
  static getFieldOps(i) {
    const e = this.getFieldType(i);
    return e ? this.getOps(e) : [];
  }
  static getOps(i) {
    const e = {
      text: ["equal", "not_equal", "begins_with", "ends_with", "contains", "not_contains"],
      numeric: ["equal", "not_equal", "lower_than", "lower_equal_than", "greater_than", "greater_equal_than"],
      date: ["on", "not_on", "earlier_than", "earlier_than_or_on", "later_than", "later_than_or_on"],
      choice: ["is", "is_not"],
      file: ["answered"]
    };
    return i in e ? e[i] : [];
  }
}
class Es {
  constructor(i, e, r, c, l, h, g) {
    this.id = i, this.ref = e, this.title = r, this._type = c, this.properties = l, this.attachment = h, this.layout = g, this.initProperties(this.properties);
  }
  get description() {
    return this.properties.description;
  }
  set description(i) {
    this.properties.description = i;
  }
  get type() {
    return this._type || "thankyou_screen";
  }
  set type(i) {
    this._type = i, this.initProperties();
  }
  initProperties(i = {}) {
    if (this.isDefault) {
      this.properties = i;
      return;
    }
    const e = {
      description: { types: ["thankyou_screen"], default: "" },
      show_button: { types: ["thankyou_screen"], default: !1 },
      button_text: { types: ["thankyou_screen"], default: "" },
      button_mode: { types: ["thankyou_screen"], default: "default_redirect" },
      redirect_url: { types: ["thankyou_screen", "url_redirect"], default: "" },
      share_icons: { types: ["thankyou_screen"], default: !1 }
    };
    for (const r of Object.keys(e)) {
      const c = e[r], l = "types" in c ? c.types : [];
      if (l.length > 0 && !l.includes(this.type))
        continue;
      const h = r in this.properties ? this.properties[r] : null, g = "default" in c ? c.default : null;
      i[r] = h ?? g;
    }
    this.properties = i;
  }
  getAllowedReferenceOptions(i, e) {
    const r = [];
    return i.hidden.forEach((c) => {
      r.push({
        label: c,
        value: e("hidden", c)
      });
    }), i.fields.forEach((c) => {
      ui.getFieldOps(c).length !== 0 && r.push({
        label: c.title.replaceAll(Ua, "_"),
        value: e("field", c.ref)
      });
    }), r;
  }
  getAllowedReferences(i, e) {
    return this.getAllowedReferenceOptions(i, e).map((r) => r.value);
  }
  get isDefault() {
    return this.id === "DefaultTyScreen";
  }
  toRequestData() {
    const i = {
      id: this.id,
      ref: this.ref,
      title: this.title,
      type: this.type
    }, e = this.properties;
    return e.button_mode && e.button_mode !== "redirect" && delete e.redirect_url, i.properties = e, this.attachment && (i.attachment = this.attachment), this.layout && (i.layout = this.layout), i;
  }
  static fromData(i) {
    return i === null || typeof i == "string" || i instanceof Es ? i : new Es(
      i.id,
      i.ref,
      i.title || "",
      i.type,
      i.properties || {},
      i.attachment,
      i.layout
    );
  }
}
class dr {
  constructor(i, e, r, c, l, h, g, v) {
    this.id = i, this.ref = e, this.title = r, this._type = c, this.properties = l, this.validations = h, this.attachment = g, this.layout = v, this.initProperties(this.properties), this.initValidations(this.validations);
  }
  get description() {
    return this.properties.description;
  }
  set description(i) {
    this.properties.description = i;
  }
  get type() {
    return this._type;
  }
  set type(i) {
    this._type = i, this.initProperties(), this.initValidations();
  }
  initProperties(i = {}) {
    const e = {
      allow_multiple_selection: { types: ["multiple_choice", "picture_choice"], default: !1 },
      allow_other_choice: { types: ["multiple_choice", "picture_choice"], default: !1 },
      alphabetical_order: { types: ["dropdown"], default: !1 },
      button_text: { types: ["group", "payment", "statement"], default: "" },
      choices: { types: ["ranking", "dropdown", "multiple_choice", "picture_choice"], default: [] },
      currency: { types: ["payment"], default: "EUR" },
      default_country_code: { types: ["phone_number"], default: "nl" },
      description: { default: "" },
      fields: { types: ["group", "matrix"], default: [] },
      hide_marks: { types: ["statement"], default: !1 },
      labels: { types: ["opinion_scale"], default: { left: "", center: "", right: "" } },
      price: { types: ["payment"], default: { type: "variable", value: "price" } },
      randomize: { types: ["multiple_choice", "picture_choice", "dropdown"], default: !1 },
      separator: { types: ["date"], default: "-" },
      shape: { types: ["rating"], default: "star" },
      show_button: { types: ["group", "payment"], default: !1 },
      show_labels: { types: ["picture_choice"], default: !1 },
      start_at_one: { types: ["opinion_scale"], default: !1 },
      steps: { types: ["opinion_scale", "rating"], default: 10 },
      structure: { types: ["date"], default: "DDMMYYYY" }
    };
    for (const r of Object.keys(e)) {
      const c = e[r], l = "types" in c ? c.types : [];
      if (l.length > 0 && !l.includes(this.type))
        continue;
      const h = r in this.properties ? this.properties[r] : null, g = "default" in c ? c.default : null;
      i[r] = h ?? g;
    }
    this.properties = i;
  }
  initValidations(i = {}) {
    const e = {
      max_length: { types: ["long_text", "short_text"] },
      max_selection: { types: ["multiple_choice", "picture_choice"] },
      max_value: { types: ["number"] },
      min_selection: { types: ["multiple_choice", "picture_choice"] },
      min_value: { types: ["number"] },
      required: { types: ["matrix", "ranking", "date", "dropdown", "email", "file_upload", "legal", "long_text", "multiple_choice", "number", "opinion_scale", "payment", "picture_choice", "rating", "short_text", "website", "phone_number", "yes_no"], default: !1 }
    };
    for (const r of Object.keys(e)) {
      const c = e[r], l = "types" in c ? c.types : [];
      if (l.length > 0 && !l.includes(this.type))
        continue;
      const h = r in this.validations ? this.validations[r] : null, g = "default" in c ? c.default : null;
      i[r] = h ?? g;
    }
    this.validations = i;
  }
  getAllowedReferenceOptions(i, e, r = !1) {
    const c = [];
    i.hidden.forEach((h) => {
      c.push({
        label: h,
        value: e("hidden", h)
      });
    });
    const l = i.fields.findIndex((h) => h.ref === this.ref);
    return i.fields.forEach((h, g) => {
      if (l !== -1 && g > l)
        return;
      l !== -1 && g === l && !r || ui.getFieldOps(h).length === 0 || c.push({
        label: h.title.replaceAll(Ua, "_"),
        value: e("field", h.ref)
      });
    }), c;
  }
  getAllowedReferences(i, e, r = !1) {
    return this.getAllowedReferenceOptions(i, e, r).map((c) => c.value);
  }
  toRequestData() {
    const i = {
      id: this.id,
      ref: this.ref,
      title: this.title,
      type: this.type,
      properties: this.properties,
      validations: this.validations
    };
    return this.attachment && (i.attachment = this.attachment), this.layout && (i.layout = this.layout), i;
  }
  static fromData(i) {
    return i === null || typeof i == "string" || i instanceof dr ? i : new dr(
      i.id,
      i.ref,
      i.title || "",
      i.type,
      i.properties || {},
      i.validations || {},
      i.attachment,
      i.layout
    );
  }
}
class xs {
  constructor(i, e, r, c) {
    this.id = i, this.action = e, this.details = r, this.condition = c;
  }
  get flattenedConditions() {
    return this.flattenCondition(this.condition);
  }
  set flattenedConditions(i) {
    let e = null;
    const r = W.cloneDeep(i);
    for (; r.length > 0; ) {
      const c = r.shift();
      if (c)
        if (e === null)
          e = c.toCondition();
        else if (c.flattenedOp === e.op)
          e.vars.push(c.toCondition());
        else if (c.flattenedOp === "and" && e.op === "or") {
          const l = e.vars[e.vars.length - 1];
          l.op === "and" ? l.vars.push(c.toCondition()) : e.vars[e.vars.length - 1] = {
            op: c.flattenedOp,
            vars: [
              l,
              c.toCondition()
            ]
          };
        } else
          e = {
            op: c.flattenedOp,
            vars: [
              e,
              c.toCondition()
            ]
          };
    }
    this.condition = e;
  }
  flattenCondition(i, e = null) {
    let r = [];
    return i.op === "and" || i.op === "or" ? i.vars.forEach((c) => {
      const l = this.flattenCondition(c, i.op);
      l[0].flattenedOp = i.op, r = [].concat(r, l);
    }) : r.push(ui.fromCondition(i, e)), r;
  }
  get alwaysCondition() {
    return this.flattenedConditions.find((i) => i.op === "always") || null;
  }
  toRequestData() {
    return {
      action: this.action,
      details: this.details,
      condition: this.condition
    };
  }
  static fromData(i) {
    return i === null || typeof i == "string" || i instanceof xs ? i : new xs(
      i.id || ln(),
      i.action,
      i.details,
      si.fromData(i.condition)
    );
  }
}
class yr {
  constructor(i, e, r) {
    this.type = i, this.ref = e, this.actions = r;
  }
  get alwaysAction() {
    return this.actions.find((i) => i.alwaysCondition) || null;
  }
  toRequestData() {
    const i = {
      type: this.type,
      actions: this.actions.map((e) => e.toRequestData())
    };
    return this.ref && (i.ref = this.ref), i;
  }
  static fromData(i) {
    return i === null || typeof i == "string" || i instanceof yr ? i : new yr(
      i.type,
      i.ref,
      Object.values(i.actions || {}).map((e) => xs.fromData(e))
    );
  }
}
class Is extends M {
  constructor(e, r, c, l, h, g, v, A, D, I, S, N, R, O, $) {
    super(e);
    w(this, "collectionName", Lt.collectionName);
    this.id = e, this.type = r, this.title = c, this.workspace = l, this.theme = h, this.settings = g, this.cui_settings = v, this.hidden = A, this.variables = D, this.welcome_screens = I, this.thankyou_screens = S, this.fields = N, this.logic = R, this.created_at = O, this.last_updated_at = $;
  }
  getOrCreateLogicForField(e) {
    let r = this.getLogicForField(e);
    return r || (r = this.createLogicForField(e)), r;
  }
  getLogicForField(e) {
    return e instanceof dr ? this.logic.find((r) => r.type === "field" && r.ref === e.ref) || null : e instanceof gr && this.logic.find((r) => r.type === "hidden") || null;
  }
  createLogicForField(e) {
    return e instanceof dr ? yr.fromData({
      type: "field",
      ref: e.ref
    }) : e instanceof gr ? yr.fromData({
      type: "hidden"
    }) : null;
  }
  get hasUnsupportedFeatures() {
    for (const e of this.fields)
      if (["group", "matrix"].includes(e.type))
        return !0;
    if (Object.keys(this.variables).length > 0)
      return !0;
    for (const e of this.logic)
      for (const r of e.actions) {
        if (!["jump"].includes(r.action))
          return !0;
        for (const l of r.flattenedConditions)
          for (const h of l.vars)
            if (["variable"].includes(h.type))
              return !0;
      }
    return !1;
  }
  toRequestData() {
    return {
      id: this.id,
      type: this.type,
      title: this.title,
      workspace: this.workspace,
      theme: this.theme,
      settings: this.settings,
      cui_settings: this.cui_settings,
      hidden: this.hidden,
      variables: this.variables,
      welcome_screens: this.welcome_screens.map((e) => e.toRequestData()),
      thankyou_screens: this.thankyou_screens.map((e) => e.toRequestData()),
      fields: this.fields.map((e) => e.toRequestData()),
      logic: this.logic
    };
  }
  static fromData(e) {
    return e === null || typeof e == "string" || e instanceof Is ? e : new Is(
      e.id,
      e.type,
      e.title,
      Cs.fromData(e.workspace || null),
      Ts.fromData(e.theme || null),
      e.settings || {},
      e.cui_settings || {},
      e.hidden || [],
      e.variables || {},
      Object.values(e.welcome_screens || {}).map((r) => gr.fromData(r)),
      Object.values(e.thankyou_screens || {}).map((r) => Es.fromData(r)),
      Object.values(e.fields || {}).map((r) => dr.fromData(r)),
      Object.values(e.logic || {}).map((r) => yr.fromData(r)),
      e.created_at,
      e.last_updated_at
    );
  }
}
const Ua = new RegExp("({{\\s*(hidden|field):(.*?)\\s*}})", "g");
class qv extends V {
  constructor() {
    super(...arguments);
    w(this, "collectionName", "service/typeform/forms");
    w(this, "parseData", Is.fromData);
  }
  async get(e, r = !1) {
    if (!r && this.cache.has(e))
      return this.cache.get(e);
    const c = await this.client.get(`${this.basePath}/${this.collectionName}/${e}`, {
      headers: {
        Accept: "application/json"
      }
    }), l = this.parseData(c.data);
    return this.cache.set(e, l), this.cache.get(e);
  }
  async getAll(e = {}) {
    return (await this.client.get(`${this.basePath}/${this.collectionName}`, {
      params: e,
      headers: {
        Accept: "application/json"
      }
    })).data.items.map((l) => this.parseData(l));
  }
  async getPaged(e) {
    const r = await this.client.get(`${this.basePath}/${this.collectionName}`, {
      params: e,
      headers: {
        Accept: "application/json"
      }
    }), c = r.data.total_items, l = r.data.page_count;
    return {
      collection: r.data.items.map((g) => this.parseData(g)),
      totalItems: c,
      totalPages: l
    };
  }
  async update(e, r) {
    return await this.client.put(`${this.basePath}/${this.collectionName}/${e}`, r.toRequestData(), {
      headers: {
        Accept: "application/json"
      }
    }), await this.wait(), await this.get(e, !0);
  }
}
class Rs extends M {
  constructor(e, r, c, l, h) {
    super("");
    w(this, "collectionName", Lt.collectionName);
    this.key = e, this.type = r, this.text = c, this.number = l, this.value = h;
  }
  toRequestData() {
    return {
      key: this.key,
      type: this.type,
      text: this.text,
      number: this.number,
      value: this.value
    };
  }
  static fromData(e) {
    return e === null || typeof e == "string" || e instanceof Rs ? e : new Rs(
      e.key,
      e.type,
      e.text,
      e.number,
      e.value
    );
  }
}
class Ps extends M {
  constructor(e, r) {
    super("");
    w(this, "collectionName", Lt.collectionName);
    this.choiceId = e, this.choiceLabel = r;
  }
  toRequestData() {
    return {
      choiceId: this.choiceId,
      choiceLabel: this.choiceLabel
    };
  }
  static fromData(e) {
    return e === null || typeof e == "string" || e instanceof Ps ? e : new Ps(
      e.choiceId,
      e.choiceLabel
    );
  }
}
class Ns extends M {
  constructor(e, r, c, l, h, g, v) {
    super("");
    w(this, "collectionName", Lt.collectionName);
    this.fieldId = e, this.fieldTitle = r, this.fieldType = c, this.fieldRef = l, this.choices = h, this.allowMultipleSelections = g, this.allowOtherChoice = v;
  }
  toRequestData() {
    return {
      fieldId: this.fieldId,
      fieldTitle: this.fieldTitle,
      fieldType: this.fieldType,
      fieldRef: this.fieldRef,
      choices: this.choices.map((e) => e.toRequestData()),
      allowMultipleSelections: this.allowMultipleSelections,
      allowOtherChoice: this.allowOtherChoice
    };
  }
  static fromData(e) {
    return e === null || typeof e == "string" || e instanceof Ns ? e : new Ns(
      e.fieldId,
      e.fieldTitle,
      e.fieldType,
      e.fieldRef,
      Object.values(e.choices || {}).map((r) => Ps.fromData(r)),
      e.allowMultipleSelections,
      e.allowOtherChoice
    );
  }
}
class Ss extends M {
  constructor(e, r, c) {
    super("");
    w(this, "collectionName", Lt.collectionName);
    this.formId = e, this.formTitle = r, this.fields = c;
  }
  toRequestData() {
    return {
      formId: this.formId,
      formTitle: this.formTitle,
      fields: this.fields.map((e) => e.toRequestData())
    };
  }
  static fromData(e) {
    return e === null || typeof e == "string" || e instanceof Ss ? e : new Ss(
      e.formId,
      e.formTitle,
      Object.values(e.fields || {}).map((r) => Ns.fromData(r))
    );
  }
}
class Os extends M {
  constructor(e) {
    super("");
    w(this, "collectionName", Lt.collectionName);
    this.label = e;
  }
  toRequestData() {
    return {
      label: this.label
    };
  }
  static fromData(e) {
    return e === null || typeof e == "string" || e instanceof Os ? e : new Os(
      e.label
    );
  }
}
class ks extends M {
  constructor(e, r, c, l, h, g, v, A, D, I, S, N, R) {
    super("");
    w(this, "collectionName", Lt.collectionName);
    this.type = e, this.choices = r, this.fieldId = c, this.fieldType = l, this.text = h, this.number = g, this.date = v, this.choicesOther = A, this.boolean = D, this.email = I, this.url = S, this.fileUrl = N, this.fieldRef = R;
  }
  get isFieldTypeText() {
    return [
      "short_text",
      "long_text",
      "dropdown"
    ].includes(this.fieldType);
  }
  get isFieldTypeChoice() {
    return [
      "multiple_choice",
      "picture_choice"
    ].includes(this.fieldType);
  }
  get isFieldTypeEmail() {
    return [
      "email"
    ].includes(this.fieldType);
  }
  get isFieldTypeUrl() {
    return [
      "website",
      "file_upload"
    ].includes(this.fieldType);
  }
  get isFieldTypeBoolean() {
    return [
      "legal",
      "yes_no"
    ].includes(this.fieldType);
  }
  get isFieldTypeNumber() {
    return [
      "rating",
      "opinion_scale",
      "number"
    ].includes(this.fieldType);
  }
  get isFieldTypeDate() {
    return [
      "date"
    ].includes(this.fieldType);
  }
  toRequestData() {
    return {
      type: this.type,
      choices: this.choices.map((e) => e.toRequestData()),
      fieldId: this.fieldId,
      fieldType: this.fieldType,
      text: this.text,
      number: this.number,
      date: this.date,
      choicesOther: this.choicesOther,
      boolean: this.boolean,
      email: this.email,
      url: this.url,
      fileUrl: this.fileUrl,
      fieldRef: this.fieldRef
    };
  }
  static fromData(e) {
    return e === null || typeof e == "string" || e instanceof ks ? e : new ks(
      e.type,
      Object.values(e.choices || {}).map((r) => Os.fromData(r)),
      e.fieldId,
      e.fieldType,
      e.text,
      e.number,
      e.date,
      e.choicesOther,
      e.boolean,
      e.email,
      e.url,
      e.fileUrl,
      e.fieldRef
    );
  }
}
class Bs extends M {
  constructor(e, r, c, l, h, g, v, A, D, I, S, N, R) {
    super(e);
    w(this, "collectionName", Lt.collectionName);
    this.id = e, this.token = r, this.submittedAt = c, this.landedAt = l, this.calculatedScore = h, this.variables = g, this.hidden = v, this.definition = A, this.answers = D, this.agenda = I, this.medewerker = S, this.relatie = N, this.wonenObject = R;
  }
  toRequestData() {
    return {
      id: this.id,
      token: this.token,
      submittedAt: this.submittedAt,
      landedAt: this.landedAt,
      calculatedScore: this.calculatedScore,
      variables: this.variables,
      hidden: this.hidden,
      definition: this.definition,
      answers: this.answers,
      agenda: this.agenda,
      medewerker: this.medewerker,
      relatie: this.relatie,
      wonenObject: this.wonenObject
    };
  }
  static fromData(e) {
    return e === null || typeof e == "string" || e instanceof Bs ? e : new Bs(
      e.id,
      e.token,
      e.submittedAt,
      e.landedAt,
      e.calculatedScore,
      Object.values(e.variables || {}).map((r) => Rs.fromData(r)),
      e.hidden,
      Ss.fromData(e.definition),
      Object.values(e.answers || {}).map((r) => ks.fromData(r)),
      e.agenda || null,
      e.medewerker || null,
      e.relatie || null,
      e.wonenObject || null
    );
  }
}
class Wv extends V {
  constructor() {
    super(...arguments);
    w(this, "collectionName", "service/typeform/responses");
    w(this, "parseData", Bs.fromData);
  }
  async get(e, r = !1) {
    if (!r && this.cache.has(e))
      return this.cache.get(e);
    const c = await this.client.get(`${this.basePath}/${this.collectionName}/${e}`, {
      headers: {
        Accept: "application/json"
      }
    }), l = this.parseData(c.data);
    return this.cache.set(e, l), this.cache.get(e);
  }
}
class Hv extends V {
  constructor() {
    super(...arguments);
    w(this, "collectionName", "customer_portal_brandings");
    w(this, "parseData", Xn.fromData);
  }
  async update(e, r) {
    const c = new FormData();
    return Object.keys(r).forEach((l) => {
      c.append(l, r[l]);
    }), await this.client.post(`${this.basePath}/${this.collectionName}/${e}`, c, {
      headers: {
        "Content-Type": "multipart/form-data"
      }
    }), await this.wait(), await this.get(e);
  }
}
class Ic extends M {
  constructor(e, r, c) {
    super(e);
    w(this, "collectionName", yf.collectionName);
    this.id = e, this.company = r, this.email = c;
  }
  static fromData(e) {
    return e === null || typeof e == "string" || e instanceof Comment ? e : new Ic(
      e.id,
      U.fromData(e.company),
      e.email
    );
  }
}
class Kv extends V {
  constructor() {
    super(...arguments);
    w(this, "collectionName", "customer_portal_links");
    w(this, "parseData", Ic.fromData);
  }
}
class Ls extends M {
  constructor(e, r, c, l, h = [], g = {}) {
    super(e);
    w(this, "collectionName", Lt.collectionName);
    this.id = e, this.formId = r, this.fieldId = c, this.actionType = l, this.answers = h, this.options = g;
  }
  toRequestData() {
    return {
      id: this.id,
      formId: this.formId,
      fieldId: this.fieldId,
      actionType: this.actionType,
      answers: this.answers,
      options: this.options
    };
  }
  static fromData(e) {
    return e === null || typeof e == "string" || e instanceof Ls ? e : new Ls(
      e.id,
      e.formId,
      e.fieldId,
      e.actionType,
      e.answers,
      e.options
    );
  }
}
class Vv extends V {
  constructor() {
    super(...arguments);
    w(this, "collectionName", "service/typeform/response-answer-hooks");
    w(this, "parseData", Ls.fromData);
  }
}
class Gv extends V {
  constructor() {
    super(...arguments);
    w(this, "collectionName", "pipelines");
    w(this, "parseData", J.fromData);
  }
  async create(e) {
    const r = W.cloneDeep(e);
    return e.company instanceof U && (r.company = e.company.resourceIdentifier), e.fallbackBranch instanceof X && (r.fallbackBranch = e.fallbackBranch.resourceIdentifier), e.branches && (r.branches = e.branches.filter((c) => c instanceof X).map((c) => c.resourceIdentifier)), super.create(r);
  }
  async update(e, r) {
    const c = W.cloneDeep(r);
    return r.company && delete c.company, r.fallbackBranch instanceof X && (c.fallbackBranch = r.fallbackBranch.resourceIdentifier), r.branches && (c.branches = r.branches.filter((l) => l instanceof X).map((l) => l.resourceIdentifier)), super.update(e, c);
  }
  async getOwnPipelines() {
    return this.decodedAccessToken ? (await this.client.get(`${this.basePath}/${this.collectionName}?company=${this.decodedAccessToken.companyId}`)).data["hydra:member"].map((c) => this.parseData({
      ...c,
      company: Yr.currentCompany
    })) : [];
  }
}
class jv extends V {
  constructor() {
    super(...arguments);
    w(this, "collectionName", "pipeline_phases");
    w(this, "parseData", Ve.fromData);
  }
  async create(e) {
    const r = W.cloneDeep(e);
    return e.pipeline instanceof J && (r.pipeline = e.pipeline.resourceIdentifier), super.create(r);
  }
  async update(e, r) {
    const c = W.cloneDeep(r);
    return r.pipeline && delete c.pipeline, super.update(e, c);
  }
}
class zv extends V {
  constructor() {
    super(...arguments);
    w(this, "collectionName", "pipeline_connections");
    w(this, "parseData", vr.fromData);
    w(this, "convertData", (e) => {
      const r = W.cloneDeep(e);
      return e.pipeline instanceof J && (r.pipeline = e.pipeline.resourceIdentifier), e.sourceCompany instanceof U && (r.sourceCompany = e.sourceCompany.resourceIdentifier), e.targetCompany instanceof U && (r.targetCompany = e.targetCompany.resourceIdentifier), r;
    });
  }
  async create(e) {
    return super.create(this.convertData(e));
  }
  async update(e, r) {
    return super.update(e, this.convertData(r));
  }
}
class Ms extends M {
  constructor(e, r, c, l, h, g, v) {
    super(r);
    w(this, "collectionName", vf.collectionName);
    this.company = e, this.id = r, this.status = c, this.statusReasonRequired = l, this.noReasonEnabled = h, this.createdAt = g, this.updatedAt = v;
  }
  static fromData(e) {
    return e === null || typeof e == "string" || e instanceof Ms ? e : new Ms(
      e.company ? U.fromData(e.company) : null,
      e.id,
      e.status,
      e.statusReasonRequired,
      e.noReasonEnabled,
      e.createdAt,
      e.updatedAt
    );
  }
}
class Yv extends V {
  constructor() {
    super(...arguments);
    w(this, "collectionName", "statuses");
    w(this, "parseData", Ms.fromData);
  }
  async create(e) {
    const r = W.cloneDeep(e);
    return e.company instanceof U && (r.company = e.company.resourceIdentifier), super.create(r);
  }
  async update(e, r) {
    const c = W.cloneDeep(r);
    return r.company && delete c.company, super.update(e, c);
  }
}
class Jv extends V {
  constructor() {
    super(...arguments);
    w(this, "collectionName", "status_reasons");
    w(this, "parseData", cn.fromData);
  }
  async create(e) {
    const r = W.cloneDeep(e);
    return e.company instanceof U && (r.company = e.company.resourceIdentifier), e.pipeline instanceof J && (r.pipeline = e.pipeline.resourceIdentifier), e.phases && (r.phases = e.phases.filter((c) => c instanceof Ve).map((c) => c.resourceIdentifier)), super.create(r);
  }
  async update(e, r) {
    const c = W.cloneDeep(r);
    return r.company && delete c.company, r.pipeline instanceof J && (c.pipeline = r.pipeline.resourceIdentifier), r.phases && (c.phases = r.phases.filter((l) => l instanceof Ve).map((l) => l.resourceIdentifier)), super.update(e, c);
  }
}
class Us extends M {
  constructor(e, r, c, l) {
    super(c);
    w(this, "collectionName", Wa.collectionName);
    this.pipeline = e, this.branch = r, this.id = c, this.areaCode = l;
  }
  static fromData(e) {
    return e === null || typeof e == "string" || e instanceof Us ? e : new Us(
      J.fromData(e.pipeline),
      X.fromData(e.branch),
      e.id,
      e.areaCode
    );
  }
}
class Zv extends V {
  constructor() {
    super(...arguments);
    w(this, "collectionName", "branch_operating_zones");
    w(this, "parseData", Us.fromData);
  }
  async create(e) {
    const r = W.cloneDeep(e);
    return e.pipeline instanceof J && (r.pipeline = e.pipeline.resourceIdentifier), e.branch instanceof X && (r.branch = e.branch.resourceIdentifier), super.create(r);
  }
  async update(e, r) {
    const c = W.cloneDeep(r);
    return r.pipeline instanceof J && (c.pipeline = r.pipeline.resourceIdentifier), r.branch instanceof X && (c.branch = r.branch.resourceIdentifier), super.update(e, c);
  }
  handleError(e) {
    throw e;
  }
}
class Fs extends M {
  constructor(e, r, c, l, h, g, v) {
    super(r);
    w(this, "collectionName", Df.collectionName);
    this.company = e, this.id = r, this.pipelineMapping = c, this.phaseMapping = l, this.reasonMapping = h, this.createdAt = g, this.updatedAt = v;
  }
  static fromData(e) {
    return e === null || typeof e == "string" || e instanceof Fs ? e : new Fs(
      e.company ? U.fromData(e.company) : null,
      e.id,
      e.pipelineMapping,
      e.phaseMapping,
      e.reasonMapping,
      e.createdAt,
      e.updatedAt
    );
  }
}
class Xv extends V {
  constructor() {
    super(...arguments);
    w(this, "collectionName", "migration_maps");
    w(this, "parseData", Fs.fromData);
  }
  async create(e) {
    const r = W.cloneDeep(e);
    return e.company instanceof U && (r.company = e.company.resourceIdentifier), super.create(r);
  }
  async startMigration(e) {
    return await this.client.put(`${this.basePath}/${this.collectionName}/${e.id}/start_migration`, e), await this.get(e.id, !0);
  }
}
class Qv extends V {
  constructor() {
    super(...arguments);
    w(this, "collectionName", "sources");
    w(this, "parseData", Xe.fromData);
  }
}
class Rc extends M {
  constructor(i, e, r, c, l, h, g, v, A, D, I, S) {
    super(i), this.id = i, this.source = e, this.straat = r, this.huisnummer = c, this.huisnummertoevoeging = l, this.postcode = h, this.plaats = g, this.land = v, this.bouwjaar = A, this.bouwvorm = D, this.woonhuistype = I, this.actief = S;
  }
  static fromData(i) {
    var r, c, l, h, g, v, A;
    const e = (D) => D ? (D.charAt(0).toUpperCase() + D.slice(1).toLowerCase()).replaceAll("_", " ") : "";
    return new Rc(
      i.wonenObject.id,
      i.source,
      (r = i.wonenObject.adres) == null ? void 0 : r.straat,
      (c = i.wonenObject.adres) == null ? void 0 : c.huisnummer,
      (l = i.wonenObject.adres) == null ? void 0 : l.huisnummertoevoeging,
      (h = i.wonenObject.adres) == null ? void 0 : h.postcode,
      e((g = i.wonenObject.adres) == null ? void 0 : g.plaats),
      i.wonenObject.adres.land,
      i.wonenObject.algemeen.bouwjaar,
      e((v = i.wonenObject.algemeen) == null ? void 0 : v.bouwvorm),
      e((A = i.wonenObject.algemeen) == null ? void 0 : A.woonhuistype),
      i.actief
    );
  }
}
class eb extends Cc {
  async getAgendatypes() {
    return (await this.client.get("/api/v1/service/realworks/agendatypes", {
      headers: {
        Accept: "application/json"
      }
    })).data;
  }
  async getAgendaStatussen() {
    return (await this.client.get("/api/v1/service/realworks/agenda_statussen", {
      headers: {
        Accept: "application/json"
      }
    })).data;
  }
  async getTaaktypes() {
    return (await this.client.get("/api/v1/service/realworks/taaktypes", {
      headers: {
        Accept: "application/json"
      }
    })).data;
  }
  async getRelatietypes() {
    return (await this.client.get("/api/v1/service/realworks/relatietypes", {
      headers: {
        Accept: "application/json"
      }
    })).data;
  }
  async getTaakStatussen() {
    return (await this.client.get("/api/v1/service/realworks/taak_statussen", {
      headers: {
        Accept: "application/json"
      }
    })).data;
  }
  async importMedewerkers(i) {
    await this.client.post("/api/v1/service/realworks/medewerker/import", {
      company: i.id
    }, {
      headers: {
        Accept: "application/json"
      }
    }), await this.wait();
  }
  async getMedewerkersWithUser() {
    const e = (await this.client.get("/api/v1/service/realworks/medewerker/with_user", {
      headers: {
        Accept: "application/json"
      }
    })).data;
    return e.forEach((r) => {
      r.user = F.fromData(r.user);
    }), e;
  }
  async getMedewerkerWithUser(i) {
    const r = (await this.client.get(`/api/v1/service/realworks/medewerker/${i}/with_user`, {
      headers: {
        Accept: "application/json"
      }
    })).data;
    return r.user = F.fromData(r.user), r;
  }
  async createUsersForMedewerkers(i, e) {
    const r = W.cloneDeep(i);
    Object.keys(r).forEach((c) => {
      if (!r[c].role) {
        delete r[c];
        return;
      }
      r[c].branches = r[c].branches.map((l) => l.id);
    }), await this.client.post("/api/v1/service/realworks/medewerker/create_users", {
      mapping: r,
      informUsers: e
    }, {
      headers: {
        Accept: "application/json"
      }
    }), await this.wait();
  }
  async getContactInformation(i) {
    return (await this.client.post("/api/v1/service/realworks/contact_information", {
      contactId: i
    }, {
      headers: {
        Accept: "application/json"
      }
    })).data;
  }
  async searchWonenObjects(i, e) {
    const r = new URLSearchParams([
      ["company", i],
      ["search", e]
    ]), c = await this.client.get("/api/v1/service/realworks/wonen_objecten", { params: r });
    return !c.data || !c.data["hydra:member"] ? [] : c.data["hydra:member"];
  }
  async getRealworksWonenObjecten(i, e = null) {
    const r = e === null ? `/api/v1/service/realworks/wonen_objecten_by_contact_id/${i}` : `/api/v1/service/realworks/wonen_objecten_by_contact_id/${i}?referral_id=${e}`;
    return (await this.client.get(r, {
      headers: {
        Accept: "application/json"
      }
    })).data.map((h) => Rc.fromData(h));
  }
}
class $s extends M {
  constructor(e, r, c, l, h, g) {
    super(e);
    w(this, "collectionName", Tf.collectionName);
    this.id = e, this.referral = r, this.user = c, this.branch = l, this.createdAt = h, this.updatedAt = g;
  }
  static fromData(e) {
    return e === null || typeof e == "string" || e instanceof $s ? e : new $s(
      e.id,
      Qe.fromData(e.referral),
      e.user ? F.fromData(e.user) : null,
      e.branch ? X.fromData(e.branch) : null,
      e.createdAt,
      e.updatedAt
    );
  }
}
class tb extends V {
  constructor() {
    super(...arguments);
    w(this, "collectionName", "referral_permissions");
    w(this, "parseData", $s.fromData);
  }
  async create(e) {
    const r = W.cloneDeep(e);
    return e.referral instanceof Qe && (r.referral = e.referral.resourceIdentifier), e.user instanceof F && (r.user = e.user.resourceIdentifier), e.branch instanceof X && (r.team = e.branch.resourceIdentifier), await this.client.post(`${this.basePath}/${this.collectionName}`, r), await this.wait(), e;
  }
  async delete(e) {
    await this.client.delete(
      `${this.basePath}/${this.collectionName}/${e}`,
      { data: "{}" }
      // expres leeg
    ), await this.wait();
  }
}
class nb extends Cc {
  constructor() {
    super(...arguments);
    w(this, "collectionName", "license");
  }
  async create(e, r) {
    await this.client.post(`${this.basePath}/${this.collectionName}`, {
      companyId: e.id,
      companyName: e.name,
      companyType: e.type,
      note: e.note,
      license: e.license,
      betaOptInAvailable: e.betaOptInAvailable,
      userId: r.id,
      firstname: r.firstname,
      middlename: r.middlename,
      lastname: r.lastname,
      gender: r.gender,
      email: r.email,
      licenseType: e.licenseType,
      modules: e.modules,
      amountOfUsers: e.amountOfUsers,
      amountOfBranches: e.amountOfBranches
    });
  }
  async update(e) {
    await this.client.post(`${this.basePath}/${this.collectionName}/update`, {
      id: e.id,
      name: e.name,
      license: e.license,
      note: e.note,
      betaOptInAvailable: e.betaOptInAvailable,
      licenseType: e.licenseType,
      modules: e.modules,
      amountOfUsers: e.amountOfUsers,
      amountOfBranches: e.amountOfBranches
    });
  }
  handleError(e) {
    throw e;
  }
}
const Fa = new sv(), $a = new ov(), qa = new cv(), Wa = new Zv(), Ha = new uv(), Ka = new lv(), Va = new av(), Ga = new fv(), Yr = new hv(), ja = new pv(), za = new mv(), rb = new gv(), Ya = new dv(), ib = new _v(), Ja = new yv(), Za = new Bv(), Xa = new wv(), qs = new Av(), Qa = new vv(), ef = new bv(), tf = new Dv(), nf = new Cv(), rf = new Tv(), sf = new Ev(), of = new xv(), cf = new Iv(), uf = new Rv(), lf = new Pv(), af = new Lv(), ff = new Nv(), hf = new Sv(), pf = new Ov(), mf = new kv(), gf = new Mv(), sb = new Uv(), ob = new Fv(), cb = new $v(), Lt = new qv(), ub = new Wv(), lb = new Vv(), df = new Hv(), yf = new Kv(), wf = new Gv(), _f = new jv(), Af = new zv(), vf = new Yv(), bf = new Jv(), Df = new Xv(), Cf = new Qv(), ab = new eb(), Tf = new tb(), fb = new nb(), Gb = (o) => {
  [
    Fa,
    $a,
    qa,
    Wa,
    Ha,
    Ka,
    Va,
    Ga,
    Yr,
    ja,
    za,
    rb,
    Ya,
    ib,
    Ja,
    Za,
    Xa,
    qs,
    Qa,
    ef,
    tf,
    nf,
    rf,
    sf,
    of,
    cf,
    uf,
    lf,
    af,
    ff,
    hf,
    pf,
    mf,
    gf,
    sb,
    ob,
    cb,
    Lt,
    ub,
    lb,
    df,
    yf,
    wf,
    _f,
    Af,
    vf,
    bf,
    Df,
    Cf,
    ab,
    Tf,
    fb
  ].forEach((e) => {
    e.configure(o);
  });
};
export {
  Tc as AccelerateCredentials,
  Qn as Action,
  Fa as ActionAPI,
  Gr as ActionAppointmentType,
  BA as ActionAssignToType,
  sn as ActionType,
  ss as ActiveCampaignCredentials,
  ei as Attachment,
  $a as AttachmentAPI,
  XA as BadgeColor,
  Wb as BadgeColorCodes,
  ZA as BadgeType,
  qb as BadgeTypes,
  X as Branch,
  qa as BranchAPI,
  Us as BranchOperatingZone,
  Wa as BranchOperatingZoneAPI,
  as as BranchTarget,
  Ha as BranchTargetAPI,
  jr as BranchType,
  Zr as Branding,
  Ka as BrandingAPI,
  fs as ChecklistSettings,
  Va as ChecklistSettingsAPI,
  Ma as Comment,
  Ga as CommentAPI,
  MA as CommentOrigin,
  UA as CommentVisibility,
  U as Company,
  Yr as CompanyAPI,
  EA as CompanyLicenseType,
  TA as CompanyTargetType,
  CA as CompanyType,
  Ar as Contact,
  ja as ContactAPI,
  LA as ContactView,
  xt as Credentials,
  za as CredentialsAPI,
  Et as CredentialsType,
  Xn as CustomerPortalBranding,
  df as CustomerPortalBrandingAPI,
  Ic as CustomerPortalLink,
  yf as CustomerPortalLinkAPI,
  us as Dashboard,
  cf as DashboardAPI,
  FA as DashboardView,
  OA as DelayUnit,
  _r as EventLog,
  ef as EventLogAPI,
  Xr as GamificationBadge,
  ob as GamificationBadgeAPI,
  Qr as GamificationScore,
  cb as GamificationScoreAPI,
  Zn as GamificationSettings,
  sb as GamificationSettingsAPI,
  jn as Gender,
  fb as LicenseAPI,
  os as MailchimpCredentials,
  rb as MentionAPI,
  Fs as MigrationMap,
  Df as MigrationMapAPI,
  qA as NewBuildType,
  ii as Offer,
  uf as OfferAPI,
  ys as Order,
  lf as OrderAPI,
  bs as OrderCount,
  af as OrderCountAPI,
  PA as OrderStatus,
  RA as OrderType,
  J as Pipeline,
  wf as PipelineAPI,
  Hb as PipelineCategories,
  QA as PipelineCategory,
  vr as PipelineConnection,
  Af as PipelineConnectionAPI,
  Ve as PipelinePhase,
  _f as PipelinePhaseAPI,
  Kb as PipelinePhaseCategories,
  zn as PipelinePhaseCategory,
  ws as PrintableDocument,
  hf as PrintableDocumentAPI,
  _s as PrintedDocument,
  pf as PrintedDocumentAPI,
  ri as Product,
  ff as ProductAPI,
  WA as ProductType,
  Bt as Project,
  Ya as ProjectAPI,
  ab as RealworksAPI,
  Tn as RealworksCredentials,
  ib as RealworksCredentialsAPI,
  xc as RealworksKenmerk,
  rf as RealworksKenmerkAPI,
  As as RealworksStatusRule,
  mf as RealworksStatusRuleAPI,
  Rc as RealworksWonenObject,
  Qe as Referral,
  Ja as ReferralAPI,
  ev as ReferralChannel,
  vs as ReferralCount,
  Za as ReferralCountAPI,
  En as ReferralNode,
  Xa as ReferralNodeAPI,
  NA as ReferralNodeType,
  kA as ReferralOrigin,
  Tf as ReferralPermissionAPI,
  zr as ReferralStatus,
  IA as ReferralStatusReason,
  gc as ReferralType,
  Ke as Role,
  Dn as ScheduledDashboardExport,
  sf as ScheduledDashboardExportAPI,
  $A as ScheduledDashboardExportSchedule,
  gs as Share,
  of as ShareAPI,
  Xe as Source,
  Cf as SourceAPI,
  Ms as Status,
  vf as StatusAPI,
  cn as StatusReason,
  bf as StatusReasonAPI,
  xA as TargetDirection,
  SA as TriggerType,
  ps as TriggeredAction,
  tf as TriggeredActionAPI,
  ms as TriggeredReferral,
  nf as TriggeredReferralAPI,
  cs as TypeformCredentials,
  Lt as TypeformFormAPI,
  ub as TypeformResponseAPI,
  lb as TypeformResponseAnswerHookAPI,
  F as User,
  qs as UserAPI,
  hs as UserTarget,
  Qa as UserTargetAPI,
  Ba as UserType,
  Ds as Webhook,
  gf as WebhookAPI,
  JA as WidgetAvatarStyle,
  KA as WidgetFlowType,
  YA as WidgetFont,
  VA as WidgetGoalType,
  zA as WidgetPopupAnimation,
  jA as WidgetPopupPosition,
  GA as WidgetPopupType,
  HA as WidgetType,
  Tb as allowedReferralStatusReasons,
  Db as allowedReferralStatuses,
  kb as availableActionAppointmentTypes,
  Ob as availableActionAssignToTypes,
  Sb as availableActionTypes,
  Lb as availableCommentVisibilities,
  yb as availableCompanyTargetTypes,
  db as availableCompanyTypes,
  Bb as availableContactViews,
  gb as availableCredentialsTypes,
  Mb as availableDashboardViews,
  Pb as availableDelayUnits,
  La as availableGenders,
  wb as availableLicenseTypes,
  _b as availableModules,
  Fb as availableNewBuildTypes,
  $b as availableProductTypes,
  Vb as availableReferralChannels,
  Ib as availableReferralNodeTypes,
  Nb as availableReferralOrigins,
  Cb as availableReferralStatusReasons,
  bb as availableReferralStatuses,
  vb as availableReferralTypes,
  mb as availableReferralViews,
  pb as availableRoles,
  Ub as availableScheduledDashboardExportSchedules,
  Ab as availableTargetDirections,
  Rb as availableTriggerTypes,
  Gb as configureAPIs,
  mc as createResourceIdentifier,
  xb as orderStatusses,
  Eb as orderTypes
};
//# sourceMappingURL=one-api-client-legacy.js.map
